export const bhajanHtml = `
<div class="thallyrics">
  <div class="mb-4 doha-mistan">
                                    <h3 class="text-textColor font-bold text-xl mt-3">દોહા</h3>
                                    <p>આજ અન્નકૂટ ઉત્સવ છે, ભક્ત આવ્યા અપાર;<span class="space hidden">..૦૧</span></p>
                                    <p> શ્રીહરિને જમાડવાનો, સહુને અતિશય પ્યાર..૦૧</p>
                                    <p>પ્રેમી સંતો-ભક્તોએ, વાનગી કરી અપાર;<span class="space hidden">..૦૨</span></p>
                                    <p> અન્નકૂટ ભર્યો અતિ મોટો, જુગતે જમો કિરતાર..૦૨</p>
                                    <p>અન્નકૂટ ધર્યો આપને, કરી શોભા બહુ પ્રકાર;<span class="space hidden">..૦૩</span></p>
                                    <p> અન્નકૂટ થાળ રચીને, ગાવું કરી અતિ પ્યાર..૦૩</p>
                                    <p>રચનામાં મેં વસ્તુક્રમ, ગોઠવ્યો મુજ રીત;<span class="space hidden">..૦૪</span></p>
                                    <p> જમ્યાની રીતે જમજો, જેમ તમને થાય પ્રીત..૦૪</p>
                                    <p>સહુ આઇટમ શુદ્ધપણે, કરી-કરાવી સાર;<span class="space hidden">..૦૫</span></p>
                                    <p> ભક્તો લાવ્યા ભાવથી, આરોગો અમ પ્યાર..૦૫</p>
                                    <p>ધર્મવિરુદ્ધ શુદ્ધિ હીણ, અખાદ્ય વસ્તુ અસાર;<span class="space hidden">..૦૬</span></p>
                                    <p> બાજારું ખાણી પીણી, નથી લાવ્યા લગાર..૦૬</p>
                                    <h3 class="text-textColor font-bold text-xl mt-3">મિષ્ટાન્ન</h3>
                                    <h4>
                                        <p>વાની અગ્યારસો અગ્યાર, અન્નકૂટ આરોગો;</p>
                                    </h4>
                                    <h4>
                                        <p>ધરી અન્નકૂટમાં આ વાર, અન્નકૂટ આરોગો.</p>
                                    </h4>
                                    </div>
                                    <div class="thallyricsp w-full mt-3 mx-auto max-lg:px-2">
                                    <p>
                                        છે આ થાળ અમારો પ્યાર, અન્ન<sub class="text-[10px]">૦</sub>
                                        <span class="text-12 invisible lg:hidden inline-box">૦૦૦</span>
                                        <br class="lg:hidden"/>
                                        ભાવે જમજો તમે ભરથાર, અન્ન<sub class="text-[10px]">૦</sub>
                                        <span class="text-12 inline-box">૦૦૭</span>
                                    </p>
                                    <p>
                                        <a class="recipe" data-id="R0001" href="?id=R0001" sup-id="">
                                            ચુરમાદિ<sup class="red">૧</sup>
                                        </a>
                                        વિધવિધ લાડુ, અન્ન<sub class="text-[10px]">૦</sub>
                                        <span class="text-12 invisible lg:hidden inline-box">૦૦૦</span>
                                        <br class="lg:hidden"/>
                                        મારે હાથે તમને જમાડું, અન્ન<sub class="text-[10px]">૦</sub>
                                        <span class="text-12 invisible">૦૦૦</span>
                                    </p>
                                    <p>
                                        <a class="recipe" data-id="R0002" href="?id=R0002" sup-id="">
                                            લાડુ પાકના<sup class="red">૨</sup>
                                        </a>
                                        <a class="recipe" data-id="R0003" href="?id=R0003" sup-id="">
                                            લાખણસાઈ<sup class="red">૩</sup>
                                        </a>
                                        , અન્ન<sub class="text-[10px]">૦</sub>
                                        <span class="text-12 invisible lg:hidden inline-box">૦૦૦</span>
                                        <br class="lg:hidden"/>
                                        <a class="recipe" data-id="R0004" href="?id=R0004" sup-id="">
                                            લાડુ પનીરના<sup class="red">૪</sup>
                                        </a>
                                        સુખદાઈ, અન્ન<sub class="text-[10px]">૦</sub>
                                        <span class="text-12 inline-box">૦૦૮</span>
                                    </p>
                                    <p>
                                        <a class="recipe" data-id="R0005" href="?id=R0005" sup-id="">
                                            લાડુ પંચુરીના<sup class="red">૫</sup>
                                        </a>
                                        છે સારા, અન્ન<sub class="text-[10px]">૦</sub>
                                        <span class="text-12 invisible lg:hidden inline-box">૦૦૦</span>
                                        <br class="lg:hidden"/>
                                        <a class="recipe" data-id="R0006" href="?id=R0006" sup-id="">
                                            લાડુ પોંકના<sup class="red">૬</sup>
                                        </a>
                                        જમો પ્યારા, અન્ન<sub class="text-[10px]">૦</sub>
                                        <span class="text-12 invisible">૦૦૦</span>
                                    </p>
                                    <p>
                                        <a class="recipe" data-id="R0007" href="?id=R0007" sup-id="">
                                            લાડુ મગસ<sup class="red">૭</sup>
                                        </a>
                                        <a class="recipe" data-id="R0008" href="?id=R0008" sup-id="">
                                            લાડુ મોતૈયા<sup class="red">૮</sup>
                                        </a>
                                        , અન્ન<sub class="text-[10px]">૦</sub>
                                        <span class="text-12 invisible lg:hidden inline-box">૦૦૦</span>
                                        <br class="lg:hidden"/>
                                        <a class="recipe" data-id="R0009" href="?id=R0009" sup-id="">
                                            લાડુ મોતીચુર<sup class="red">૯</sup>
                                        </a>
                                        સુખદૈયા, અન્ન<sub class="text-[10px]">૦</sub>
                                        <span class="text-12 inline-box">૦૦૯</span>
                                    </p>
                                    <p>
                                        <a class="recipe" data-id="R0010" href="?id=R0010" sup-id="">
                                            લાડુ ચોખાના<sup class="red">૧૦</sup>
                                        </a>
                                        <a class="recipe" data-id="R0011" href="?id=R0011" sup-id="">
                                            રાગીના<sup class="red">૧૧</sup>
                                        </a>
                                        , અન્ન<sub class="text-[10px]">૦</sub>
                                        <span class="text-12 invisible lg:hidden inline-box">૦૦૦</span>
                                        <br class="lg:hidden"/>
                                        <a class="recipe" data-id="R0012" href="?id=R0012" sup-id="">
                                            મોદક<sup class="red">૧૨</sup>
                                        </a>
                                        ને 
                                        <a class="recipe" data-id="R0013" href="?id=R0013" sup-id="">
                                            લાડુ બાજરીના<sup class="red">૧૩</sup>
                                        </a>
                                        , અન્ન<sub class="text-[10px]">૦</sub>
                                        <span class="text-12 invisible">૦૦૦</span>
                                    </p>
                                    <p>
                                        <a class="recipe" data-id="R0014" href="?id=R0014" sup-id="">
                                            લાડુ શીંગના<sup class="red">૧૪</sup>
                                        </a>
                                        ને 
                                        <a class="recipe" data-id="R0015" href="?id=R0015" sup-id="">
                                            દાળિયાના<sup class="red">૧૫</sup>
                                        </a>
                                        , અન્ન<sub class="text-[10px]">૦</sub>
                                        <span class="text-12 invisible lg:hidden inline-box">૦૦૦</span>
                                        <br class="lg:hidden"/>
                                        લાડુ સારા બન્યા 
                                        <a class="recipe" data-id="R0016" href="?id=R0016" sup-id="">
                                            મમરાના<sup class="red">૧૬</sup>
                                        </a>
                                        , અન્ન<sub class="text-[10px]">૦</sub>
                                        <span class="text-12 inline-box">૦૧૦</span>
                                    </p>
                                    <p>
                                        <a class="recipe" data-id="R0017" href="?id=R0017" sup-id="">
                                            ચોકલેટબોલ<sup class="red">૧૭</sup>
                                        </a>
                                        <a class="recipe" data-id="R0018" href="?id=R0018" sup-id="">
                                            લાડુ સાથવાના<sup class="red">૧૮</sup>
                                        </a>
                                        અન્ન<sub class="text-[10px]">૦</sub>
                                        <span class="text-12 invisible lg:hidden inline-box">૦૦૦</span>
                                        <br class="lg:hidden"/>
                                        <a class="recipe" data-id="R0019" href="?id=R0019" sup-id="">
                                            લાડુ મગદાળના<sup class="red">૧૯</sup>
                                        </a>
                                        ને 
                                        <a class="recipe" data-id="R0020" href="?id=R0020" sup-id="R0020">
                                            રવાના<sup class="red">૨૦</sup>
                                        </a>
                                        , અન્ન<sub class="text-[10px]">૦</sub>
                                        <span class="text-12 invisible">૦૦૦</span>
                                    </p>
                                    <p>
                                        <a class="recipe" data-id="R0021" href="?id=R0021" sup-id="">
                                            જાદરિયું<sup class="red">૨૧</sup>
                                        </a>
                                        <a class="recipe" data-id="R0022" href="?id=R0022" sup-id="">
                                            ટોપરાપાક<sup class="red">૨૨</sup>
                                        </a>
                                        , અન્ન<sub class="text-[10px]">૦</sub>
                                        <span class="text-12 invisible lg:hidden inline-box">૦૦૦</span>
                                        <br class="lg:hidden"/>
                                        <a class="recipe" data-id="R0023" href="?id=R0023" sup-id="">
                                            પેંડા દાળિયાના<sup class="red">૨૩</sup>
                                        </a>
                                        <a class="recipe" data-id="R0024" href="?id=R0024" sup-id="">
                                            ગુંદરપાક<sup class="red">૨૪</sup>
                                        </a>
                                        , અન્ન<sub class="text-[10px]">૦</sub>
                                        <span class="text-12 inline-box">૦૧૧</span>
                                    </p>
                                    <p>
                                        <a class="recipe" data-id="R0025" href="?id=R0025" sup-id="">
                                            ગુલાબપાક<sup class="red">૨૫</sup>
                                        </a>
                                        <a class="recipe" data-id="R0026" href="?id=R0026" sup-id="">
                                            મોહનથાળ<sup class="red">૨૬</sup>
                                        </a>
                                        , અન્ન<sub class="text-[10px]">૦</sub>
                                        <span class="text-12 invisible lg:hidden inline-box">૦૦૦</span>
                                        <br class="lg:hidden"/>
                                        <a class="recipe" data-id="R0027" href="?id=R0027" sup-id="">
                                            બરફીચૂરમું<sup class="red">૨૭</sup>
                                        </a>
                                        છે રસાળ, અન્ન<sub class="text-[10px]">૦</sub>
                                        <span class="text-12 invisible">૦૦૦</span>
                                    </p>
                                    <p>
                                        <a class="recipe" data-id="R0028" href="?id=R0028" sup-id="">
                                            મગદળ<sup class="red">૨૮</sup>
                                        </a>
                                        ને 
                                        <a class="recipe" data-id="R0029" href="?id=R0029" sup-id="">
                                            સાલમપાક<sup class="red">૨૯</sup>
                                        </a>
                                        , અન્ન<sub class="text-[10px]">૦</sub>
                                        <span class="text-12 invisible lg:hidden inline-box">૦૦૦</span>
                                        <br class="lg:hidden"/>
                                        જમો 
                                        <a class="recipe" data-id="R0030" href="?id=R0030" sup-id="">
                                            મેસૂબ<sup class="red">૩૦</sup>
                                        </a>
                                        <a class="recipe" data-id="R0031" href="?id=R0031" sup-id="">
                                            મેથીપાક<sup class="red">૩૧</sup>
                                        </a>
                                        , અન્ન<sub class="text-[10px]">૦</sub>
                                        <span class="text-12 inline-box">૦૧૨</span>
                                    </p>
                                    <p>
                                        જમો 
                                        <a class="recipe" data-id="R0032" href="?id=R0032" sup-id="">
                                            સાકર કેરી સુખડી<sup class="red">૩૨</sup>
                                        </a>
                                        , અન્ન<sub class="text-[10px]">૦</sub>
                                        <span class="text-12 invisible lg:hidden inline-box">૦૦૦</span>
                                        <br class="lg:hidden"/>
                                        <a class="recipe" data-id="R0033" href="?id=R0033" sup-id="">
                                            સાદી સુખડી<sup class="red">૩૩</sup>
                                        </a>
                                        <a class="recipe" data-id="R0034" href="?id=R0034" sup-id="">
                                            સોનપાપડી<sup class="red">૩૪</sup>
                                        </a>
                                        , અન્ન<sub class="text-[10px]">૦</sub>
                                        <span class="text-12 invisible">૦૦૦</span>
                                    </p>
                                    <p>
                                        <a class="recipe" data-id="R0035" href="?id=R0035" sup-id="">
                                            આદુપાક<sup class="red">૩૫</sup>
                                        </a>
                                        ને 
                                        <a class="recipe" data-id="R0036" href="?id=R0036" sup-id="">
                                            અમૃતપાક<sup class="red">૩૬</sup>
                                        </a>
                                        , અન્ન<sub class="text-[10px]">૦</sub>
                                        <span class="text-12 invisible lg:hidden inline-box">૦૦૦</span>
                                        <br class="lg:hidden"/>
                                        એ આદિક જમજો પાક, અન્ન<sub class="text-[10px]">૦</sub>
                                        <span class="text-12 inline-box">૦૧૩</span>
                                    </p>
                                    <p>
                                        <a class="recipe" data-id="R0037" href="?id=R0037" sup-id="">
                                            હરીસો<sup class="red">૩૭</sup>
                                        </a>
                                        <a class="recipe" data-id="R0038" href="?id=R0038" sup-id="">
                                            સેવઈ<sup class="red">૩૮</sup>
                                        </a>
                                        ને 
                                        <a class="recipe" data-id="R0039" href="?id=R0039" sup-id="">
                                            ઠોર<sup class="red">૩૯</sup>
                                        </a>
                                        , અન્ન<sub class="text-[10px]">૦</sub>
                                        <span class="text-12 invisible lg:hidden inline-box">૦૦૦</span>
                                        <br class="lg:hidden"/>
                                        <a class="recipe" data-id="R0040" href="?id=R0040" sup-id="">
                                            પેઠા<sup class="red">૪૦</sup>
                                        </a>
                                        <a class="recipe" data-id="R0041" href="?id=R0041" sup-id="">
                                            બિરંજ<sup class="red">૪૧</sup>
                                        </a>
                                        છે ચિત્તચોર, અન્ન<sub class="text-[10px]">૦</sub>
                                        <span class="text-12 invisible">૦૦૦</span>
                                    </p>
                                    <p>
                                        <a class="recipe" data-id="R0042" href="?id=R0042" sup-id="">
                                            ઘેબર<sup class="red">૪૨</sup>
                                        </a>
                                        <a class="recipe" data-id="R0043" href="?id=R0043" sup-id="">
                                            અડદિયો<sup class="red">૪૩</sup>
                                        </a>
                                        ને 
                                        <a class="recipe" data-id="R0044" href="?id=R0044" sup-id="">
                                            ઘારી<sup class="red">૪૪</sup>
                                        </a>
                                        , અન્ન<sub class="text-[10px]">૦</sub>
                                        <span class="text-12 invisible lg:hidden inline-box">૦૦૦</span>
                                        <br class="lg:hidden"/>
                                        જમો 
                                        <a class="recipe" data-id="R0045" href="?id=R0045" sup-id="">
                                            ઘસિયો<sup class="red">૪૫</sup>
                                        </a>
                                        <a class="recipe" data-id="R0046" href="?id=R0046" sup-id="">
                                            કુલેર<sup class="red">૪૬</sup>
                                        </a>
                                        પ્યારી, અન્ન<sub class="text-[10px]">૦</sub>
                                        <span class="text-12 inline-box">૦૧૪</span>
                                    </p>
                                    <p>
                                        <a class="recipe" data-id="R0047" href="?id=R0047" sup-id="">
                                            ગગનગાંઠિયા<sup class="red">૪૭</sup>
                                        </a>
                                        <a class="recipe" data-id="R0048" href="?id=R0048" sup-id="">
                                            ફાડાલાપસી<sup class="red">૪૮</sup>
                                        </a>
                                        , અન્ન<sub class="text-[10px]">૦</sub>
                                        <span class="text-12 invisible lg:hidden inline-box">૦૦૦</span>
                                        <br class="lg:hidden"/>
                                        પ્યારા છે 
                                        <a class="recipe" data-id="R0049" href="?id=R0049" sup-id="R0049">
                                            ઘૂઘરા<sup class="red">૪૯</sup>
                                        </a>
                                        <a class="recipe" data-id="R0050" href="?id=R0050" sup-id="">
                                            લાપસી<sup class="red">૫૦</sup>
                                        </a>
                                        , અન્ન<sub class="text-[10px]">૦</sub>
                                        <span class="text-12 invisible">૦૦૦</span>
                                    </p>
                                    <p>
                                        <a class="recipe" data-id="R0051" href="?id=R0051" sup-id="">
                                            સેવ બિરંજ<sup class="red">૫૧</sup>
                                        </a>
                                        <a class="recipe" data-id="R0052" href="?id=R0052" sup-id="">
                                            બોમ્બે હલવો<sup class="red">૫૨</sup>
                                        </a>
                                        , અન્ન<sub class="text-[10px]">૦</sub>
                                        <span class="text-12 invisible lg:hidden inline-box">૦૦૦</span>
                                        <br class="lg:hidden"/>
                                        વળી 
                                        <a class="recipe" data-id="R0053" href="?id=R0053" sup-id="">
                                            બોમ્બે આઇસ હલવો<sup class="red">૫૩</sup>
                                        </a>
                                        , અન્ન<sub class="text-[10px]">૦</sub>
                                        <span class="text-12 inline-box">૦૧૫</span>
                                    </p>
                                    <p>
                                        <a class="recipe" data-id="R0054" href="?id=R0054" sup-id="R0054">
                                            ઘઉં<sup class="red">૫૪</sup>
                                        </a>
                                        તથા 
                                        <a class="recipe" data-id="R0055" href="?id=R0055" sup-id="R0055">
                                            રવાના<sup class="red">૫૫</sup>
                                        </a>
                                        શીરા, અન્ન<sub class="text-[10px]">૦</sub>
                                        <span class="text-12 invisible lg:hidden inline-box">૦૦૦</span>
                                        <br class="lg:hidden"/>
                                        વળી 
                                        <a class="recipe" data-id="R0056" href="?id=R0056" sup-id="R0056">
                                            મગ<sup class="red">૫૬</sup>
                                        </a>
                                        આદિકના શીરા, અન્ન<sub class="text-[10px]">૦</sub>
                                        <span class="text-12 invisible">૦૦૦</span>
                                    </p>
                                    <p>
                                        <a class="recipe" data-id="R0057" href="?id=R0057" sup-id="">
                                            સૂતરફેણી<sup class="red">૫૭</sup>
                                        </a>
                                        <a class="recipe" data-id="R0058" href="?id=R0058" sup-id="">
                                            સાટા<sup class="red">૫૮</sup>
                                        </a>
                                        સારા, અન્ન<sub class="text-[10px]">૦</sub>
                                        <span class="text-12 invisible lg:hidden inline-box">૦૦૦</span>
                                        <br class="lg:hidden"/>
                                        <a class="recipe" data-id="R0059" href="?id=R0059" sup-id="">
                                            હલવાસન<sup class="red">૫૯</sup>
                                        </a>
                                        <a class="recipe" data-id="R0060" href="?id=R0060" sup-id="">
                                            કંસાર<sup class="red">૬૦</sup>
                                        </a>
                                        પ્યારા, અન્ન<sub class="text-[10px]">૦</sub>
                                        <span class="text-12 inline-box">૦૧૬</span>
                                    </p>
                                    <p>
                                        <a class="recipe" data-id="R0061" href="?id=R0061" sup-id="">
                                            ખાજા<sup class="red">૬૧</sup>
                                        </a>
                                        <a class="recipe" data-id="R0062" href="?id=R0062" sup-id="">
                                            બુંદી<sup class="red">૬૨</sup>
                                        </a>
                                        <a class="recipe" data-id="R0063" href="?id=R0063" sup-id="">
                                            કાલાજામ<sup class="red">૬૩</sup>
                                        </a>
                                        , અન્ન<sub class="text-[10px]">૦</sub>
                                        <span class="text-12 invisible lg:hidden inline-box">૦૦૦</span>
                                        <br class="lg:hidden"/>
                                        જમો 
                                        <a class="recipe" data-id="R0064" href="?id=R0064" sup-id="">
                                            ગુલાબજાંબુ<sup class="red">૬૪</sup>
                                        </a>
                                        શ્યામ, અન્ન<sub class="text-[10px]">૦</sub>
                                        <span class="text-12 invisible">૦૦૦</span>
                                    </p>
                                    <p>
                                        <a class="recipe" data-id="R0065" href="?id=R0065" sup-id="">
                                            દૂધપાક<sup class="red">૬૫</sup>
                                        </a>
                                        ને 
                                        <a class="recipe" data-id="R0066" href="?id=R0066" sup-id="">
                                            માલપૂડા<sup class="red">૬૬</sup>
                                        </a>
                                        , અન્ન<sub class="text-[10px]">૦</sub>
                                        <span class="text-12 invisible lg:hidden inline-box">૦૦૦</span>
                                        <br class="lg:hidden"/>
                                        <a class="recipe" data-id="R0067" href="?id=R0067" sup-id="">
                                            જલેબી<sup class="red">૬૭</sup>
                                        </a>
                                        <a class="recipe" data-id="R0068" href="?id=R0068" sup-id="">
                                            રસગુલ્લા<sup class="red">૬૮</sup>
                                        </a>
                                        રૂડા, અન્ન<sub class="text-[10px]">૦</sub>
                                        <span class="text-12 inline-box">૦૧૭</span>
                                    </p>
                                    <p>
                                        <a class="recipe" data-id="R0069" href="?id=R0069" sup-id="">
                                            ઇમરતી<sup class="red">૬૯</sup>
                                        </a>
                                        ને 
                                        <a class="recipe" data-id="R0070" href="?id=R0070" sup-id="">
                                            કમલભોગ<sup class="red">૭૦</sup>
                                        </a>
                                        , અન્ન<sub class="text-[10px]">૦</sub>
                                        <span class="text-12 invisible lg:hidden inline-box">૦૦૦</span>
                                        <br class="lg:hidden"/>
                                        <a class="recipe" data-id="R0071" href="?id=R0071" sup-id="">
                                            ચોકલેટ પેંડા<sup class="red">૭૧</sup>
                                        </a>
                                        કરો ભોગ, અન્ન<sub class="text-[10px]">૦</sub>
                                        <span class="text-12 invisible">૦૦૦</span>
                                    </p>
                                    <p>
                                        <a class="recipe" data-id="R0072" href="?id=R0072" sup-id="">
                                            બાલુશાહી<sup class="red">૭૨</sup>
                                        </a>
                                        <a class="recipe" data-id="R0073" href="?id=R0073" sup-id="">
                                            ચોકો ફીરની<sup class="red">૭૩</sup>
                                        </a>
                                        , અન્ન<sub class="text-[10px]">૦</sub>
                                        <span class="text-12 invisible lg:hidden inline-box">૦૦૦</span>
                                        <br class="lg:hidden"/>
                                        જમો 
                                        <a class="recipe" data-id="R0074" href="?id=R0074" sup-id="">
                                            કેસર-પિસ્તા ફીરની<sup class="red">૭૪</sup>
                                        </a>
                                        , અન્ન<sub class="text-[10px]">૦</sub>
                                        <span class="text-12 inline-box">૦૧૮</span>
                                    </p>
                                    <p>
                                        <a class="recipe" data-id="R0075" href="?id=R0075" sup-id="">
                                            દૂધપાક બુંદીનો<sup class="red">૭૫</sup>
                                        </a>
                                        જમો, અન્ન<sub class="text-[10px]">૦</sub>
                                        <span class="text-12 invisible lg:hidden inline-box">૦૦૦</span>
                                        <br class="lg:hidden"/>
                                        <a class="recipe" data-id="R0076" href="?id=R0076" sup-id="">
                                            દૂધપૌંઆ<sup class="red">૭૬</sup>
                                        </a>
                                        ને 
                                        <a class="recipe" data-id="R0077" href="?id=R0077" sup-id="R0077">
                                            ખીર<sup class="red">૭૭</sup>
                                        </a>
                                        જમો, અન્ન<sub class="text-[10px]">૦</sub>
                                        <span class="text-12 invisible">૦૦૦</span>
                                    </p>
                                    <p>
                                        <a class="recipe" data-id="R0078" href="?id=R0078" sup-id="">
                                            ચણાદાળની પૂરણપોળી<sup class="red">૭૮</sup>
                                        </a>
                                        , અન્ન<sub class="text-[10px]">૦</sub>
                                        <span class="text-12 invisible lg:hidden inline-box">૦૦૦</span>
                                        <br class="lg:hidden"/>
                                        <a class="recipe" data-id="R0079" href="?id=R0079" sup-id="R0079">
                                            ખજૂરની<sup class="red">૭૯</sup>
                                        </a>
                                        ઘીમાં ઝબોળી, અન્ન<sub class="text-[10px]">૦</sub>
                                        <span class="text-12 inline-box">૦૧૯</span>
                                    </p>
                                    <p>
                                        <a class="recipe" data-id="R0080" href="?id=R0080" sup-id="">
                                            તુવેરદાળની છે પોળી<sup class="red">૮૦</sup>
                                        </a>
                                        , અન્ન<sub class="text-[10px]">૦</sub>
                                        <span class="text-12 invisible lg:hidden inline-box">૦૦૦</span>
                                        <br class="lg:hidden"/>
                                        <a class="recipe" data-id="R0081" href="?id=R0081" sup-id="">
                                            સંજોરી<sup class="red">૮૧</sup>
                                        </a>
                                        <a class="recipe" data-id="R0082" href="?id=R0082" sup-id="">
                                            અંજીરાદિ<sup class="red">૮૨</sup>
                                        </a>
                                        પોળી, અન્ન<sub class="text-[10px]">૦</sub>
                                        <span class="text-12 invisible">૦૦૦</span>
                                    </p>
                                    <p>
                                        <a class="recipe" data-id="R0083" href="?id=R0083" sup-id="">
                                            ચીકી દાળિયાની<sup class="red">૮૩</sup>
                                        </a>
                                        છે પ્યારી, અન્ન<sub class="text-[10px]">૦</sub>
                                        <span class="text-12 invisible lg:hidden inline-box">૦૦૦</span>
                                        <br class="lg:hidden"/>
                                        <a class="recipe" data-id="R0084" href="?id=R0084" sup-id="">
                                            બરફી ચોકલેટની<sup class="red">૮૪</sup>
                                        </a>
                                        છે ન્યારી, અન્ન<sub class="text-[10px]">૦</sub>
                                        <span class="text-12 inline-box">૦૨૦</span>
                                    </p>
                                    <h3>ફરાળી વાનગી</h3>
                                    <p>
                                        જમો વાનગી આ ફરાળી, અન્ન<sub class="text-[10px]">૦</sub>
                                        <span class="text-12 invisible lg:hidden inline-box">૦૦૦</span>
                                        <br class="lg:hidden"/>
                                        <a class="recipe" data-id="R0085" href="?id=R0085" sup-id="">
                                            અખરોટ બરફી<sup class="red">૮૫</sup>
                                        </a>
                                        વનમાળી, અન્ન<sub class="text-[10px]">૦</sub>
                                        <span class="text-12 invisible">૦૦૦</span>
                                    </p>
                                    <p>
                                        જમો 
                                        <a class="recipe" data-id="R0086" href="?id=R0086" sup-id="">
                                            બરફી પાઇનેપલની<sup class="red">૮૬</sup>
                                        </a>
                                        , અન્ન<sub class="text-[10px]">૦</sub>
                                        <span class="text-12 invisible lg:hidden inline-box">૦૦૦</span>
                                        <br class="lg:hidden"/>
                                        <a class="recipe" data-id="R0087" href="?id=R0087" sup-id="">
                                            બરફી કેસર-પિસ્તાદિકની<sup class="red">૮૭</sup>
                                        </a>
                                        , અન્ન<sub class="text-[10px]">૦</sub>
                                        <span class="text-12 inline-box">૦૨૧</span>
                                    </p>
                                    <p>
                                        <a class="recipe" data-id="R0088" href="?id=R0088" sup-id="">
                                            ગુલાબ બરફી<sup class="red">૮૮</sup>
                                        </a>
                                        <a class="recipe" data-id="R0089" href="?id=R0089" sup-id="">
                                            બરફી ત્રિરંગી<sup class="red">૮૯</sup>
                                        </a>
                                        , અન્ન<sub class="text-[10px]">૦</sub>
                                        <span class="text-12 invisible lg:hidden inline-box">૦૦૦</span>
                                        <br class="lg:hidden"/>
                                        <a class="recipe" data-id="R0090" href="?id=R0090" sup-id="">
                                            બરફી મેંગો<sup class="red">૯૦</sup>
                                        </a>
                                        છે સુરંગી, અન્ન<sub class="text-[10px]">૦</sub>
                                        <span class="text-12 invisible">૦૦૦</span>
                                    </p>
                                    <p>
                                        <a class="recipe" data-id="R0091" href="?id=R0091" sup-id="">
                                            ડ્રાયફ્રૂટની બરફી<sup class="red">૯૧</sup>
                                        </a>
                                        અચ્છી, અન્ન<sub class="text-[10px]">૦</sub>
                                        <span class="text-12 invisible lg:hidden inline-box">૦૦૦</span>
                                        <br class="lg:hidden"/>
                                        <a class="recipe" data-id="R0092" href="?id=R0092" sup-id="">
                                            ગુલકંદ બરફી<sup class="red">૯૨</sup>
                                        </a>
                                        <a class="recipe" data-id="R0093" href="?id=R0093" sup-id="">
                                            પેંડા કચ્છી<sup class="red">૯૩</sup>
                                        </a>
                                        , અન્ન<sub class="text-[10px]">૦</sub>
                                        <span class="text-12 inline-box">૦૨૨</span>
                                    </p>
                                    <p>
                                        <a class="recipe" data-id="R0094" href="?id=R0094" sup-id="">
                                            પેંડા મલાઈ<sup class="red">૯૪</sup>
                                        </a>
                                        <a class="recipe" data-id="R0095" href="?id=R0095" sup-id="">
                                            પેંડા કેસરના<sup class="red">૯૫</sup>
                                        </a>
                                        અન્ન<sub class="text-[10px]">૦</sub>
                                        <span class="text-12 invisible lg:hidden inline-box">૦૦૦</span>
                                        <br class="lg:hidden"/>
                                        <a class="recipe" data-id="R0096" href="?id=R0096" sup-id="">
                                            મેંગો પેંડા<sup class="red">૯૬</sup>
                                        </a>
                                        <a class="recipe" data-id="R0097" href="?id=R0097" sup-id="">
                                            પેંડા ખજૂરના<sup class="red">૯૭</sup>
                                        </a>
                                        , અન્ન<sub class="text-[10px]">૦</sub>
                                        <span class="text-12 invisible">૦૦૦</span>
                                    </p>
                                    <p>
                                        <a class="recipe" data-id="R0098" href="?id=R0098" sup-id="">
                                            મઠો પાઇનેપલનો<sup class="red">૯૮</sup>
                                        </a>
                                        સારો, અન્ન<sub class="text-[10px]">૦</sub>
                                        <span class="text-12 invisible lg:hidden inline-box">૦૦૦</span>
                                        <br class="lg:hidden"/>
                                        <a class="recipe" data-id="R0099" href="?id=R0099" sup-id="">
                                            મઠો ડ્રાયફ્રૂટનો<sup class="red">૯૯</sup>
                                        </a>
                                        છે ન્યારો, અન્ન<sub class="text-[10px]">૦</sub>
                                        <span class="text-12 inline-box">૦૨૩</span>
                                    </p>
                                    <p>
                                        <a class="recipe" data-id="R0100" href="?id=R0100" sup-id="">
                                            મઠો કેરીનો<sup class="red">૧૦૦</sup>
                                        </a>
                                        <a class="recipe" data-id="R0101" href="?id=R0101" sup-id="">
                                            શૈડકી<sup class="red">૧૦૧</sup>
                                        </a>
                                        શ્યામ, અન્ન<sub class="text-[10px]">૦</sub>
                                        <span class="text-12 invisible lg:hidden inline-box">૦૦૦</span>
                                        <br class="lg:hidden"/>
                                        <a class="recipe" data-id="R0102" href="?id=R0102" sup-id="">
                                            મઠો અમેરિકન<sup class="red">૧૦૨</sup>
                                        </a>
                                        સુખધામ, અન્ન<sub class="text-[10px]">૦</sub>
                                        <span class="text-12 invisible">૦૦૦</span>
                                    </p>
                                    <p>
                                        <a class="recipe" data-id="R0103" href="?id=R0103" sup-id="">
                                            સાદો શિખંડ<sup class="red">૧૦૩</sup>
                                        </a>
                                        <a class="recipe" data-id="R0104" href="?id=R0104" sup-id="">
                                            ફ્રૂટ શિખંડ<sup class="red">૧૦૪</sup>
                                        </a>
                                        , અન્ન<sub class="text-[10px]">૦</sub>
                                        <span class="text-12 invisible lg:hidden inline-box">૦૦૦</span>
                                        <br class="lg:hidden"/>
                                        છે 
                                        <a class="recipe" data-id="R0105" href="?id=R0105" sup-id="">
                                            રાજભોગનો શિખંડ<sup class="red">૧૦૫</sup>
                                        </a>
                                        , અન્ન<sub class="text-[10px]">૦</sub>
                                        <span class="text-12 inline-box">૦૨૪</span>
                                    </p>
                                    <p>
                                        <a class="recipe" data-id="R0106" href="?id=R0106" sup-id="">
                                            બટરસ્કોચનો આ શિખંડ<sup class="red">૧૦૬</sup>
                                        </a>
                                        , અન્ન<sub class="text-[10px]">૦</sub>
                                        <span class="text-12 invisible lg:hidden inline-box">૦૦૦</span>
                                        <br class="lg:hidden"/>
                                        <a class="recipe" data-id="R0107" href="?id=R0107" sup-id="">
                                            ડ્રાયફ્રૂટનો ઠંડો શિખંડ<sup class="red">૧૦૭</sup>
                                        </a>
                                        , અન્ન<sub class="text-[10px]">૦</sub>
                                        <span class="text-12 invisible">૦૦૦</span>
                                    </p>
                                    <p>
                                        જમો 
                                        <a class="recipe" data-id="R0108" href="?id=R0108" sup-id="">
                                            અમેરિકન શિખંડ<sup class="red">૧૦૮</sup>
                                        </a>
                                        , અન્ન<sub class="text-[10px]">૦</sub>
                                        <span class="text-12 invisible lg:hidden inline-box">૦૦૦</span>
                                        <br class="lg:hidden"/>
                                        પ્યારો 
                                        <a class="recipe" data-id="R0109" href="?id=R0109" sup-id="">
                                            ઇલાયચી શિખંડ<sup class="red">૧૦૯</sup>
                                        </a>
                                        , અન્ન<sub class="text-[10px]">૦</sub>
                                        <span class="text-12 inline-box">૦૨૫</span>
                                    </p>
                                    <p>
                                        <a class="recipe" data-id="R0110" href="?id=R0110" sup-id="">
                                            કેસર શિખંડ<sup class="red">૧૧૦</sup>
                                        </a>
                                        છે આ પ્યારો, અન્ન<sub class="text-[10px]">૦</sub>
                                        <span class="text-12 invisible lg:hidden inline-box">૦૦૦</span>
                                        <br class="lg:hidden"/>
                                        <a class="recipe" data-id="R0111" href="?id=R0111" sup-id="">
                                            દૂધપાક દૂધીનો<sup class="red">૧૧૧</sup>
                                        </a>
                                        ન્યારો, અન્ન<sub class="text-[10px]">૦</sub>
                                        <span class="text-12 invisible">૦૦૦</span>
                                    </p>
                                    <p>
                                        છે 
                                        <a class="recipe" data-id="R0112" href="?id=R0112" sup-id="">
                                            શક્કરિયાની બાસુંદી<sup class="red">૧૧૨</sup>
                                        </a>
                                        , અન્ન<sub class="text-[10px]">૦</sub>
                                        <span class="text-12 invisible lg:hidden inline-box">૦૦૦</span>
                                        <br class="lg:hidden"/>
                                        વળી 
                                        <a class="recipe" data-id="R0113" href="?id=R0113" sup-id="">
                                            અંજીરની બાસુંદી<sup class="red">૧૧૩</sup>
                                        </a>
                                        , અન્ન<sub class="text-[10px]">૦</sub>
                                        <span class="text-12 inline-box">૦૨૬</span>
                                    </p>
                                    <p>
                                        <a class="recipe" data-id="R0114" href="?id=R0114" sup-id="">
                                            સાદી બાસુંદી<sup class="red">૧૧૪</sup>
                                        </a>
                                        છે સારી, અન્ન<sub class="text-[10px]">૦</sub>
                                        <span class="text-12 invisible lg:hidden inline-box">૦૦૦</span>
                                        <br class="lg:hidden"/>
                                        <a class="recipe" data-id="R0115" href="?id=R0115" sup-id="">
                                            અંગૂરની બાસુંદી<sup class="red">૧૧૫</sup>
                                        </a>
                                        ન્યારી, અન્ન<sub class="text-[10px]">૦</sub>
                                        <span class="text-12 invisible">૦૦૦</span>
                                    </p>
                                    <p>
                                        <a class="recipe" data-id="R0116" href="?id=R0116" sup-id="">
                                            બાસુંદી પાઇનેપલની<sup class="red">૧૧૬</sup>
                                        </a>
                                        , અન્ન<sub class="text-[10px]">૦</sub>
                                        <span class="text-12 invisible lg:hidden inline-box">૦૦૦</span>
                                        <br class="lg:hidden"/>
                                        <a class="recipe" data-id="R0117" href="?id=R0117" sup-id="">
                                            ઠંડી બાસુંદી ખજૂરની<sup class="red">૧૧૭</sup>
                                        </a>
                                        , અન્ન<sub class="text-[10px]">૦</sub>
                                        <span class="text-12 inline-box">૦૨૭</span>
                                    </p>
                                    <p>
                                        <a class="recipe" data-id="R0118" href="?id=R0118" sup-id="">
                                            ફ્રૂટસલાડ<sup class="red">૧૧૮</sup>
                                        </a>
                                        <a class="recipe" data-id="R0119" href="?id=R0119" sup-id="">
                                            લચ્છા રબડી<sup class="red">૧૧૯</sup>
                                        </a>
                                        , અન્ન<sub class="text-[10px]">૦</sub>
                                        <span class="text-12 invisible lg:hidden inline-box">૦૦૦</span>
                                        <br class="lg:hidden"/>
                                        જમો બહુ 
                                        <a class="recipe" data-id="R0120" href="?id=R0120" sup-id="">
                                            સીતાફળ રબડી<sup class="red">૧૨૦</sup>
                                        </a>
                                        , અન્ન<sub class="text-[10px]">૦</sub>
                                        <span class="text-12 invisible">૦૦૦</span>
                                    </p>
                                    <p>
                                        છે 
                                        <a class="recipe" data-id="R0121" href="?id=R0121" sup-id="">
                                            રબડી આ ગાજરની<sup class="red">૧૨૧</sup>
                                        </a>
                                        , અન્ન<sub class="text-[10px]">૦</sub>
                                        <span class="text-12 invisible lg:hidden inline-box">૦૦૦</span>
                                        <br class="lg:hidden"/>
                                        સારી 
                                        <a class="recipe" data-id="R0122" href="?id=R0122" sup-id="">
                                            રબડી છે અંગૂરની<sup class="red">૧૨૨</sup>
                                        </a>
                                        , અન્ન<sub class="text-[10px]">૦</sub>
                                        <span class="text-12 inline-box">૦૨૮</span>
                                    </p>
                                    <p>
                                        <a class="recipe" data-id="R0123" href="?id=R0123" sup-id="">
                                            રબડી પાઇનેપલની<sup class="red">૧૨૩</sup>
                                        </a>
                                        સારી, અન્ન<sub class="text-[10px]">૦</sub>
                                        <span class="text-12 invisible lg:hidden inline-box">૦૦૦</span>
                                        <br class="lg:hidden"/>
                                        <a class="recipe" data-id="R0124" href="?id=R0124" sup-id="">
                                            કેરીની રબડી<sup class="red">૧૨૪</sup>
                                        </a>
                                        ન્યારી, અન્ન<sub class="text-[10px]">૦</sub>
                                        <span class="text-12 invisible">૦૦૦</span>
                                    </p>
                                    <p>
                                        <a class="recipe" data-id="R0125" href="?id=R0125" sup-id="">
                                            અંજીરબહાર<sup class="red">૧૨૫</sup>
                                        </a>
                                        <a class="recipe" data-id="R0126" href="?id=R0126" sup-id="">
                                            રસમલાઈ<sup class="red">૧૨૬</sup>
                                        </a>
                                        , અન્ન<sub class="text-[10px]">૦</sub>
                                        <span class="text-12 invisible lg:hidden inline-box">૦૦૦</span>
                                        <br class="lg:hidden"/>
                                        જમો 
                                        <a class="recipe" data-id="R0127" href="?id=R0127" sup-id="">
                                            સંદેશ<sup class="red">૧૨૭</sup>
                                        </a>
                                        હે હરિરાય, અન્ન<sub class="text-[10px]">૦</sub>
                                        <span class="text-12 inline-box">૦૨૯</span>
                                    </p>
                                    <p>
                                        <a class="recipe" data-id="R0128" href="?id=R0128" sup-id="">
                                            જમો થાબડી<sup class="red">૧૨૮</sup>
                                        </a>
                                        બની છે સારી, અન્ન<sub class="text-[10px]">૦</sub>
                                        <span class="text-12 invisible lg:hidden inline-box">૦૦૦</span>
                                        <br class="lg:hidden"/>
                                        <a class="recipe" data-id="R0129" href="?id=R0129" sup-id="">
                                            પાઇનાક્રૂઝ<sup class="red">૧૨૯</sup>
                                        </a>
                                        <a class="recipe" data-id="R0130" href="?id=R0130" sup-id="">
                                            ચમચમ<sup class="red">૧૩૦</sup>
                                        </a>
                                        ન્યારી, અન્ન<sub class="text-[10px]">૦</sub>
                                        <span class="text-12 invisible">૦૦૦</span>
                                    </p>
                                    <p>
                                        જમો 
                                        <a class="recipe" data-id="R0131" href="?id=R0131" sup-id="">
                                            કેરીરસ<sup class="red">૧૩૧</sup>
                                        </a>
                                        મુજ ધામ, અન્ન<sub class="text-[10px]">૦</sub>
                                        <span class="text-12 invisible lg:hidden inline-box">૦૦૦</span>
                                        <br class="lg:hidden"/>
                                        કરો રાજી સહુને શ્યામ, અન્ન<sub class="text-[10px]">૦</sub>
                                        <span class="text-12 inline-box">૦૩૦</span>
                                    </p>
                                    <p>
                                        <a class="recipe" data-id="R0132" href="?id=R0132" sup-id="">
                                            કાજુરોલ<sup class="red">૧૩૨</sup>
                                        </a>
                                        <a class="recipe" data-id="R0133" href="?id=R0133" sup-id="">
                                            પિસ્તારોલ<sup class="red">૧૩૩</sup>
                                        </a>
                                        , અન્ન<sub class="text-[10px]">૦</sub>
                                        <span class="text-12 invisible lg:hidden inline-box">૦૦૦</span>
                                        <br class="lg:hidden"/>
                                        <a class="recipe" data-id="R0134" href="?id=R0134" sup-id="">
                                            કાજુ-અંજીરના છે રોલ<sup class="red">૧૩૪</sup>
                                        </a>
                                        , અન્ન<sub class="text-[10px]">૦</sub>
                                        <span class="text-12 invisible">૦૦૦</span>
                                    </p>
                                    <p>
                                        <a class="recipe" data-id="R0135" href="?id=R0135" sup-id="">
                                            કાજુપાન<sup class="red">૧૩૫</sup>
                                        </a>
                                        <a class="recipe" data-id="R0136" href="?id=R0136" sup-id="">
                                            કાજુકતરી<sup class="red">૧૩૬</sup>
                                        </a>
                                        , અન્ન<sub class="text-[10px]">૦</sub>
                                        <span class="text-12 invisible lg:hidden inline-box">૦૦૦</span>
                                        <br class="lg:hidden"/>
                                        જમો 
                                        <a class="recipe" data-id="R0137" href="?id=R0137" sup-id="">
                                            બદામકતરી<sup class="red">૧૩૭</sup>
                                        </a>
                                        હરિ, અન્ન<sub class="text-[10px]">૦</sub>
                                        <span class="text-12 inline-box">૦૩૧</span>
                                    </p>
                                    <p>
                                        <a class="recipe" data-id="R0138" href="?id=R0138" sup-id="">
                                            મેસૂબ કાજુનો<sup class="red">૧૩૮</sup>
                                        </a>
                                        છે સારો, અન્ન<sub class="text-[10px]">૦</sub>
                                        <span class="text-12 invisible lg:hidden inline-box">૦૦૦</span>
                                        <br class="lg:hidden"/>
                                        છે 
                                        <a class="recipe" data-id="R0139" href="?id=R0139" sup-id="R0139">
                                            બદામનો<sup class="red">૧૩૯</sup>
                                        </a>
                                        પણ પ્યારો, અન્ન<sub class="text-[10px]">૦</sub>
                                        <span class="text-12 invisible">૦૦૦</span>
                                    </p>
                                    <p>
                                        જમો 
                                        <a class="recipe" data-id="R0140" href="?id=R0140" sup-id="">
                                            શીંગનો મેસૂબ<sup class="red">૧૪૦</sup>
                                        </a>
                                        શ્યામ, અન્ન<sub class="text-[10px]">૦</sub>
                                        <span class="text-12 invisible lg:hidden inline-box">૦૦૦</span>
                                        <br class="lg:hidden"/>
                                        એ આદિ મેસૂબ તમામ, અન્ન<sub class="text-[10px]">૦</sub>
                                        <span class="text-12 inline-box">૦૩૨</span>
                                    </p>
                                    <p>
                                        <a class="recipe" data-id="R0141" href="?id=R0141" sup-id="">
                                            સુખડી રાજગરાની<sup class="red">૧૪૧</sup>
                                        </a>
                                        સારી, અન્ન<sub class="text-[10px]">૦</sub>
                                        <span class="text-12 invisible lg:hidden inline-box">૦૦૦</span>
                                        <br class="lg:hidden"/>
                                        તમે ભાવે જમો અવતારી, અન્ન<sub class="text-[10px]">૦</sub>
                                        <span class="text-12 invisible">૦૦૦</span>
                                    </p>
                                    <p>
                                        <a class="recipe" data-id="R0142" href="?id=R0142" sup-id="">
                                            અખરોટપ્લાઝા<sup class="red">૧૪૨</sup>
                                        </a>
                                        <a class="recipe" data-id="R0143" href="?id=R0143" sup-id="">
                                            શીંગપાક<sup class="red">૧૪૩</sup>
                                        </a>
                                        , અન્ન<sub class="text-[10px]">૦</sub>
                                        <span class="text-12 invisible lg:hidden inline-box">૦૦૦</span>
                                        <br class="lg:hidden"/>
                                        <a class="recipe" data-id="R0144" href="?id=R0144" sup-id="">
                                            ખજૂરપાક<sup class="red">૧૪૪</sup>
                                        </a>
                                        <a class="recipe" data-id="R0145" href="?id=R0145" sup-id="">
                                            અંજીરપાક<sup class="red">૧૪૫</sup>
                                        </a>
                                        , અન્ન<sub class="text-[10px]">૦</sub>
                                        <span class="text-12 inline-box">૦૩૩</span>
                                    </p>
                                    <p>
                                        <a class="recipe" data-id="R0146" href="?id=R0146" sup-id="">
                                            દૂધીનો હલવો<sup class="red">૧૪૬</sup>
                                        </a>
                                        સારો, અન્ન<sub class="text-[10px]">૦</sub>
                                        <span class="text-12 invisible lg:hidden inline-box">૦૦૦</span>
                                        <br class="lg:hidden"/>
                                        <a class="recipe" data-id="R0147" href="?id=R0147" sup-id="">
                                            ગાજરનો હલવો<sup class="red">૧૪૭</sup>
                                        </a>
                                        પ્યારો, અન્ન<sub class="text-[10px]">૦</sub>
                                        <span class="text-12 invisible">૦૦૦</span>
                                    </p>
                                    <p>
                                        <a class="recipe" data-id="R0148" href="?id=R0148" sup-id="">
                                            ચીકુનો હલવો<sup class="red">૧૪૮</sup>
                                        </a>
                                        ન્યારો, અન્ન<sub class="text-[10px]">૦</sub>
                                        <span class="text-12 invisible lg:hidden inline-box">૦૦૦</span>
                                        <br class="lg:hidden"/>
                                        છે 
                                        <a class="recipe" data-id="R0149" href="?id=R0149" sup-id="">
                                            બીટનો હલવો<sup class="red">૧૪૯</sup>
                                        </a>
                                        સારો, અન્ન<sub class="text-[10px]">૦</sub>
                                        <span class="text-12 inline-box">૦૩૪</span>
                                    </p>
                                    <p>
                                        <a class="recipe" data-id="R0150" href="?id=R0150" sup-id="">
                                            લીલા નાળિયેરનો હલવો<sup class="red">૧૫૦</sup>
                                        </a>
                                        , અન્ન<sub class="text-[10px]">૦</sub>
                                        <span class="text-12 invisible lg:hidden inline-box">૦૦૦</span>
                                        <br class="lg:hidden"/>
                                        <a class="recipe" data-id="R0151" href="?id=R0151" sup-id="">
                                            એપલ હલવો<sup class="red">૧૫૧</sup>
                                        </a>
                                        <a class="recipe" data-id="R0152" href="?id=R0152" sup-id="">
                                            અખરોટ હલવો<sup class="red">૧૫૨</sup>
                                        </a>
                                        , અન્ન<sub class="text-[10px]">૦</sub>
                                        <span class="text-12 invisible">૦૦૦</span>
                                    </p>
                                    <p>
                                        જમો 
                                        <a class="recipe" data-id="R0153" href="?id=R0153" sup-id="">
                                            કચરિયું<sup class="red">૧૫૩</sup>
                                        </a>
                                        આ સારું, અન્ન<sub class="text-[10px]">૦</sub>
                                        <span class="text-12 invisible lg:hidden inline-box">૦૦૦</span>
                                        <br class="lg:hidden"/>
                                        દિલે જમતી મૂર્તિ ધારું, અન્ન<sub class="text-[10px]">૦</sub>
                                        <span class="text-12 inline-box">૦૩૫</span>
                                    </p>
                                    <p>
                                        <a class="recipe" data-id="R0154" href="?id=R0154" sup-id="">
                                            સાબુદાણાની ખીર<sup class="red">૧૫૪</sup>
                                        </a>
                                        પ્યારી, અન્ન<sub class="text-[10px]">૦</sub>
                                        <span class="text-12 invisible lg:hidden inline-box">૦૦૦</span>
                                        <br class="lg:hidden"/>
                                        <a class="recipe" data-id="R0155" href="?id=R0155" sup-id="">
                                            ખીર મોરૈયાની<sup class="red">૧૫૫</sup>
                                        </a>
                                        સારી, અન્ન<sub class="text-[10px]">૦</sub>
                                        <span class="text-12 invisible">૦૦૦</span>
                                    </p>
                                    <p>
                                        <a class="ingredient" data-id="I0218" href="?id=I0218" sup-id="">
                                            ખીરું<sup class="red">૧૫૬</sup>
                                        </a>
                                        <a class="recipe" data-id="R0157" href="?id=R0157" sup-id="">
                                            ખીરાના પેંડા<sup class="red">૧૫૭</sup>
                                        </a>
                                        <a class="recipe" data-id="R0158" href="?id=R0158" sup-id="">
                                            બળી<sup class="red">૧૫૮</sup>
                                        </a>
                                        , અન્ન<sub class="text-[10px]">૦</sub>
                                        <span class="text-12 invisible lg:hidden inline-box">૦૦૦</span>
                                        <br class="lg:hidden"/>
                                        જમો 
                                        <a class="recipe" data-id="R0159" href="?id=R0159" sup-id="">
                                            મોગોના લાડુ<sup class="red">૧૫૯</sup>
                                        </a>
                                        વળી, અન્ન<sub class="text-[10px]">૦</sub>
                                        <span class="text-12 inline-box">૦૩૬</span>
                                    </p>
                                    <p>
                                        જમો 
                                        <a class="recipe" data-id="R0160" href="?id=R0160" sup-id="">
                                            કાજુ-બદામના લાડુ<sup class="red">૧૬૦</sup>
                                        </a>
                                        , અન્ન<sub class="text-[10px]">૦</sub>
                                        <span class="text-12 invisible lg:hidden inline-box">૦૦૦</span>
                                        <br class="lg:hidden"/>
                                        જમો 
                                        <a class="recipe" data-id="R0161" href="?id=R0161" sup-id="">
                                            મોરૈયાના લાડુ<sup class="red">૧૬૧</sup>
                                        </a>
                                        , અન્ન<sub class="text-[10px]">૦</sub>
                                        <span class="text-12 invisible">૦૦૦</span>
                                    </p>
                                    <p>
                                        <a class="recipe" data-id="R0162" href="?id=R0162" sup-id="">
                                            રાજગરા ધાણીના લાડુ<sup class="red">૧૬૨</sup>
                                        </a>
                                        , અન્ન<sub class="text-[10px]">૦</sub>
                                        <span class="text-12 invisible lg:hidden inline-box">૦૦૦</span>
                                        <br class="lg:hidden"/>
                                        <a class="recipe" data-id="R0163" href="?id=R0163" sup-id="">
                                            બીટ લાડુ<sup class="red">૧૬૩</sup>
                                        </a>
                                        <a class="recipe" data-id="R0164" href="?id=R0164" sup-id="">
                                            ડ્રાયફ્રૂટ લાડુ<sup class="red">૧૬૪</sup>
                                        </a>
                                        , અન્ન<sub class="text-[10px]">૦</sub>
                                        <span class="text-12 inline-box">૦૩૭</span>
                                    </p>
                                    <p>
                                        <a class="recipe" data-id="R0165" href="?id=R0165" sup-id="">
                                            તલલાડુ<sup class="red">૧૬૫</sup>
                                        </a>
                                        <a class="recipe" data-id="R0166" href="?id=R0166" sup-id="">
                                            ટોપરાલાડુ<sup class="red">૧૬૬</sup>
                                        </a>
                                        , અન્ન<sub class="text-[10px]">૦</sub>
                                        <span class="text-12 invisible lg:hidden inline-box">૦૦૦</span>
                                        <br class="lg:hidden"/>
                                        <a class="recipe" data-id="R0167" href="?id=R0167" sup-id="">
                                            શીરો મોરૈયાનો<sup class="red">૧૬૭</sup>
                                        </a>
                                        જમાડું, અન્ન<sub class="text-[10px]">૦</sub>
                                        <span class="text-12 invisible">૦૦૦</span>
                                    </p>
                                    <p>
                                        <a class="recipe" data-id="R0168" href="?id=R0168" sup-id="R0168">
                                            શિંગોડાનો<sup class="red">૧૬૮</sup>
                                        </a>
                                        <a class="recipe" data-id="R0169" href="?id=R0169" sup-id="R0169">
                                            રાજગરાનો<sup class="red">૧૬૯</sup>
                                        </a>
                                        , અન્ન<sub class="text-[10px]">૦</sub>
                                        <span class="text-12 invisible lg:hidden inline-box">૦૦૦</span>
                                        <br class="lg:hidden"/>
                                        <a class="recipe" data-id="R0170" href="?id=R0170" sup-id="">
                                            શીરો રતાળુનો<sup class="red">૧૭૦</sup>
                                        </a>
                                        <a class="recipe" data-id="R0171" href="?id=R0171" sup-id="">
                                            બટેકાનો<sup class="red">૧૭૧</sup>
                                        </a>
                                        , અન્ન<sub class="text-[10px]">૦</sub>
                                        <span class="text-12 inline-box">૦૩૮</span>
                                    </p>
                                    <p>
                                        <a class="recipe" data-id="R0172" href="?id=R0172" sup-id="">
                                            શીરો શક્કરિયાનો<sup class="red">૧૭૨</sup>
                                        </a>
                                        જમાડું, અન્ન<sub class="text-[10px]">૦</sub>
                                        <span class="text-12 invisible lg:hidden inline-box">૦૦૦</span>
                                        <br class="lg:hidden"/>
                                        વાલા તમને આનંદ પમાડું, અન્ન<sub class="text-[10px]">૦</sub>
                                        <span class="text-12 invisible">૦૦૦</span>
                                    </p>
                                    <p>
                                        <a class="recipe" data-id="R0173" href="?id=R0173" sup-id="">
                                            મોરૈયાના રોટલા<sup class="red">૧૭૩</sup>
                                        </a>
                                        પ્યારા, અન્ન<sub class="text-[10px]">૦</sub>
                                        <span class="text-12 invisible lg:hidden inline-box">૦૦૦</span>
                                        <br class="lg:hidden"/>
                                        <a class="recipe" data-id="R0174" href="?id=R0174" sup-id="">
                                            મોરૈયાના ખમણ<sup class="red">૧૭૪</sup>
                                        </a>
                                        સારા, અન્ન<sub class="text-[10px]">૦</sub>
                                        <span class="text-12 inline-box">૦૩૯</span>
                                    </p>
                                    <p>
                                        <a class="recipe" data-id="R0175" href="?id=R0175" sup-id="">
                                            નાનખટાઈ મોરૈયાની<sup class="red">૧૭૫</sup>
                                        </a>
                                        , અન્ન<sub class="text-[10px]">૦</sub>
                                        <span class="text-12 invisible lg:hidden inline-box">૦૦૦</span>
                                        <br class="lg:hidden"/>
                                        જમો 
                                        <a class="recipe" data-id="R0176" href="?id=R0176" sup-id="">
                                            ખીચડી મોરૈયાની <sup class="red">૧૭૬</sup>
                                        </a>
                                        , અન્ન<sub class="text-[10px]">૦</sub>
                                        <span class="text-12 invisible">૦૦૦</span>
                                    </p>
                                    <p>
                                        <a class="recipe" data-id="R0177" href="?id=R0177" sup-id="">
                                            મોરૈયા-રાજગરાના બિસ્કીટ<sup class="red">૧૭૭</sup>
                                        </a>
                                        , અન્ન<sub class="text-[10px]">૦</sub>
                                        <span class="text-12 invisible lg:hidden inline-box">૦૦૦</span>
                                        <br class="lg:hidden"/>
                                        <a class="recipe" data-id="R0178" href="?id=R0178" sup-id="">
                                            સાબુદાણાની ખીચડી<sup class="red">૧૭૮</sup>
                                        </a>
                                        ઇષ્ટ, અન્ન<sub class="text-[10px]">૦</sub>
                                        <span class="text-12 inline-box">૦૪૦</span>
                                    </p>
                                    <p>
                                        <a class="recipe" data-id="R0179" href="?id=R0179" sup-id="">
                                            તલપાક<sup class="red">૧૭૯</sup>
                                        </a>
                                        ને 
                                        <a class="ingredient" data-id="I0050" href="?id=I0050" sup-id="">
                                            દૂધની તર<sup class="red">૧૮૦</sup>
                                        </a>
                                        , અન્ન<sub class="text-[10px]">૦</sub>
                                        <span class="text-12 invisible lg:hidden inline-box">૦૦૦</span>
                                        <br class="lg:hidden"/>
                                        <a class="ingredient" data-id="I0219" href="?id=I0219" sup-id="">
                                            કોટન કેન્ડી<sup class="red">૧૮૧</sup>
                                        </a>
                                        <a class="recipe" data-id="R0182" href="?id=R0182" sup-id="">
                                            પંજરી<sup class="red">૧૮૨</sup>
                                        </a>
                                        વર, અન્ન<sub class="text-[10px]">૦</sub>
                                        <span class="text-12 invisible">૦૦૦</span>
                                    </p>
                                    <p>
                                        <a class="recipe" data-id="R0183" href="?id=R0183" sup-id="">
                                            ઢોંસા ફરાળી<sup class="red">૧૮૩</sup>
                                        </a>
                                        <a class="recipe" data-id="R0184" href="?id=R0184" sup-id="">
                                            ફરાળી સાંભાર<sup class="red">૧૮૪</sup>
                                        </a>
                                        , અન્ન<sub class="text-[10px]">૦</sub>
                                        <span class="text-12 invisible lg:hidden inline-box">૦૦૦</span>
                                        <br class="lg:hidden"/>
                                        <a class="recipe" data-id="R0185" href="?id=R0185" sup-id="">
                                            સાબુદાણાનાં વડાં<sup class="red">૧૮૫</sup>
                                        </a>
                                        સાર, અન્ન<sub class="text-[10px]">૦</sub>
                                        <span class="text-12 inline-box">૦૪૧</span>
                                    </p>
                                    <p>
                                        જમો 
                                        <a class="recipe" data-id="R0186" href="?id=R0186" sup-id="">
                                            ફરાળી ભેળ<sup class="red">૧૮૬</sup>
                                        </a>
                                        હે હરિ, અન્ન<sub class="text-[10px]">૦</sub>
                                        <span class="text-12 invisible lg:hidden inline-box">૦૦૦</span>
                                        <br class="lg:hidden"/>
                                        જમો વહાલા 
                                        <a class="recipe" data-id="R0187" href="?id=R0187" sup-id="">
                                            માખણ મિસરી<sup class="red">૧૮૭</sup>
                                        </a>
                                        , અન્ન<sub class="text-[10px]">૦</sub>
                                        <span class="text-12 invisible">૦૦૦</span>
                                    </p>
                                    <p>
                                        <a class="recipe" data-id="R0188" href="?id=R0188" sup-id="">
                                            ઘી ગોળ<sup class="red">૧૮૮</sup>
                                        </a>
                                        ને છે 
                                        <a class="recipe" data-id="R0189" href="?id=R0189" sup-id="">
                                            ઘી કેળાં<sup class="red">૧૮૯</sup>
                                        </a>
                                        , અન્ન<sub class="text-[10px]">૦</sub>
                                        <span class="text-12 invisible lg:hidden inline-box">૦૦૦</span>
                                        <br class="lg:hidden"/>
                                        અતિ ભાવે કર્યા છે ભેળાં, અન્ન<sub class="text-[10px]">૦</sub>
                                        <span class="text-12 inline-box">૦૪૨</span>
                                    </p>
                                    <p>
                                        <a class="recipe" data-id="R0190" href="?id=R0190" sup-id="R0190">
                                            રાજગરાની<sup class="red">૧૯૦</sup>
                                        </a>
                                        <a class="recipe" data-id="R0191" href="?id=R0191" sup-id="">
                                            કાજુની ચીકી<sup class="red">૧૯૧</sup>
                                        </a>
                                        , અન્ન<sub class="text-[10px]">૦</sub>
                                        <span class="text-12 invisible lg:hidden inline-box">૦૦૦</span>
                                        <br class="lg:hidden"/>
                                        <a class="recipe" data-id="R0192" href="?id=R0192" sup-id="">
                                            ટોપરાચીકી<sup class="red">૧૯૨</sup>
                                        </a>
                                        <a class="recipe" data-id="R0193" href="?id=R0193" sup-id="">
                                            બદામની ચીકી<sup class="red">૧૯૩</sup>
                                        </a>
                                        , અન્ન<sub class="text-[10px]">૦</sub>
                                        <span class="text-12 invisible">૦૦૦</span>
                                    </p>
                                    <p>
                                        <a class="recipe" data-id="R0194" href="?id=R0194" sup-id="">
                                            ચીકી તલની<sup class="red">૧૯૪</sup>
                                        </a>
                                        ને 
                                        <a class="recipe" data-id="R0195" href="?id=R0195" sup-id="R0195">
                                            પિસ્તાની<sup class="red">૧૯૫</sup>
                                        </a>
                                        , અન્ન<sub class="text-[10px]">૦</sub>
                                        <span class="text-12 invisible lg:hidden inline-box">૦૦૦</span>
                                        <br class="lg:hidden"/>
                                        <a class="recipe" data-id="R0196" href="?id=R0196" sup-id="">
                                            શીંગચીકી<sup class="red">૧૯૬</sup>
                                        </a>
                                        <a class="recipe" data-id="R0197" href="?id=R0197" sup-id="">
                                            ચીકી માવાની<sup class="red">૧૯૭</sup>
                                        </a>
                                        , અન્ન<sub class="text-[10px]">૦</sub>
                                        <span class="text-12 inline-box">૦૪૩</span>
                                    </p>
                                    <p>
                                        વ્હાલા વિવિધ 
                                        <a class="recipe" data-id="R0198" href="?id=R0198" sup-id="">
                                            ડ્રાયફ્રૂટ કેરી<sup class="red">૧૯૮</sup>
                                        </a>
                                        , અન્ન<sub class="text-[10px]">૦</sub>
                                        <span class="text-12 invisible lg:hidden inline-box">૦૦૦</span>
                                        <br class="lg:hidden"/>
                                        ચીકી જમજો પ્રેમે ઘણેરી, અન્ન<sub class="text-[10px]">૦</sub>
                                        <span class="text-12 invisible">૦૦૦</span>
                                    </p>
                                    <h3>ભીનું ફરસાણ</h3>
                                    <p>
                                        જમો નાથ 
                                        <a class="recipe" data-id="R0199" href="?id=R0199" sup-id="">
                                            ખસતા કચોરી<sup class="red">૧૯૯</sup>
                                        </a>
                                        , અન્ન<sub class="text-[10px]">૦</sub>
                                        <span class="text-12 invisible lg:hidden inline-box">૦૦૦</span>
                                        <br class="lg:hidden"/>
                                        છે 
                                        <a class="recipe" data-id="R0200" href="?id=R0200" sup-id="">
                                            સ્પાઇસી મસાલા કચોરી<sup class="red">૨૦૦</sup>
                                        </a>
                                        , અન્ન<sub class="text-[10px]">૦</sub>
                                        <span class="text-12 inline-box">૦૪૪</span>
                                    </p>
                                    <p>
                                        <a class="recipe" data-id="R0201" href="?id=R0201" sup-id="">
                                            પનીરની<sup class="red">૨૦૧</sup>
                                        </a>
                                        ને 
                                        <a class="recipe" data-id="R0202" href="?id=R0202" sup-id="">
                                            વટાણાની<sup class="red">૨૦૨</sup>
                                        </a>
                                        , અન્ન<sub class="text-[10px]">૦</sub>
                                        <span class="text-12 invisible lg:hidden inline-box">૦૦૦</span>
                                        <br class="lg:hidden"/>
                                        વળી 
                                        <a class="recipe" data-id="R0203" href="?id=R0203" sup-id="">
                                            કચોરી છે લીલવાની<sup class="red">૨૦૩</sup>
                                        </a>
                                        , અન્ન<sub class="text-[10px]">૦</sub>
                                        <span class="text-12 invisible">૦૦૦</span>
                                    </p>
                                    <p>
                                        જમો વાલા 
                                        <a class="recipe" data-id="R0204" href="?id=R0204" sup-id="">
                                            રાજકચોરી<sup class="red">૨૦૪</sup>
                                        </a>
                                        , અન્ન<sub class="text-[10px]">૦</sub>
                                        <span class="text-12 invisible lg:hidden inline-box">૦૦૦</span>
                                        <br class="lg:hidden"/>
                                        જમો જીવન 
                                        <a class="recipe" data-id="R0205" href="?id=R0205" sup-id="">
                                            આલુ કચોરી<sup class="red">૨૦૫</sup>
                                        </a>
                                        , અન્ન<sub class="text-[10px]">૦</sub>
                                        <span class="text-12 inline-box">૦૪૫</span>
                                    </p>
                                    <p>
                                        જમો 
                                        <a class="recipe" data-id="R0206" href="?id=R0206" sup-id="">
                                            કટલેસ<sup class="red">૨૦૬</sup>
                                        </a>
                                        ને 
                                        <a class="recipe" data-id="R0207" href="?id=R0207" sup-id="">
                                            સમોસા<sup class="red">૨૦૭</sup>
                                        </a>
                                        , અન્ન<sub class="text-[10px]">૦</sub>
                                        <span class="text-12 invisible lg:hidden inline-box">૦૦૦</span>
                                        <br class="lg:hidden"/>
                                        વળી 
                                        <a class="recipe" data-id="R0208" href="?id=R0208" sup-id="">
                                            પંજાબી સમોસા<sup class="red">૨૦૮</sup>
                                        </a>
                                        , અન્ન<sub class="text-[10px]">૦</sub>
                                        <span class="text-12 invisible">૦૦૦</span>
                                    </p>
                                    <p>
                                        <a class="recipe" data-id="R0209" href="?id=R0209" sup-id="">
                                            પાંઉ સમોસા<sup class="red">૨૦૯</sup>
                                        </a>
                                        <a class="recipe" data-id="R0210" href="?id=R0210" sup-id="">
                                            પટ્ટી સમોસા<sup class="red">૨૧૦</sup>
                                        </a>
                                        , અન્ન<sub class="text-[10px]">૦</sub>
                                        <span class="text-12 invisible lg:hidden inline-box">૦૦૦</span>
                                        <br class="lg:hidden"/>
                                        <a class="recipe" data-id="R0211" href="?id=R0211" sup-id="">
                                            ચાઇનીઝ<sup class="red">૨૧૧</sup>
                                        </a>
                                        ને 
                                        <a class="recipe" data-id="R0212" href="?id=R0212" sup-id="">
                                            પોટલી સમોસા<sup class="red">૨૧૨</sup>
                                        </a>
                                        , અન્ન<sub class="text-[10px]">૦</sub>
                                        <span class="text-12 inline-box">૦૪૬</span>
                                    </p>
                                    <p>
                                        <a class="recipe" data-id="R0213" href="?id=R0213" sup-id="">
                                            ઢેબરાં કોથમીર<sup class="red">૨૧૩</sup>
                                        </a>
                                        ને 
                                        <a class="recipe" data-id="R0214" href="?id=R0214" sup-id="R0214">
                                            મેથીનાં<sup class="red">૨૧૪</sup>
                                        </a>
                                        , અન્ન<sub class="text-[10px]">૦</sub>
                                        <span class="text-12 invisible lg:hidden inline-box">૦૦૦</span>
                                        <br class="lg:hidden"/>
                                        જમો 
                                        <a class="recipe" data-id="R0215" href="?id=R0215" sup-id="R0215">
                                            બાજરી<sup class="red">૨૧૫</sup>
                                        </a>
                                        ને 
                                        <a class="recipe" data-id="R0216" href="?id=R0216" sup-id="R0216">
                                            દૂધીનાં<sup class="red">૨૧૬</sup>
                                        </a>
                                        , અન્ન<sub class="text-[10px]">૦</sub>
                                        <span class="text-12 invisible">૦૦૦</span>
                                    </p>
                                    <p>
                                        <a class="recipe" data-id="R0217" href="?id=R0217" sup-id="">
                                            બીટ ઢેબરાં<sup class="red">૨૧૭</sup>
                                        </a>
                                        <a class="recipe" data-id="R0218" href="?id=R0218" sup-id="">
                                            પાલખ ઢેબરાં<sup class="red">૨૧૮</sup>
                                        </a>
                                        , અન્ન<sub class="text-[10px]">૦</sub>
                                        <span class="text-12 invisible lg:hidden inline-box">૦૦૦</span>
                                        <br class="lg:hidden"/>
                                        જમો વાલમ હે સુખકરા, અન્ન<sub class="text-[10px]">૦</sub>
                                        <span class="text-12 inline-box">૦૪૭</span>
                                    </p>
                                    <p>
                                        જમો 
                                        <a class="recipe" data-id="R0219" href="?id=R0219" sup-id="">
                                            મકાઈનાં ઢોકળાં<sup class="red">૨૧૯</sup>
                                        </a>
                                        , અન્ન<sub class="text-[10px]">૦</sub>
                                        <span class="text-12 invisible lg:hidden inline-box">૦૦૦</span>
                                        <br class="lg:hidden"/>
                                        વળી છે ત્રિરંગી 
                                        <a class="recipe" data-id="R0220" href="?id=R0220" sup-id="R0220">
                                            ઢોકળાં<sup class="red">૨૨૦</sup>
                                        </a>
                                        , અન્ન<sub class="text-[10px]">૦</sub>
                                        <span class="text-12 invisible">૦૦૦</span>
                                    </p>
                                    <p>
                                        છે 
                                        <a class="recipe" data-id="R0221" href="?id=R0221" sup-id="">
                                            ખાટિયાં ઢોકળાં<sup class="red">૨૨૧</sup>
                                        </a>
                                        પ્યારાં, અન્ન<sub class="text-[10px]">૦</sub>
                                        <span class="text-12 invisible lg:hidden inline-box">૦૦૦</span>
                                        <br class="lg:hidden"/>
                                        <a class="recipe" data-id="R0222" href="?id=R0222" sup-id="">
                                            મગદાળનાં<sup class="red">૨૨૨</sup>
                                        </a>
                                        <a class="recipe" data-id="R0223" href="?id=R0223" sup-id="">
                                            રવાના<sup class="red">૨૨૩</sup>
                                        </a>
                                        ન્યારાં, અન્ન<sub class="text-[10px]">૦</sub>
                                        <span class="text-12 inline-box">૦૪૮</span>
                                    </p>
                                    <p>
                                        <a class="recipe" data-id="R0224" href="?id=R0224" sup-id="">
                                            મૂઠિયાં પાલખનાં<sup class="red">૨૨૪</sup>
                                        </a>
                                        <a class="recipe" data-id="R0225" href="?id=R0225" sup-id="R0225">
                                            દૂધીનાં<sup class="red">૨૨૫</sup>
                                        </a>
                                        , અન્ન<sub class="text-[10px]">૦</sub>
                                        <span class="text-12 invisible lg:hidden inline-box">૦૦૦</span>
                                        <br class="lg:hidden"/>
                                        જમો મૂઠિયાં આ 
                                        <a class="recipe" data-id="R0226" href="?id=R0226" sup-id="R0226">
                                            મેથીનાં<sup class="red">૨૨૬</sup>
                                        </a>
                                        , અન્ન<sub class="text-[10px]">૦</sub>
                                        <span class="text-12 invisible">૦૦૦</span>
                                    </p>
                                    <p>
                                        <a class="recipe" data-id="R0227" href="?id=R0227" sup-id="">
                                            ઈદડાં<sup class="red">૨૨૭</sup>
                                        </a>
                                        <a class="recipe" data-id="R0228" href="?id=R0228" sup-id="">
                                            ખાંડવી<sup class="red">૨૨૮</sup>
                                        </a>
                                        ને 
                                        <a class="recipe" data-id="R0229" href="?id=R0229" sup-id="R0229">
                                            ખમણ<sup class="red">૨૨૯</sup>
                                        </a>
                                        , અન્ન<sub class="text-[10px]">૦</sub>
                                        <span class="text-12 invisible lg:hidden inline-box">૦૦૦</span>
                                        <br class="lg:hidden"/>
                                        <a class="recipe" data-id="R0230" href="?id=R0230" sup-id="">
                                            વાટીદાળના છે ખમણ<sup class="red">૨૩૦</sup>
                                        </a>
                                        , અન્ન<sub class="text-[10px]">૦</sub>
                                        <span class="text-12 inline-box">૦૪૯</span>
                                    </p>
                                    <p>
                                        <a class="recipe" data-id="R0231" href="?id=R0231" sup-id="R0231">
                                            પાતરા<sup class="red">૨૩૧</sup>
                                        </a>
                                        <a class="recipe" data-id="R0232" href="?id=R0232" sup-id="">
                                            પેટીસ<sup class="red">૨૩૨</sup>
                                        </a>
                                        <a class="recipe" data-id="R0233" href="?id=R0233" sup-id="">
                                            દાળઢોકળી<sup class="red">૨૩૩</sup>
                                        </a>
                                        , અન્ન<sub class="text-[10px]">૦</sub>
                                        <span class="text-12 invisible lg:hidden inline-box">૦૦૦</span>
                                        <br class="lg:hidden"/>
                                        <a class="recipe" data-id="R0234" href="?id=R0234" sup-id="">
                                            અપ્પમ<sup class="red">૨૩૪</sup>
                                        </a>
                                        ને 
                                        <a class="recipe" data-id="R0235" href="?id=R0235" sup-id="">
                                            ખીચડો<sup class="red">૨૩૫</sup>
                                        </a>
                                        વળી, અન્ન<sub class="text-[10px]">૦</sub>
                                        <span class="text-12 invisible">૦૦૦</span>
                                    </p>
                                    <p>
                                        <a class="recipe" data-id="R0236" href="?id=R0236" sup-id="">
                                            દાલવડાં<sup class="red">૨૩૬</sup>
                                        </a>
                                        <a class="recipe" data-id="R0237" href="?id=R0237" sup-id="">
                                            બટેકાવડાં<sup class="red">૨૩૭</sup>
                                        </a>
                                        , અન્ન<sub class="text-[10px]">૦</sub>
                                        <span class="text-12 invisible lg:hidden inline-box">૦૦૦</span>
                                        <br class="lg:hidden"/>
                                        <a class="ingredient" data-id="I0228" href="?id=I0228" sup-id="">
                                            રતાળુ<sup class="red">૨૩૮</sup>
                                        </a>
                                        ને 
                                        <a class="recipe" data-id="R0239" href="?id=R0239" sup-id="">
                                            દેસાઈવડાં<sup class="red">૨૩૯</sup>
                                        </a>
                                        , અન્ન<sub class="text-[10px]">૦</sub>
                                        <span class="text-12 inline-box">૦૫૦</span>
                                    </p>
                                    <p>
                                        <a class="recipe" data-id="R0240" href="?id=R0240" sup-id="">
                                            કાજુવડાં<sup class="red">૨૪૦</sup>
                                        </a>
                                        <a class="recipe" data-id="R0241" href="?id=R0241" sup-id="">
                                            ડાકોરનાં ગોટાં<sup class="red">૨૪૧</sup>
                                        </a>
                                        , અન્ન<sub class="text-[10px]">૦</sub>
                                        <span class="text-12 invisible lg:hidden inline-box">૦૦૦</span>
                                        <br class="lg:hidden"/>
                                        <a class="recipe" data-id="R0242" href="?id=R0242" sup-id="">
                                            આખા મરચાંનાં ભજિયાં<sup class="red">૨૪૨</sup>
                                        </a>
                                        મોટાં, અન્ન<sub class="text-[10px]">૦</sub>
                                        <span class="text-12 invisible">૦૦૦</span>
                                    </p>
                                    <p>
                                        <a class="recipe" data-id="R0243" href="?id=R0243" sup-id="">
                                            વેજિટેબલનાં છે ભજિયાં<sup class="red">૨૪૩</sup>
                                        </a>
                                        , અન્ન<sub class="text-[10px]">૦</sub>
                                        <span class="text-12 invisible lg:hidden inline-box">૦૦૦</span>
                                        <br class="lg:hidden"/>
                                        <a class="recipe" data-id="R0244" href="?id=R0244" sup-id="R0244">
                                            મેથીનાં<sup class="red">૨૪૪</sup>
                                        </a>
                                        તથા 
                                        <a class="recipe" data-id="R0245" href="?id=R0245" sup-id="">
                                            કુંભણિયાં<sup class="red">૨૪૫</sup>
                                        </a>
                                        , અન્ન<sub class="text-[10px]">૦</sub>
                                        <span class="text-12 inline-box">૦૫૧</span>
                                    </p>
                                    <p>
                                        <a class="recipe" data-id="R0246" href="?id=R0246" sup-id="">
                                            કેળાં ભજિયાં<sup class="red">૨૪૬</sup>
                                        </a>
                                        <a class="recipe" data-id="R0247" href="?id=R0247" sup-id="">
                                            માખણ ભજિયાં<sup class="red">૨૪૭</sup>
                                        </a>
                                        , અન્ન<sub class="text-[10px]">૦</sub>
                                        <span class="text-12 invisible lg:hidden inline-box">૦૦૦</span>
                                        <br class="lg:hidden"/>
                                        જમો 
                                        <a class="recipe" data-id="R0248" href="?id=R0248" sup-id="">
                                            આખા ટમેટાનાં ભજિયાં<sup class="red">૨૪૮</sup>
                                        </a>
                                        , અન્ન<sub class="text-[10px]">૦</sub>
                                        <span class="text-12 invisible">૦૦૦</span>
                                    </p>
                                    <p>
                                        <a class="recipe" data-id="R0249" href="?id=R0249" sup-id="">
                                            બ્રેડ ભજિયાં<sup class="red">૨૪૯</sup>
                                        </a>
                                        <a class="recipe" data-id="R0250" href="?id=R0250" sup-id="">
                                            પાલખ ભજિયાં<sup class="red">૨૫૦</sup>
                                        </a>
                                        , અન્ન<sub class="text-[10px]">૦</sub>
                                        <span class="text-12 invisible lg:hidden inline-box">૦૦૦</span>
                                        <br class="lg:hidden"/>
                                        <a class="recipe" data-id="R0251" href="?id=R0251" sup-id="R0251">
                                            ગલકાં<sup class="red">૨૫૧</sup>
                                        </a>
                                        ને 
                                        <a class="recipe" data-id="R0252" href="?id=R0252" sup-id="">
                                            મકાઈ ભજિયાં<sup class="red">૨૫૨</sup>
                                        </a>
                                        , અન્ન<sub class="text-[10px]">૦</sub>
                                        <span class="text-12 inline-box">૦૫૨</span>
                                    </p>
                                    <p>
                                        જમો 
                                        <a class="recipe" data-id="R0253" href="?id=R0253" sup-id="">
                                            ભજિયાં આ અજમાનાં<sup class="red">૨૫૩</sup>
                                        </a>
                                        , અન્ન<sub class="text-[10px]">૦</sub>
                                        <span class="text-12 invisible lg:hidden inline-box">૦૦૦</span>
                                        <br class="lg:hidden"/>
                                        વળી 
                                        <a class="recipe" data-id="R0254" href="?id=R0254" sup-id="">
                                            ભજિયાં છે રીંગણાનાં<sup class="red">૨૫૪</sup>
                                        </a>
                                        , અન્ન<sub class="text-[10px]">૦</sub>
                                        <span class="text-12 invisible">૦૦૦</span>
                                    </p>
                                    <p>
                                        <a class="recipe" data-id="R0255" href="?id=R0255" sup-id="">
                                            પોઈપાનનાં છે ભજિયાં<sup class="red">૨૫૫</sup>
                                        </a>
                                        , અન્ન<sub class="text-[10px]">૦</sub>
                                        <span class="text-12 invisible lg:hidden inline-box">૦૦૦</span>
                                        <br class="lg:hidden"/>
                                        <a class="recipe" data-id="R0256" href="?id=R0256" sup-id="">
                                            પટ્ટીભજિયાં<sup class="red">૨૫૬</sup>
                                        </a>
                                        <a class="recipe" data-id="R0257" href="?id=R0257" sup-id="">
                                            અળવીનાં ભજિયાં<sup class="red">૨૫૭</sup>
                                        </a>
                                        , અન્ન<sub class="text-[10px]">૦</sub>
                                        <span class="text-12 inline-box">૦૫૩</span>
                                    </p>
                                    <p>
                                        <a class="recipe" data-id="R0258" href="?id=R0258" sup-id="">
                                            મારવાડી મરચાં<sup class="red">૨૫૮</sup>
                                        </a>
                                        સારાં, અન્ન<sub class="text-[10px]">૦</sub>
                                        <span class="text-12 invisible lg:hidden inline-box">૦૦૦</span>
                                        <br class="lg:hidden"/>
                                        <a class="recipe" data-id="R0259" href="?id=R0259" sup-id="">
                                            જમો બટેકાપૂરી<sup class="red">૨૫૯</sup>
                                        </a>
                                        પ્યારા, અન્ન<sub class="text-[10px]">૦</sub>
                                        <span class="text-12 invisible">૦૦૦</span>
                                    </p>
                                    <p>
                                        જમો 
                                        <a class="recipe" data-id="R0260" href="?id=R0260" sup-id="R0260">
                                            હાંડવો<sup class="red">૨૬૦</sup>
                                        </a>
                                        વેજિટેબલ, અન્ન<sub class="text-[10px]">૦</sub>
                                        <span class="text-12 invisible lg:hidden inline-box">૦૦૦</span>
                                        <br class="lg:hidden"/>
                                        વળી 
                                        <a class="recipe" data-id="R0261" href="?id=R0261" sup-id="">
                                            ડંગેલા<sup class="red">૨૬૧</sup>
                                        </a>
                                        <a class="recipe" data-id="R0262" href="?id=R0262" sup-id="R0262">
                                            ઘૂઘરા<sup class="red">૨૬૨</sup>
                                        </a>
                                        અવલ, અન્ન<sub class="text-[10px]">૦</sub>
                                        <span class="text-12 inline-box">૦૫૪</span>
                                    </p>
                                    <p>
                                        <a class="recipe" data-id="R0263" href="?id=R0263" sup-id="">
                                            પાંઉ ગાંઠિયા<sup class="red">૨૬૩</sup>
                                        </a>
                                        <a class="recipe" data-id="R0264" href="?id=R0264" sup-id="">
                                            ભાજીકોન<sup class="red">૨૬૪</sup>
                                        </a>
                                        , અન્ન<sub class="text-[10px]">૦</sub>
                                        <span class="text-12 invisible lg:hidden inline-box">૦૦૦</span>
                                        <br class="lg:hidden"/>
                                        <a class="recipe" data-id="R0265" href="?id=R0265" sup-id="">
                                            મકાઈ ભેળ<sup class="red">૨૬૫</sup>
                                        </a>
                                        <a class="recipe" data-id="R0266" href="?id=R0266" sup-id="">
                                            ચટપટા કોન<sup class="red">૨૬૬</sup>
                                        </a>
                                        , અન્ન<sub class="text-[10px]">૦</sub>
                                        <span class="text-12 invisible">૦૦૦</span>
                                    </p>
                                    <p>
                                        <a class="recipe" data-id="R0267" href="?id=R0267" sup-id="">
                                            પાપડરોલ<sup class="red">૨૬૭</sup>
                                        </a>
                                        <a class="recipe" data-id="R0268" href="?id=R0268" sup-id="">
                                            પુના મિસળ<sup class="red">૨૬૮</sup>
                                        </a>
                                        , અન્ન<sub class="text-[10px]">૦</sub>
                                        <span class="text-12 invisible lg:hidden inline-box">૦૦૦</span>
                                        <br class="lg:hidden"/>
                                        <a class="recipe" data-id="R0269" href="?id=R0269" sup-id="">
                                            પનિયારમ<sup class="red">૨૬૯</sup>
                                        </a>
                                        છે નિરમળ, અન્ન<sub class="text-[10px]">૦</sub>
                                        <span class="text-12 inline-box">૦૫૫</span>
                                    </p>
                                    <p>
                                        <a class="recipe" data-id="R0270" href="?id=R0270" sup-id="">
                                            ગળવાણું<sup class="red">૨૭૦</sup>
                                        </a>
                                        ને 
                                        <a class="recipe" data-id="R0271" href="?id=R0271" sup-id="">
                                            દિલખુશ<sup class="red">૨૭૧</sup>
                                        </a>
                                        , અન્ન<sub class="text-[10px]">૦</sub>
                                        <span class="text-12 invisible lg:hidden inline-box">૦૦૦</span>
                                        <br class="lg:hidden"/>
                                        જમો દિલ થઈ જાશે ખુશ, અન્ન<sub class="text-[10px]">૦</sub>
                                        <span class="text-12 invisible">૦૦૦</span>
                                    </p>
                                    <p>
                                        <a class="recipe" data-id="R0272" href="?id=R0272" sup-id="">
                                            સેવખમણી<sup class="red">૨૭૨</sup>
                                        </a>
                                        <a class="recipe" data-id="R0273" href="?id=R0273" sup-id="">
                                            બટેકાપૌંઆ<sup class="red">૨૭૩</sup>
                                        </a>
                                        , અન્ન<sub class="text-[10px]">૦</sub>
                                        <span class="text-12 invisible lg:hidden inline-box">૦૦૦</span>
                                        <br class="lg:hidden"/>
                                        આવ્યાં નરનારી સૌ જોવાં, અન્ન<sub class="text-[10px]">૦</sub>
                                        <span class="text-12 inline-box">૦૫૬</span>
                                    </p>
                                    <h3>સૂકું ફરસાણ</h3>
                                    <p>
                                        <a class="recipe" data-id="R0274" href="?id=R0274" sup-id="">
                                            ચેવડો શીંગ અને પૌંઆનો<sup class="red">૨૭૪</sup>
                                        </a>
                                        , અન્ન<sub class="text-[10px]">૦</sub>
                                        <span class="text-12 invisible lg:hidden inline-box">૦૦૦</span>
                                        <br class="lg:hidden"/>
                                        <a class="recipe" data-id="R0275" href="?id=R0275" sup-id="">
                                            ચેવડો પૌંઆ ને મમરાનો<sup class="red">૨૭૫</sup>
                                        </a>
                                        , અન્ન<sub class="text-[10px]">૦</sub>
                                        <span class="text-12 invisible">૦૦૦</span>
                                    </p>
                                    <p>
                                        <a class="recipe" data-id="R0276" href="?id=R0276" sup-id="">
                                            વળી ચેવડો વટાણાનો<sup class="red">૨૭૬</sup>
                                        </a>
                                        , અન્ન<sub class="text-[10px]">૦</sub>
                                        <span class="text-12 invisible lg:hidden inline-box">૦૦૦</span>
                                        <br class="lg:hidden"/>
                                        જમો 
                                        <a class="recipe" data-id="R0277" href="?id=R0277" sup-id="">
                                            ચેવડો બટેકાનો<sup class="red">૨૭૭</sup>
                                        </a>
                                        , અન્ન<sub class="text-[10px]">૦</sub>
                                        <span class="text-12 inline-box">૦૫૭</span>
                                    </p>
                                    <p>
                                        <a class="recipe" data-id="R0278" href="?id=R0278" sup-id="">
                                            ચેવડો મકાઈનો સારો<sup class="red">૨૭૮</sup>
                                        </a>
                                        , અન્ન<sub class="text-[10px]">૦</sub>
                                        <span class="text-12 invisible lg:hidden inline-box">૦૦૦</span>
                                        <br class="lg:hidden"/>
                                        <a class="recipe" data-id="R0279" href="?id=R0279" sup-id="">
                                            ઘઉં પૌંઆનો<sup class="red">૨૭૯</sup>
                                        </a>
                                        છે ન્યારો, અન્ન<sub class="text-[10px]">૦</sub>
                                        <span class="text-12 invisible">૦૦૦</span>
                                    </p>
                                    <p>
                                        <a class="recipe" data-id="R0280" href="?id=R0280" sup-id="">
                                            વાલા જમજો લીલો ચેવડો<sup class="red">૨૮૦</sup>
                                        </a>
                                        , અન્ન<sub class="text-[10px]">૦</sub>
                                        <span class="text-12 invisible lg:hidden inline-box">૦૦૦</span>
                                        <br class="lg:hidden"/>
                                        <a class="recipe" data-id="R0281" href="?id=R0281" sup-id="">
                                            પાપડ-પૌંઆનો ચેવડો<sup class="red">૨૮૧</sup>
                                        </a>
                                        , અન્ન<sub class="text-[10px]">૦</sub>
                                        <span class="text-12 inline-box">૦૫૮</span>
                                    </p>
                                    <p>
                                        <a class="recipe" data-id="R0282" href="?id=R0282" sup-id="">
                                            આખા ઘઉંનો છે ચેવડો<sup class="red">૨૮૨</sup>
                                        </a>
                                        , અન્ન<sub class="text-[10px]">૦</sub>
                                        <span class="text-12 invisible lg:hidden inline-box">૦૦૦</span>
                                        <br class="lg:hidden"/>
                                        વહાલા જમો 
                                        <a class="recipe" data-id="R0283" href="?id=R0283" sup-id="">
                                            નાયલોન ચેવડો<sup class="red">૨૮૩</sup>
                                        </a>
                                        , અન્ન<sub class="text-[10px]">૦</sub>
                                        <span class="text-12 invisible">૦૦૦</span>
                                    </p>
                                    <p>
                                        જમો વિધવિધ આ ચવાણાં, અન્ન<sub class="text-[10px]">૦</sub>
                                        <span class="text-12 invisible lg:hidden inline-box">૦૦૦</span>
                                        <br class="lg:hidden"/>
                                        અમે ગાઈએ તમારાં ગાણાં, અન્ન<sub class="text-[10px]">૦</sub>
                                        <span class="text-12 inline-box">૦૫૯</span>
                                    </p>
                                    <p>
                                        પ્યારું 
                                        <a class="recipe" data-id="R0284" href="?id=R0284" sup-id="">
                                            નડિયાદી ચવાણું<sup class="red">૨૮૪</sup>
                                        </a>
                                        , અન્ન<sub class="text-[10px]">૦</sub>
                                        <span class="text-12 invisible lg:hidden inline-box">૦૦૦</span>
                                        <br class="lg:hidden"/>
                                        <a class="recipe" data-id="R0285" href="?id=R0285" sup-id="">
                                            સુરતી ભૂસું<sup class="red">૨૮૫</sup>
                                        </a>
                                        ને 
                                        <a class="recipe" data-id="R0286" href="?id=R0286" sup-id="">
                                            ચવાણું<sup class="red">૨૮૬</sup>
                                        </a>
                                        , અન્ન<sub class="text-[10px]">૦</sub>
                                        <span class="text-12 invisible">૦૦૦</span>
                                    </p>
                                    <p>
                                        <a class="recipe" data-id="R0287" href="?id=R0287" sup-id="R0287">
                                            મકાઈના પૌંઆ<sup class="red">૨૮૭</sup>
                                        </a>
                                        સારા, અન્ન<sub class="text-[10px]">૦</sub>
                                        <span class="text-12 invisible lg:hidden inline-box">૦૦૦</span>
                                        <br class="lg:hidden"/>
                                        <a class="recipe" data-id="R0288" href="?id=R0288" sup-id="">
                                            મોળા ગાંઠિયા<sup class="red">૨૮૮</sup>
                                        </a>
                                        જમો પ્યારા, અન્ન<sub class="text-[10px]">૦</sub>
                                        <span class="text-12 inline-box">૦૬૦</span>
                                    </p>
                                    <p>
                                        જમો 
                                        <a class="recipe" data-id="R0289" href="?id=R0289" sup-id="">
                                            ભાવનગરી આ ગાંઠિયા<sup class="red">૨૮૯</sup>
                                        </a>
                                        , અન્ન<sub class="text-[10px]">૦</sub>
                                        <span class="text-12 invisible lg:hidden inline-box">૦૦૦</span>
                                        <br class="lg:hidden"/>
                                        વળી જમજો 
                                        <a class="recipe" data-id="R0290" href="?id=R0290" sup-id="">
                                            તીખા ગાંઠિયા<sup class="red">૨૯૦</sup>
                                        </a>
                                        , અન્ન<sub class="text-[10px]">૦</sub>
                                        <span class="text-12 invisible">૦૦૦</span>
                                    </p>
                                    <p>
                                        વાલા જમો 
                                        <a class="recipe" data-id="R0291" href="?id=R0291" sup-id="">
                                            વણેલા ગાંઠિયા<sup class="red">૨૯૧</sup>
                                        </a>
                                        , અન્ન<sub class="text-[10px]">૦</sub>
                                        <span class="text-12 invisible lg:hidden inline-box">૦૦૦</span>
                                        <br class="lg:hidden"/>
                                        વળી છે 
                                        <a class="recipe" data-id="R0292" href="?id=R0292" sup-id="">
                                            ચંપાકલી ગાંઠિયા<sup class="red">૨૯૨</sup>
                                        </a>
                                        , અન્ન<sub class="text-[10px]">૦</sub>
                                        <span class="text-12 inline-box">૦૬૧</span>
                                    </p>
                                    <p>
                                        <a class="recipe" data-id="R0293" href="?id=R0293" sup-id="">
                                            ચંદનકચોરી<sup class="red">૨૯૩</sup>
                                        </a>
                                        <a class="recipe" data-id="R0294" href="?id=R0294" sup-id="">
                                            ચીઝ ખાખરા<sup class="red">૨૯૪</sup>
                                        </a>
                                        , અન્ન<sub class="text-[10px]">૦</sub>
                                        <span class="text-12 invisible lg:hidden inline-box">૦૦૦</span>
                                        <br class="lg:hidden"/>
                                        વળી છે 
                                        <a class="recipe" data-id="R0295" href="?id=R0295" sup-id="">
                                            તળેલા ખાખરા<sup class="red">૨૯૫</sup>
                                        </a>
                                        , અન્ન<sub class="text-[10px]">૦</sub>
                                        <span class="text-12 invisible">૦૦૦</span>
                                    </p>
                                    <p>
                                        છે આ 
                                        <a class="recipe" data-id="R0296" href="?id=R0296" sup-id="">
                                            સાદા ખાખરા સારા<sup class="red">૨૯૬</sup>
                                        </a>
                                        , અન્ન<sub class="text-[10px]">૦</sub>
                                        <span class="text-12 invisible lg:hidden inline-box">૦૦૦</span>
                                        <br class="lg:hidden"/>
                                        છે 
                                        <a class="recipe" data-id="R0297" href="?id=R0297" sup-id="R0297">
                                            મેથીના<sup class="red">૨૯૭</sup>
                                        </a>
                                        પણ ન્યારા, અન્ન<sub class="text-[10px]">૦</sub>
                                        <span class="text-12 inline-box">૦૬૨</span>
                                    </p>
                                    <p>
                                        છે 
                                        <a class="recipe" data-id="R0298" href="?id=R0298" sup-id="">
                                            મસાલા ખાખરા<sup class="red">૨૯૮</sup>
                                        </a>
                                        પ્યારા, અન્ન<sub class="text-[10px]">૦</sub>
                                        <span class="text-12 invisible lg:hidden inline-box">૦૦૦</span>
                                        <br class="lg:hidden"/>
                                        તમે જમોને ભક્તિદુલારા, અન્ન<sub class="text-[10px]">૦</sub>
                                        <span class="text-12 invisible">૦૦૦</span>
                                    </p>
                                    <p>
                                        જમો પ્યારી 
                                        <a class="recipe" data-id="R0299" href="?id=R0299" sup-id="">
                                            ટોમેટો વેફર<sup class="red">૨૯૯</sup>
                                        </a>
                                        , અન્ન<sub class="text-[10px]">૦</sub>
                                        <span class="text-12 invisible lg:hidden inline-box">૦૦૦</span>
                                        <br class="lg:hidden"/>
                                        <a class="recipe" data-id="R0300" href="?id=R0300" sup-id="">
                                            સૂરણની<sup class="red">૩૦૦</sup>
                                        </a>
                                        <a class="recipe" data-id="R0301" href="?id=R0301" sup-id="">
                                            બટેકાની વેફર<sup class="red">૩૦૧</sup>
                                        </a>
                                        , અન્ન<sub class="text-[10px]">૦</sub>
                                        <span class="text-12 inline-box">૦૬૩</span>
                                    </p>
                                    <p>
                                        <a class="recipe" data-id="R0302" href="?id=R0302" sup-id="">
                                            કેળાની છે ક્રિસ્પી વેફર<sup class="red">૩૦૨</sup>
                                        </a>
                                        , અન્ન<sub class="text-[10px]">૦</sub>
                                        <span class="text-12 invisible lg:hidden inline-box">૦૦૦</span>
                                        <br class="lg:hidden"/>
                                        તમે જમોને 
                                        <a class="recipe" data-id="R0303" href="?id=R0303" sup-id="">
                                            રતાળુ વેફર<sup class="red">૩૦૩</sup>
                                        </a>
                                        , અન્ન<sub class="text-[10px]">૦</sub>
                                        <span class="text-12 invisible">૦૦૦</span>
                                    </p>
                                    <p>
                                        <a class="recipe" data-id="R0304" href="?id=R0304" sup-id="">
                                            સેવ આલુ<sup class="red">૩૦૪</sup>
                                        </a>
                                        ને 
                                        <a class="recipe" data-id="R0305" href="?id=R0305" sup-id="">
                                            બિકાનેરી<sup class="red">૩૦૫</sup>
                                        </a>
                                        , અન્ન<sub class="text-[10px]">૦</sub>
                                        <span class="text-12 invisible lg:hidden inline-box">૦૦૦</span>
                                        <br class="lg:hidden"/>
                                        <a class="recipe" data-id="R0306" href="?id=R0306" sup-id="">
                                            સેવ ટોમેટો<sup class="red">૩૦૬</sup>
                                        </a>
                                        અનેરી, અન્ન<sub class="text-[10px]">૦</sub>
                                        <span class="text-12 inline-box">૦૬૪</span>
                                    </p>
                                    <p>
                                        <a class="recipe" data-id="R0307" href="?id=R0307" sup-id="">
                                            સેવ સાદી<sup class="red">૩૦૭</sup>
                                        </a>
                                        <a class="recipe" data-id="R0308" href="?id=R0308" sup-id="">
                                            સેવ રતલામી<sup class="red">૩૦૮</sup>
                                        </a>
                                        , અન્ન<sub class="text-[10px]">૦</sub>
                                        <span class="text-12 invisible lg:hidden inline-box">૦૦૦</span>
                                        <br class="lg:hidden"/>
                                        <a class="recipe" data-id="R0309" href="?id=R0309" sup-id="">
                                            સેવ પાલખની<sup class="red">૩૦૯</sup>
                                        </a>
                                        જમો સ્વામી, અન્ન<sub class="text-[10px]">૦</sub>
                                        <span class="text-12 invisible">૦૦૦</span>
                                    </p>
                                    <p>
                                        <a class="recipe" data-id="R0310" href="?id=R0310" sup-id="R0310">
                                            મગદાળ<sup class="red">૩૧૦</sup>
                                        </a>
                                        <a class="recipe" data-id="R0311" href="?id=R0311" sup-id="">
                                            ચણાદાળ<sup class="red">૩૧૧</sup>
                                        </a>
                                        , અન્ન<sub class="text-[10px]">૦</sub>
                                        <span class="text-12 invisible lg:hidden inline-box">૦૦૦</span>
                                        <br class="lg:hidden"/>
                                        જમો 
                                        <a class="ingredient" data-id="I0184" href="?id=I0184" sup-id="">
                                            વટાણા<sup class="red">૩૧૨</sup>
                                        </a>
                                        છે દયાળ, અન્ન<sub class="text-[10px]">૦</sub>
                                        <span class="text-12 inline-box">૦૬૫</span>
                                    </p>
                                    <p>
                                        <a class="recipe" data-id="R0313" href="?id=R0313" sup-id="">
                                            દાલમૂઠ<sup class="red">૩૧૩</sup>
                                        </a>
                                        <a class="recipe" data-id="R0314" href="?id=R0314" sup-id="">
                                            ચોળાફળી<sup class="red">૩૧૪</sup>
                                        </a>
                                        , અન્ન<sub class="text-[10px]">૦</sub>
                                        <span class="text-12 invisible lg:hidden inline-box">૦૦૦</span>
                                        <br class="lg:hidden"/>
                                        <a class="recipe" data-id="R0315" href="?id=R0315" sup-id="">
                                            દહીંથરા<sup class="red">૩૧૫</sup>
                                        </a>
                                        <a class="recipe" data-id="R0316" href="?id=R0316" sup-id="">
                                            સુંવાળી<sup class="red">૩૧૬</sup>
                                        </a>
                                        વળી, અન્ન<sub class="text-[10px]">૦</sub>
                                        <span class="text-12 invisible">૦૦૦</span>
                                    </p>
                                    <p>
                                        <a class="recipe" data-id="R0317" href="?id=R0317" sup-id="">
                                            ચકરી<sup class="red">૩૧૭</sup>
                                        </a>
                                        <a class="recipe" data-id="R0318" href="?id=R0318" sup-id="">
                                            ટમટમ<sup class="red">૩૧૮</sup>
                                        </a>
                                        <a class="recipe" data-id="R0319" href="?id=R0319" sup-id="">
                                            ભાખરવડી<sup class="red">૩૧૯</sup>
                                        </a>
                                        , અન્ન<sub class="text-[10px]">૦</sub>
                                        <span class="text-12 invisible lg:hidden inline-box">૦૦૦</span>
                                        <br class="lg:hidden"/>
                                        <a class="recipe" data-id="R0320" href="?id=R0320" sup-id="">
                                            ફાફડા<sup class="red">૩૨૦</sup>
                                        </a>
                                        <a class="recipe" data-id="R0321" href="?id=R0321" sup-id="">
                                            ફાફડી<sup class="red">૩૨૧</sup>
                                        </a>
                                        <a class="recipe" data-id="R0322" href="?id=R0322" sup-id="">
                                            ફૂલવડી<sup class="red">૩૨૨</sup>
                                        </a>
                                        , અન્ન<sub class="text-[10px]">૦</sub>
                                        <span class="text-12 inline-box">૦૬૬</span>
                                    </p>
                                    <p>
                                        <a class="recipe" data-id="R0323" href="?id=R0323" sup-id="">
                                            અડદ મઠનાં<sup class="red">૩૨3</sup>
                                        </a>
                                        છે મઠિયાં, અન્ન<sub class="text-[10px]">૦</sub>
                                        <span class="text-12 invisible lg:hidden inline-box">૦૦૦</span>
                                        <br class="lg:hidden"/>
                                        <a class="recipe" data-id="R0324" href="?id=R0324" sup-id="">
                                            ફરસીપૂરી<sup class="red">૩૨4</sup>
                                        </a>
                                        ને 
                                        <a class="recipe" data-id="R0325" href="?id=R0325" sup-id="">
                                            શીંગભજિયાં<sup class="red">૩૨૫</sup>
                                        </a>
                                        , અન્ન<sub class="text-[10px]">૦</sub>
                                        <span class="text-12 invisible">૦૦૦</span>
                                    </p>
                                    <p>
                                        <a class="recipe" data-id="R0326" href="?id=R0326" sup-id="R0326">
                                            તીખા<sup class="red">૩૨૬</sup>
                                        </a>
                                        <a class="recipe" data-id="R0327" href="?id=R0327" sup-id="">
                                            ગળ્યા<sup class="red">૩૨૭</sup>
                                        </a>
                                        સક્કરપારા, અન્ન<sub class="text-[10px]">૦</sub>
                                        <span class="text-12 invisible lg:hidden inline-box">૦૦૦</span>
                                        <br class="lg:hidden"/>
                                        <a class="recipe" data-id="R0328" href="?id=R0328" sup-id="">
                                            તીખી બુંદી<sup class="red">૩૨૮</sup>
                                        </a>
                                        <a class="recipe" data-id="R0329" href="?id=R0329" sup-id="">
                                            ખાજલી<sup class="red">૩૨૯</sup>
                                        </a>
                                        પ્યારા, અન્ન<sub class="text-[10px]">૦</sub>
                                        <span class="text-12 inline-box">૦૬૭</span>
                                    </p>
                                    <p>
                                        <a class="recipe" data-id="R0330" href="?id=R0330" sup-id="">
                                            ચનાજોરગરમ<sup class="red">૩૩૦</sup>
                                        </a>
                                        હરિવરા, અન્ન<sub class="text-[10px]">૦</sub>
                                        <span class="text-12 invisible lg:hidden inline-box">૦૦૦</span>
                                        <br class="lg:hidden"/>
                                        જમો 
                                        <a class="recipe" data-id="R0331" href="?id=R0331" sup-id="">
                                            સોયાસ્ટિક<sup class="red">૩૩૧</sup>
                                        </a>
                                        <a class="recipe" data-id="R0332" href="?id=R0332" sup-id="">
                                            સેવમમરા<sup class="red">૩૩૨</sup>
                                        </a>
                                        , અન્ન<sub class="text-[10px]">૦</sub>
                                        <span class="text-12 invisible">૦૦૦</span>
                                    </p>
                                    <p>
                                        જમો 
                                        <a class="recipe" data-id="R0333" href="?id=R0333" sup-id="">
                                            પ્રેટ્ઝેલ બાઇટ્સ<sup class="red">૩૩૩</sup>
                                        </a>
                                        ન્યારા, અન્ન<sub class="text-[10px]">૦</sub>
                                        <span class="text-12 invisible lg:hidden inline-box">૦૦૦</span>
                                        <br class="lg:hidden"/>
                                        ખૂબ જમજો મારા પ્યારા, અન્ન<sub class="text-[10px]">૦</sub>
                                        <span class="text-12 inline-box">૦૬૮</span>
                                    </p>
                                    <p>
                                        <a class="recipe" data-id="R0334" href="?id=R0334" sup-id="R0334">
                                            રાજગરા<sup class="red">૩૩૪</sup>
                                        </a>
                                        <a class="recipe" data-id="R0335" href="?id=R0335" sup-id="R0335">
                                            મકાઈની<sup class="red">૩૩૫</sup>
                                        </a>
                                        ધાણી, અન્ન<sub class="text-[10px]">૦</sub>
                                        <span class="text-12 invisible lg:hidden inline-box">૦૦૦</span>
                                        <br class="lg:hidden"/>
                                        વળી જમો 
                                        <a class="recipe" data-id="R0336" href="?id=R0336" sup-id="">
                                            જુવારની ધાણી<sup class="red">૩૩૬</sup>
                                        </a>
                                        , અન્ન<sub class="text-[10px]">૦</sub>
                                        <span class="text-12 invisible">૦૦૦</span>
                                    </p>
                                    <h3>રોટલી-રોટલા</h3>
                                    <p>
                                        જમો રોટલીઓ સુખકારી, અન્ન<sub class="text-[10px]">૦</sub>
                                        <span class="text-12 invisible lg:hidden inline-box">૦૦૦</span>
                                        <br class="lg:hidden"/>
                                        વિધવિધ બનાવી છે સારી, અન્ન<sub class="text-[10px]">૦</sub>
                                        <span class="text-12 inline-box">૦૬૯</span>
                                    </p>
                                    <p>
                                        <a class="recipe" data-id="R0337" href="?id=R0337" sup-id="">
                                            સાદી રોટલી<sup class="red">૩૩૭</sup>
                                        </a>
                                        <a class="recipe" data-id="R0338" href="?id=R0338" sup-id="">
                                            ફૂલકા<sup class="red">૩૩૮</sup>
                                        </a>
                                        સારા, અન્ન<sub class="text-[10px]">૦</sub>
                                        <span class="text-12 invisible lg:hidden inline-box">૦૦૦</span>
                                        <br class="lg:hidden"/>
                                        જમો 
                                        <a class="recipe" data-id="R0339" href="?id=R0339" sup-id="">
                                            બે પડવાળી<sup class="red">૩૩૯</sup>
                                        </a>
                                        પ્યારા, અન્ન<sub class="text-[10px]">૦</sub>
                                        <span class="text-12 invisible">૦૦૦</span>
                                    </p>
                                    <p>
                                        <a class="recipe" data-id="R0340" href="?id=R0340" sup-id="">
                                            સાતપડી રોટલી<sup class="red">૩૪૦</sup>
                                        </a>
                                        <a class="recipe" data-id="R0341" href="?id=R0341" sup-id="R0341">
                                            મસાલા<sup class="red">૩૪૧</sup>
                                        </a>
                                        , અન્ન<sub class="text-[10px]">૦</sub>
                                        <span class="text-12 invisible lg:hidden inline-box">૦૦૦</span>
                                        <br class="lg:hidden"/>
                                        જમો 
                                        <a class="recipe" data-id="R0342" href="?id=R0342" sup-id="R0342">
                                            બાજરાની<sup class="red">૩૪૨</sup>
                                        </a>
                                        પણ વ્હાલા, અન્ન<sub class="text-[10px]">૦</sub>
                                        <span class="text-12 inline-box">૦૭૦</span>
                                    </p>
                                    <p>
                                        <a class="recipe" data-id="R0343" href="?id=R0343" sup-id="">
                                            રોટલી રૂમાલી<sup class="red">૩૪૩</sup>
                                        </a>
                                        <a class="recipe" data-id="R0344" href="?id=R0344" sup-id="R0344">
                                            જુવારની<sup class="red">૩૪૪</sup>
                                        </a>
                                        , અન્ન<sub class="text-[10px]">૦</sub>
                                        <span class="text-12 invisible lg:hidden inline-box">૦૦૦</span>
                                        <br class="lg:hidden"/>
                                        <a class="recipe" data-id="R0345" href="?id=R0345" sup-id="">
                                            રોટલી કુલચા<sup class="red">૩૪૫</sup>
                                        </a>
                                        <a class="recipe" data-id="R0346" href="?id=R0346" sup-id="">
                                            તંદુરની<sup class="red">૩૪૬</sup>
                                        </a>
                                        , અન્ન<sub class="text-[10px]">૦</sub>
                                        <span class="text-12 invisible">૦૦૦</span>
                                    </p>
                                    <p>
                                        <a class="recipe" data-id="R0347" href="?id=R0347" sup-id="">
                                            મીસી રોટલી<sup class="red">૩૪૭</sup>
                                        </a>
                                        <a class="recipe" data-id="R0348" href="?id=R0348" sup-id="">
                                            ખુરમો<sup class="red">૩૪૮</sup>
                                        </a>
                                        નાથ, અન્ન<sub class="text-[10px]">૦</sub>
                                        <span class="text-12 invisible lg:hidden inline-box">૦૦૦</span>
                                        <br class="lg:hidden"/>
                                        કરી 
                                        <a class="recipe" data-id="R0349" href="?id=R0349" sup-id="">
                                            જવની<sup class="red">૩૪૯</sup>
                                        </a>
                                        રોટલી મેં હાથ, અન્ન<sub class="text-[10px]">૦</sub>
                                        <span class="text-12 inline-box">૦૭૧</span>
                                    </p>
                                    <p>
                                        જમો 
                                        <a class="recipe" data-id="R0350" href="?id=R0350" sup-id="">
                                            રોટલીનાં પપૂડાં<sup class="red">૩૫૦</sup>
                                        </a>
                                        , અન્ન<sub class="text-[10px]">૦</sub>
                                        <span class="text-12 invisible lg:hidden inline-box">૦૦૦</span>
                                        <br class="lg:hidden"/>
                                        ઘી સાકર નાખેલાં રૂડાં, અન્ન<sub class="text-[10px]">૦</sub>
                                        <span class="text-12 invisible">૦૦૦</span>
                                    </p>
                                    <p>
                                        <a class="ingredient" data-id="I0154" href="?id=I0154" sup-id="">
                                            મેથી<sup class="red">૩૫૧</sup>
                                        </a>
                                        <a class="recipe" data-id="R0352" href="?id=R0352" sup-id="R0352">
                                            બંટી<sup class="red">૩૫૨</sup>
                                        </a>
                                        <a class="recipe" data-id="R0353" href="?id=R0353" sup-id="R0353">
                                            બાજરા<sup class="red">૩૫૩</sup>
                                        </a>
                                        રોટલા, અન્ન<sub class="text-[10px]">૦</sub>
                                        <span class="text-12 invisible lg:hidden inline-box">૦૦૦</span>
                                        <br class="lg:hidden"/>
                                        <a class="recipe" data-id="R0354" href="?id=R0354" sup-id="R0354">
                                            જુવારના<sup class="red">૩૫૪</sup>
                                        </a>
                                        <a class="recipe" data-id="R0355" href="?id=R0355" sup-id="R0355">
                                            મકાઈના<sup class="red">૩૫૫</sup>
                                        </a>
                                        રોટલા, અન્ન<sub class="text-[10px]">૦</sub>
                                        <span class="text-12 inline-box">૦૭૨</span>
                                    </p>
                                    <p>
                                        <a class="recipe" data-id="R0356" href="?id=R0356" sup-id="">
                                            સાદી ભાખરી<sup class="red">૩૫૬</sup>
                                        </a>
                                        <a class="recipe" data-id="R0357" href="?id=R0357" sup-id="">
                                            ભાખરી મસાલા<sup class="red">૩૫૭</sup>
                                        </a>
                                        , અન્ન<sub class="text-[10px]">૦</sub>
                                        <span class="text-12 invisible lg:hidden inline-box">૦૦૦</span>
                                        <br class="lg:hidden"/>
                                        બહુ ઘી મોણવાળી વાલા, અન્ન<sub class="text-[10px]">૦</sub>
                                        <span class="text-12 invisible">૦૦૦</span>
                                    </p>
                                    <p>
                                        <a class="recipe" data-id="R0358" href="?id=R0358" sup-id="">
                                            મેથી ભાખરી<sup class="red">૩૫૮</sup>
                                        </a>
                                        <a class="recipe" data-id="R0359" href="?id=R0359" sup-id="">
                                            બદામ ભાખરી<sup class="red">૩૫૯</sup>
                                        </a>
                                        , અન્ન<sub class="text-[10px]">૦</sub>
                                        <span class="text-12 invisible lg:hidden inline-box">૦૦૦</span>
                                        <br class="lg:hidden"/>
                                        ખાંતે જમજો મારા હરિ, અન્ન<sub class="text-[10px]">૦</sub>
                                        <span class="text-12 inline-box">૦૭૩</span>
                                    </p>
                                    <p>
                                        <a class="recipe" data-id="R0360" href="?id=R0360" sup-id="">
                                            સાદી પૂરી<sup class="red">૩૬૦</sup>
                                        </a>
                                        <a class="recipe" data-id="R0361" href="?id=R0361" sup-id="">
                                            ગળી પૂરી<sup class="red">૩૬૧</sup>
                                        </a>
                                        , અન્ન<sub class="text-[10px]">૦</sub>
                                        <span class="text-12 invisible lg:hidden inline-box">૦૦૦</span>
                                        <br class="lg:hidden"/>
                                        વળી 
                                        <a class="recipe" data-id="R0362" href="?id=R0362" sup-id="">
                                            ભટુરા<sup class="red">૩૬૨</sup>
                                        </a>
                                        <a class="recipe" data-id="R0363" href="?id=R0363" sup-id="">
                                            આલુ પૂરી<sup class="red">૩૬૩</sup>
                                        </a>
                                        , અન્ન<sub class="text-[10px]">૦</sub>
                                        <span class="text-12 invisible">૦૦૦</span>
                                    </p>
                                    <p>
                                        <a class="recipe" data-id="R0364" href="?id=R0364" sup-id="">
                                            પૂરી પાલખની<sup class="red">૩૬૪</sup>
                                        </a>
                                        ને 
                                        <a class="recipe" data-id="R0365" href="?id=R0365" sup-id="">
                                            રવાની<sup class="red">૩૬૫</sup>
                                        </a>
                                        , અન્ન<sub class="text-[10px]">૦</sub>
                                        <span class="text-12 invisible lg:hidden inline-box">૦૦૦</span>
                                        <br class="lg:hidden"/>
                                        <a class="recipe" data-id="R0366" href="?id=R0366" sup-id="">
                                            પૂરી મસાલાવાળી<sup class="red">૩૬૬</sup>
                                        </a>
                                        નાની, અન્ન<sub class="text-[10px]">૦</sub>
                                        <span class="text-12 inline-box">૦૭૪</span>
                                    </p>
                                    <p>
                                        <a class="recipe" data-id="R0367" href="?id=R0367" sup-id="">
                                            રાજગરા-મોરૈયાની પૂરી<sup class="red">૩૬૭</sup>
                                        </a>
                                        , અન્ન<sub class="text-[10px]">૦</sub>
                                        <span class="text-12 invisible lg:hidden inline-box">૦૦૦</span>
                                        <br class="lg:hidden"/>
                                        જમો 
                                        <a class="recipe" data-id="R0368" href="?id=R0368" sup-id="">
                                            મકાઈ પૂડલાં<sup class="red">૩૬૮</sup>
                                        </a>
                                        મુરારી, અન્ન<sub class="text-[10px]">૦</sub>
                                        <span class="text-12 invisible">૦૦૦</span>
                                    </p>
                                    <p>
                                        <a class="recipe" data-id="R0369" href="?id=R0369" sup-id="">
                                            ગળ્યાં પૂડલાં<sup class="red">૩૬૯</sup>
                                        </a>
                                        <a class="recipe" data-id="R0370" href="?id=R0370" sup-id="">
                                            તીખાં પૂડલાં<sup class="red">૩૭૦</sup>
                                        </a>
                                        , અન્ન<sub class="text-[10px]">૦</sub>
                                        <span class="text-12 invisible lg:hidden inline-box">૦૦૦</span>
                                        <br class="lg:hidden"/>
                                        <a class="recipe" data-id="R0371" href="?id=R0371" sup-id="">
                                            મગ પૂડલાં<sup class="red">૩૭૧</sup>
                                        </a>
                                        <a class="recipe" data-id="R0372" href="?id=R0372" sup-id="">
                                            ટોમેટો પૂડલાં<sup class="red">૩૭૨</sup>
                                        </a>
                                        , અન્ન<sub class="text-[10px]">૦</sub>
                                        <span class="text-12 inline-box">૦૭૫</span>
                                    </p>
                                    <p>
                                        <a class="recipe" data-id="R0373" href="?id=R0373" sup-id="">
                                            થેપલાં દૂધીનાં<sup class="red">૩૭૩</sup>
                                        </a>
                                        <a class="recipe" data-id="R0374" href="?id=R0374" sup-id="R0374">
                                            મેથીનાં<sup class="red">૩૭૪</sup>
                                        </a>
                                        , અન્ન<sub class="text-[10px]">૦</sub>
                                        <span class="text-12 invisible lg:hidden inline-box">૦૦૦</span>
                                        <br class="lg:hidden"/>
                                        <a class="recipe" data-id="R0375" href="?id=R0375" sup-id="">
                                            સાદાં થેપલાં<sup class="red">૩૭૫</sup>
                                        </a>
                                        ઘીથી ભીનાં, અન્ન<sub class="text-[10px]">૦</sub>
                                        <span class="text-12 invisible">૦૦૦</span>
                                    </p>
                                    <p>
                                        પ્યારા લાવી ગરમ પરોઠાં, અન્ન<sub class="text-[10px]">૦</sub>
                                        <span class="text-12 invisible lg:hidden inline-box">૦૦૦</span>
                                        <br class="lg:hidden"/>
                                        <a class="recipe" data-id="R0376" href="?id=R0376" sup-id="">
                                            મિક્સ વેજિટેબલ પરોઠાં<sup class="red">૩૭૬</sup>
                                        </a>
                                        , અન્ન<sub class="text-[10px]">૦</sub>
                                        <span class="text-12 inline-box">૦૭૬</span>
                                    </p>
                                    <p>
                                        <a class="recipe" data-id="R0377" href="?id=R0377" sup-id="">
                                            સાદાં પરોઠાં<sup class="red">૩૭૭</sup>
                                        </a>
                                        <a class="recipe" data-id="R0378" href="?id=R0378" sup-id="">
                                            ચીઝ પરોઠાં<sup class="red">૩૭૮</sup>
                                        </a>
                                        , અન્ન<sub class="text-[10px]">૦</sub>
                                        <span class="text-12 invisible lg:hidden inline-box">૦૦૦</span>
                                        <br class="lg:hidden"/>
                                        <a class="recipe" data-id="R0379" href="?id=R0379" sup-id="">
                                            કોબી પરોઠાં<sup class="red">૩૭૯</sup>
                                        </a>
                                        <a class="recipe" data-id="R0380" href="?id=R0380" sup-id="">
                                            આલુ પરોઠાં<sup class="red">૩૮૦</sup>
                                        </a>
                                        , અન્ન<sub class="text-[10px]">૦</sub>
                                        <span class="text-12 invisible">૦૦૦</span>
                                    </p>
                                    <p>
                                        <a class="recipe" data-id="R0381" href="?id=R0381" sup-id="">
                                            બટર પરોઠાં<sup class="red">૩૮૧</sup>
                                        </a>
                                        <a class="recipe" data-id="R0382" href="?id=R0382" sup-id="">
                                            મટર પરોઠાં<sup class="red">૩૮૨</sup>
                                        </a>
                                        , અન્ન<sub class="text-[10px]">૦</sub>
                                        <span class="text-12 invisible lg:hidden inline-box">૦૦૦</span>
                                        <br class="lg:hidden"/>
                                        <a class="recipe" data-id="R0383" href="?id=R0383" sup-id="">
                                            મેથી પરોઠાં<sup class="red">૩૮૩</sup>
                                        </a>
                                        <a class="recipe" data-id="R0384" href="?id=R0384" sup-id="">
                                            પનીર પરોઠાં<sup class="red">૩૮૪</sup>
                                        </a>
                                        , અન્ન<sub class="text-[10px]">૦</sub>
                                        <span class="text-12 inline-box">૦૭૭</span>
                                    </p>
                                    <p>
                                        <a class="ingredient" data-id="I0152" href="?id=I0152" sup-id="">
                                            મૂળા<sup class="red">૩૮૫</sup>
                                        </a>
                                        ને 
                                        <a class="recipe" data-id="R0386" href="?id=R0386" sup-id="">
                                            ટોમેટો પરોઠાં<sup class="red">૩૮૬</sup>
                                        </a>
                                        , અન્ન<sub class="text-[10px]">૦</sub>
                                        <span class="text-12 invisible lg:hidden inline-box">૦૦૦</span>
                                        <br class="lg:hidden"/>
                                        <a class="recipe" data-id="R0387" href="?id=R0387" sup-id="">
                                            લચ્છા પરોઠાં<sup class="red">૩૮૭</sup>
                                        </a>
                                        <a class="recipe" data-id="R0388" href="?id=R0388" sup-id="">
                                            પાલખ પરોઠાં<sup class="red">૩૮૮</sup>
                                        </a>
                                        , અન્ન<sub class="text-[10px]">૦</sub>
                                        <span class="text-12 invisible">૦૦૦</span>
                                    </p>
                                    <p>
                                        <a class="recipe" data-id="R0389" href="?id=R0389" sup-id="">
                                            ચીઝ નાન<sup class="red">૩૮૯</sup>
                                        </a>
                                        ને 
                                        <a class="recipe" data-id="R0390" href="?id=R0390" sup-id="">
                                            બટર નાન<sup class="red">૩૯૦</sup>
                                        </a>
                                        , અન્ન<sub class="text-[10px]">૦</sub>
                                        <span class="text-12 invisible lg:hidden inline-box">૦૦૦</span>
                                        <br class="lg:hidden"/>
                                        <a class="recipe" data-id="R0391" href="?id=R0391" sup-id="">
                                            લચ્છા નાન<sup class="red">૩૯૧</sup>
                                        </a>
                                        ને 
                                        <a class="recipe" data-id="R0392" href="?id=R0392" sup-id="">
                                            સાદી નાન<sup class="red">૩૯૨</sup>
                                        </a>
                                        , અન્ન<sub class="text-[10px]">૦</sub>
                                        <span class="text-12 inline-box">૦૭૮</span>
                                    </p>
                                    <h3>વિવિધ શાક</h3>
                                    <p>
                                        જમો ગુજરાતી શાક વ્હાલા, અન્ન<sub class="text-[10px]">૦</sub>
                                        <span class="text-12 invisible lg:hidden inline-box">૦૦૦</span>
                                        <br class="lg:hidden"/>
                                        એમાં નાખ્યા બહુ મસાલા, અન્ન<sub class="text-[10px]">૦</sub>
                                        <span class="text-12 invisible">૦૦૦</span>
                                    </p>
                                    <p>
                                        એવાં શાક ગણાવું વાલા, અન્ન<sub class="text-[10px]">૦</sub>
                                        <span class="text-12 invisible lg:hidden inline-box">૦૦૦</span>
                                        <br class="lg:hidden"/>
                                        તમે જમોને ભક્તિના લાલા, અન્ન<sub class="text-[10px]">૦</sub>
                                        <span class="text-12 inline-box">૦૭૯</span>
                                    </p>
                                    <p>
                                        શાક 
                                        <a class="recipe" data-id="R0393" href="?id=R0393" sup-id="">
                                            ભરેલાં રીંગણાંનું<sup class="red">૩૯૩</sup>
                                        </a>
                                        , અન્ન<sub class="text-[10px]">૦</sub>
                                        <span class="text-12 invisible lg:hidden inline-box">૦૦૦</span>
                                        <br class="lg:hidden"/>
                                        વળી 
                                        <a class="recipe" data-id="R0394" href="?id=R0394" sup-id="">
                                            રીંગણાં-વટાણાનું<sup class="red">૩૯૪</sup>
                                        </a>
                                        , અન્ન<sub class="text-[10px]">૦</sub>
                                        <span class="text-12 invisible">૦૦૦</span>
                                    </p>
                                    <p>
                                        શાક 
                                        <a class="recipe" data-id="R0395" href="?id=R0395" sup-id="">
                                            રીંગણાં-બટેકાંનું<sup class="red">૩૯૫</sup>
                                        </a>
                                        , અન્ન<sub class="text-[10px]">૦</sub>
                                        <span class="text-12 invisible lg:hidden inline-box">૦૦૦</span>
                                        <br class="lg:hidden"/>
                                        શાક 
                                        <a class="recipe" data-id="R0396" href="?id=R0396" sup-id="">
                                            કેવળ બટેકાનું<sup class="red">૩૯૬</sup>
                                        </a>
                                        , અન્ન<sub class="text-[10px]">૦</sub>
                                        <span class="text-12 inline-box">૦૮૦</span>
                                    </p>
                                    <p>
                                        <a class="recipe" data-id="R0397" href="?id=R0397" sup-id="">
                                            બટેકાની સૂકીભાજી<sup class="red">૩૯૭</sup>
                                        </a>
                                        , અન્ન<sub class="text-[10px]">૦</sub>
                                        <span class="text-12 invisible lg:hidden inline-box">૦૦૦</span>
                                        <br class="lg:hidden"/>
                                        તમે જમજો થઈને રાજી, અન્ન<sub class="text-[10px]">૦</sub>
                                        <span class="text-12 invisible">૦૦૦</span>
                                    </p>
                                    <p>
                                        શાક 
                                        <a class="recipe" data-id="R0398" href="?id=R0398" sup-id="">
                                            બટેકા-વટાણાનું<sup class="red">૩૯૮</sup>
                                        </a>
                                        , અન્ન<sub class="text-[10px]">૦</sub>
                                        <span class="text-12 invisible lg:hidden inline-box">૦૦૦</span>
                                        <br class="lg:hidden"/>
                                        વળી 
                                        <a class="recipe" data-id="R0399" href="?id=R0399" sup-id="">
                                            તુવેર ને રીંગણાંનું<sup class="red">૩૯૯</sup>
                                        </a>
                                        , અન્ન<sub class="text-[10px]">૦</sub>
                                        <span class="text-12 inline-box">૦૮૧</span>
                                    </p>
                                    <p>
                                        <a class="recipe" data-id="R0400" href="?id=R0400" sup-id="">
                                            કોબી-વટાણા<sup class="red">૪૦૦</sup>
                                        </a>
                                        ને 
                                        <a class="recipe" data-id="R0401" href="?id=R0401" sup-id="R0401">
                                            ફુલેવર<sup class="red">૪૦૧</sup>
                                        </a>
                                        , અન્ન<sub class="text-[10px]">૦</sub>
                                        <span class="text-12 invisible lg:hidden inline-box">૦૦૦</span>
                                        <br class="lg:hidden"/>
                                        <a class="recipe" data-id="R0402" href="?id=R0402" sup-id="R0402">
                                            ગુવાર<sup class="red">૪૦૨</sup>
                                        </a>
                                        <a class="recipe" data-id="R0403" href="?id=R0403" sup-id="R0403">
                                            ગલકાં<sup class="red">૪૦૩</sup>
                                        </a>
                                        ને 
                                        <a class="recipe" data-id="R0404" href="?id=R0404" sup-id="R0404">
                                            ગાજર<sup class="red">૪૦૪</sup>
                                        </a>
                                        , અન્ન<sub class="text-[10px]">૦</sub>
                                        <span class="text-12 invisible">૦૦૦</span>
                                    </p>
                                    <p>
                                        <a class="recipe" data-id="R0405" href="?id=R0405" sup-id="">
                                            ઊંબાડિયું<sup class="red">૪૦૫</sup>
                                        </a>
                                        ને 
                                        <a class="recipe" data-id="R0406" href="?id=R0406" sup-id="">
                                            ગૂંદાં ભરેલાં<sup class="red">૪૦૬</sup>
                                        </a>
                                        , અન્ન<sub class="text-[10px]">૦</sub>
                                        <span class="text-12 invisible lg:hidden inline-box">૦૦૦</span>
                                        <br class="lg:hidden"/>
                                        <a class="recipe" data-id="R0407" href="?id=R0407" sup-id="R0407">
                                            મરિયા<sup class="red">૪૦૭</sup>
                                        </a>
                                        જમોને રંગના રેલા, અન્ન<sub class="text-[10px]">૦</sub>
                                        <span class="text-12 inline-box">૦૮૨</span>
                                    </p>
                                    <p>
                                        <a class="recipe" data-id="R0408" href="?id=R0408" sup-id="R0408">
                                            પરવળ<sup class="red">૪૦૮</sup>
                                        </a>
                                        <a class="recipe" data-id="R0409" href="?id=R0409" sup-id="">
                                            વટાણા-ગાજર<sup class="red">૪૦૯</sup>
                                        </a>
                                        , અન્ન<sub class="text-[10px]">૦</sub>
                                        <span class="text-12 invisible lg:hidden inline-box">૦૦૦</span>
                                        <br class="lg:hidden"/>
                                        <a class="recipe" data-id="R0410" href="?id=R0410" sup-id="R0410">
                                            દૂધી<sup class="red">૪૧૦</sup>
                                        </a>
                                        <a class="recipe" data-id="R0411" href="?id=R0411" sup-id="">
                                            વટાણા-ફુલેવર<sup class="red">૪૧૧</sup>
                                        </a>
                                        , અન્ન<sub class="text-[10px]">૦</sub>
                                        <span class="text-12 invisible">૦૦૦</span>
                                    </p>
                                    <p>
                                        <a class="recipe" data-id="R0412" href="?id=R0412" sup-id="">
                                            કાચી કેરીનું<sup class="red">૪૧૨</sup>
                                        </a>
                                        શુભ શાક, અન્ન<sub class="text-[10px]">૦</sub>
                                        <span class="text-12 invisible lg:hidden inline-box">૦૦૦</span>
                                        <br class="lg:hidden"/>
                                        <a class="recipe" data-id="R0413" href="?id=R0413" sup-id="">
                                            કાજુ-ગાંઠિયાનું<sup class="red">૪૧૩</sup>
                                        </a>
                                        પણ શાક, અન્ન<sub class="text-[10px]">૦</sub>
                                        <span class="text-12 inline-box">૦૮૩</span>
                                    </p>
                                    <p>
                                        જમો 
                                        <a class="recipe" data-id="R0414" href="?id=R0414" sup-id="">
                                            બ્રોકોલીનું<sup class="red">૪૧૪</sup>
                                        </a>
                                        આ શાક, અન્ન<sub class="text-[10px]">૦</sub>
                                        <span class="text-12 invisible lg:hidden inline-box">૦૦૦</span>
                                        <br class="lg:hidden"/>
                                        <a class="recipe" data-id="R0415" href="?id=R0415" sup-id="">
                                            ગુવાર-ઢોકળીનું<sup class="red">૪૧૫</sup>
                                        </a>
                                        શાક, અન્ન<sub class="text-[10px]">૦</sub>
                                        <span class="text-12 invisible">૦૦૦</span>
                                    </p>
                                    <p>
                                        વળી 
                                        <a class="recipe" data-id="R0416" href="?id=R0416" sup-id="">
                                            દૂધી-ચણાની દાળ<sup class="red">૪૧૬</sup>
                                        </a>
                                        , અન્ન<sub class="text-[10px]">૦</sub>
                                        <span class="text-12 invisible lg:hidden inline-box">૦૦૦</span>
                                        <br class="lg:hidden"/>
                                        શાક 
                                        <a class="recipe" data-id="R0417" href="?id=R0417" sup-id="">
                                            તૂરિયાંનું<sup class="red">૪૧૭</sup>
                                        </a>
                                        રસાળ, અન્ન<sub class="text-[10px]">૦</sub>
                                        <span class="text-12 inline-box">૦૮૪</span>
                                    </p>
                                    <p>
                                        શાક 
                                        <a class="recipe" data-id="R0418" href="?id=R0418" sup-id="">
                                            તળેલું ભીંડાનું<sup class="red">૪૧૮</sup>
                                        </a>
                                        , અન્ન<sub class="text-[10px]">૦</sub>
                                        <span class="text-12 invisible lg:hidden inline-box">૦૦૦</span>
                                        <br class="lg:hidden"/>
                                        વળી 
                                        <a class="recipe" data-id="R0419" href="?id=R0419" sup-id="">
                                            ભરેલા ભીંડાનું<sup class="red">૪૧૯</sup>
                                        </a>
                                        , અન્ન<sub class="text-[10px]">૦</sub>
                                        <span class="text-12 invisible">૦૦૦</span>
                                    </p>
                                    <p>
                                        શાક છે 
                                        <a class="recipe" data-id="R0420" href="?id=R0420" sup-id="">
                                            તૂરિયાં-પાતરાનું<sup class="red">૪૨૦</sup>
                                        </a>
                                        , અન્ન<sub class="text-[10px]">૦</sub>
                                        <span class="text-12 invisible lg:hidden inline-box">૦૦૦</span>
                                        <br class="lg:hidden"/>
                                        <a class="recipe" data-id="R0421" href="?id=R0421" sup-id="">
                                            મૂળાનું<sup class="red">૪૨૧</sup>
                                        </a>
                                        <a class="recipe" data-id="R0422" href="?id=R0422" sup-id="">
                                            મગ-તૂરિયાંનું<sup class="red">૪૨૨</sup>
                                        </a>
                                        , અન્ન<sub class="text-[10px]">૦</sub>
                                        <span class="text-12 inline-box">૦૮૫</span>
                                    </p>
                                    <p>
                                        જમો 
                                        <a class="recipe" data-id="R0423" href="?id=R0423" sup-id="">
                                            ભીંડાના સંભારિયા<sup class="red">૪૨૩</sup>
                                        </a>
                                        , અન્ન<sub class="text-[10px]">૦</sub>
                                        <span class="text-12 invisible lg:hidden inline-box">૦૦૦</span>
                                        <br class="lg:hidden"/>
                                        જમો 
                                        <a class="recipe" data-id="R0424" href="?id=R0424" sup-id="">
                                            સૂરણનું<sup class="red">૪૨૪</sup>
                                        </a>
                                        સુખદૈયા, અન્ન<sub class="text-[10px]">૦</sub>
                                        <span class="text-12 invisible">૦૦૦</span>
                                    </p>
                                    <p>
                                        શાક 
                                        <a class="recipe" data-id="R0425" href="?id=R0425" sup-id="">
                                            કાજુ-કારેલાંનું<sup class="red">૪૨૫</sup>
                                        </a>
                                        , અન્ન<sub class="text-[10px]">૦</sub>
                                        <span class="text-12 invisible lg:hidden inline-box">૦૦૦</span>
                                        <br class="lg:hidden"/>
                                        <a class="recipe" data-id="R0426" href="?id=R0426" sup-id="">
                                            કંકોડાંનું<sup class="red">૪૨૬</sup>
                                        </a>
                                        <a class="recipe" data-id="R0427" href="?id=R0427" sup-id="">
                                            કારેલાંનું<sup class="red">૪૨૭</sup>
                                        </a>
                                        , અન્ન<sub class="text-[10px]">૦</sub>
                                        <span class="text-12 inline-box">૦૮૬</span>
                                    </p>
                                    <p>
                                        શાક છે 
                                        <a class="recipe" data-id="R0428" href="?id=R0428" sup-id="">
                                            સેવ-ટમેટાંનું<sup class="red">૪૨૮</sup>
                                        </a>
                                        , અન્ન<sub class="text-[10px]">૦</sub>
                                        <span class="text-12 invisible lg:hidden inline-box">૦૦૦</span>
                                        <br class="lg:hidden"/>
                                        <a class="recipe" data-id="R0429" href="?id=R0429" sup-id="">
                                            રતાળુનું<sup class="red">૪૨૯</sup>
                                        </a>
                                        <a class="recipe" data-id="R0430" href="?id=R0430" sup-id="">
                                            ટીંડોરાંનું<sup class="red">૪૩૦</sup>
                                        </a>
                                        , અન્ન<sub class="text-[10px]">૦</sub>
                                        <span class="text-12 invisible">૦૦૦</span>
                                    </p>
                                    <p>
                                        શાક સારું 
                                        <a class="recipe" data-id="R0431" href="?id=R0431" sup-id="">
                                            સરગવાનું<sup class="red">૪૩૧</sup>
                                        </a>
                                        , અન્ન<sub class="text-[10px]">૦</sub>
                                        <span class="text-12 invisible lg:hidden inline-box">૦૦૦</span>
                                        <br class="lg:hidden"/>
                                        <a class="recipe" data-id="R0432" href="?id=R0432" sup-id="">
                                            પાકાં ચીભડાંનું<sup class="red">૪૩૨</sup>
                                        </a>
                                        <a class="recipe" data-id="R0433" href="?id=R0433" sup-id="">
                                            ગાંઠિયાનું<sup class="red">૪૩૩</sup>
                                        </a>
                                        , અન્ન<sub class="text-[10px]">૦</sub>
                                        <span class="text-12 inline-box">૦૮૭</span>
                                    </p>
                                    <p>
                                        શાક 
                                        <a class="recipe" data-id="R0434" href="?id=R0434" sup-id="">
                                            વાલોળનું<sup class="red">૪૩૪</sup>
                                        </a>
                                        <a class="recipe" data-id="R0435" href="?id=R0435" sup-id="">
                                            પાપડીનું<sup class="red">૪૩૫</sup>
                                        </a>
                                        , અન્ન<sub class="text-[10px]">૦</sub>
                                        <span class="text-12 invisible lg:hidden inline-box">૦૦૦</span>
                                        <br class="lg:hidden"/>
                                        શાક 
                                        <a class="recipe" data-id="R0436" href="?id=R0436" sup-id="">
                                            ગાજર ને ફણસીનું<sup class="red">૪૩૬</sup>
                                        </a>
                                        , અન્ન<sub class="text-[10px]">૦</sub>
                                        <span class="text-12 invisible">૦૦૦</span>
                                    </p>
                                    <p>
                                        શાક 
                                        <a class="recipe" data-id="R0437" href="?id=R0437" sup-id="R0437">
                                            ફણસ<sup class="red">૪૩૭</sup>
                                        </a>
                                        ને 
                                        <a class="recipe" data-id="R0438" href="?id=R0438" sup-id="">
                                            પંચકુટિયું<sup class="red">૪૩૮</sup>
                                        </a>
                                        , અન્ન<sub class="text-[10px]">૦</sub>
                                        <span class="text-12 invisible lg:hidden inline-box">૦૦૦</span>
                                        <br class="lg:hidden"/>
                                        <a class="recipe" data-id="R0439" href="?id=R0439" sup-id="">
                                            શક્કરિયાનું<sup class="red">૪૩૯</sup>
                                        </a>
                                        ને 
                                        <a class="recipe" data-id="R0440" href="?id=R0440" sup-id="">
                                            ઊંધિયું<sup class="red">૪૪૦</sup>
                                        </a>
                                        , અન્ન<sub class="text-[10px]">૦</sub>
                                        <span class="text-12 inline-box">૦૮૮</span>
                                    </p>
                                    <p>
                                        શાક 
                                        <a class="recipe" data-id="R0441" href="?id=R0441" sup-id="">
                                            ઢોકળી<sup class="red">૪૪૧</sup>
                                        </a>
                                        <a class="recipe" data-id="R0442" href="?id=R0442" sup-id="">
                                            મકાઈનો દાણો<sup class="red">૪૪૨</sup>
                                        </a>
                                        , અન્ન<sub class="text-[10px]">૦</sub>
                                        <span class="text-12 invisible lg:hidden inline-box">૦૦૦</span>
                                        <br class="lg:hidden"/>
                                        <a class="recipe" data-id="R0443" href="?id=R0443" sup-id="">
                                            રીંગણાંનું ભડથું<sup class="red">૪૪૩</sup>
                                        </a>
                                        માણો, અન્ન<sub class="text-[10px]">૦</sub>
                                        <span class="text-12 invisible">૦૦૦</span>
                                    </p>
                                    <p>
                                        <a class="recipe" data-id="R0444" href="?id=R0444" sup-id="">
                                            ઓળો દૂધીનો<sup class="red">૪૪૪</sup>
                                        </a>
                                        સુખધામ, અન્ન<sub class="text-[10px]">૦</sub>
                                        <span class="text-12 invisible lg:hidden inline-box">૦૦૦</span>
                                        <br class="lg:hidden"/>
                                        અતિ ભાવે જમો ઘનશ્યામ, અન્ન<sub class="text-[10px]">૦</sub>
                                        <span class="text-12 inline-box">૦૮૯</span>
                                    </p>
                                    <p>
                                        શાક 
                                        <a class="recipe" data-id="R0445" href="?id=R0445" sup-id="">
                                            વડીનું<sup class="red">૪૪૫</sup>
                                        </a>
                                        સ્વાદિષ્ટ, અન્ન<sub class="text-[10px]">૦</sub>
                                        <span class="text-12 invisible lg:hidden inline-box">૦૦૦</span>
                                        <br class="lg:hidden"/>
                                        જમો 
                                        <a class="recipe" data-id="R0446" href="?id=R0446" sup-id="">
                                            કોળાંનું<sup class="red">૪૪૬</sup>
                                        </a>
                                        મારા ઇષ્ટ, અન્ન<sub class="text-[10px]">૦</sub>
                                        <span class="text-12 invisible">૦૦૦</span>
                                    </p>
                                    <p>
                                        શાક 
                                        <a class="recipe" data-id="R0447" href="?id=R0447" sup-id="">
                                            ટીનસાંનું<sup class="red">૪૪૭</sup>
                                        </a>
                                        છે સારું, અન્ન<sub class="text-[10px]">૦</sub>
                                        <span class="text-12 invisible lg:hidden inline-box">૦૦૦</span>
                                        <br class="lg:hidden"/>
                                        જમો લાગશે તમને પ્યારું, અન્ન<sub class="text-[10px]">૦</sub>
                                        <span class="text-12 inline-box">૦૯૦</span>
                                    </p>
                                    <p>
                                        રૂડું 
                                        <a class="recipe" data-id="R0448" href="?id=R0448" sup-id="">
                                            ઝુમખડીનું શાક<sup class="red">૪૪૮</sup>
                                        </a>
                                        , અન્ન<sub class="text-[10px]">૦</sub>
                                        <span class="text-12 invisible lg:hidden inline-box">૦૦૦</span>
                                        <br class="lg:hidden"/>
                                        જન જમે તજીને પાક, અન્ન<sub class="text-[10px]">૦</sub>
                                        <span class="text-12 invisible">૦૦૦</span>
                                    </p>
                                    <p>
                                        <a class="recipe" data-id="R0449" href="?id=R0449" sup-id="R0449">
                                            કાચાં<sup class="red">૪૪૯</sup>
                                        </a>
                                        <a class="recipe" data-id="R0450" href="?id=R0450" sup-id="R0450">
                                            પાકાં<sup class="red">૪૫૦</sup>
                                        </a>
                                        કેળાંનું શાક, અન્ન<sub class="text-[10px]">૦</sub>
                                        <span class="text-12 invisible lg:hidden inline-box">૦૦૦</span>
                                        <br class="lg:hidden"/>
                                        <a class="recipe" data-id="R0451" href="?id=R0451" sup-id="">
                                            ઝૂકીનીનું<sup class="red">૪૫૧</sup>
                                        </a>
                                        અદ્ભુત શાક, અન્ન<sub class="text-[10px]">૦</sub>
                                        <span class="text-12 inline-box">૦૯૧</span>
                                    </p>
                                    <p>
                                        રૂડી 
                                        <a class="recipe" data-id="R0452" href="?id=R0452" sup-id="">
                                            ભાજી છે મેથીની<sup class="red">૪૫૨</sup>
                                        </a>
                                        , અન્ન<sub class="text-[10px]">૦</sub>
                                        <span class="text-12 invisible lg:hidden inline-box">૦૦૦</span>
                                        <br class="lg:hidden"/>
                                        <a class="recipe" data-id="R0453" href="?id=R0453" sup-id="">
                                            ભાજી પાલખની<sup class="red">૪૫૩</sup>
                                        </a>
                                        <a class="recipe" data-id="R0454" href="?id=R0454" sup-id="">
                                            લૂણીની<sup class="red">૪૫૪</sup>
                                        </a>
                                        , અન્ન<sub class="text-[10px]">૦</sub>
                                        <span class="text-12 invisible">૦૦૦</span>
                                    </p>
                                    <p>
                                        <a class="recipe" data-id="R0455" href="?id=R0455" sup-id="">
                                            મીઠી અજમાની<sup class="red">૪૫૫</sup>
                                        </a>
                                        છે ભાજી, અન્ન<sub class="text-[10px]">૦</sub>
                                        <span class="text-12 invisible lg:hidden inline-box">૦૦૦</span>
                                        <br class="lg:hidden"/>
                                        જમો 
                                        <a class="recipe" data-id="R0456" href="?id=R0456" sup-id="">
                                            સુવાની<sup class="red">૪૫૬</sup>
                                        </a>
                                        થઈ રાજી, અન્ન<sub class="text-[10px]">૦</sub>
                                        <span class="text-12 inline-box">૦૯૨</span>
                                    </p>
                                    <p>
                                        રૂડી 
                                        <a class="recipe" data-id="R0457" href="?id=R0457" sup-id="">
                                            ભાજી તાંદળજાની<sup class="red">૪૫૭</sup>
                                        </a>
                                        , અન્ન<sub class="text-[10px]">૦</sub>
                                        <span class="text-12 invisible lg:hidden inline-box">૦૦૦</span>
                                        <br class="lg:hidden"/>
                                        એવી 
                                        <a class="recipe" data-id="R0458" href="?id=R0458" sup-id="">
                                            ભાજી મૂળા<sup class="red">૪૫૮</sup>
                                        </a>
                                        આદિની, અન્ન<sub class="text-[10px]">૦</sub>
                                        <span class="text-12 invisible">૦૦૦</span>
                                    </p>
                                    <p>
                                        જમો શાક પંજાબી દયાળુ, અન્ન<sub class="text-[10px]">૦</sub>
                                        <span class="text-12 invisible lg:hidden inline-box">૦૦૦</span>
                                        <br class="lg:hidden"/>
                                        <a class="recipe" data-id="R0459" href="?id=R0459" sup-id="">
                                            મલાઈ કોફતા<sup class="red">૪૫૯</sup>
                                        </a>
                                        ને 
                                        <a class="recipe" data-id="R0460" href="?id=R0460" sup-id="">
                                            દમઆલુ<sup class="red">૪૬૦</sup>
                                        </a>
                                        , અન્ન<sub class="text-[10px]">૦</sub>
                                        <span class="text-12 inline-box">૦૯૩</span>
                                    </p>
                                    <p>
                                        <a class="recipe" data-id="R0461" href="?id=R0461" sup-id="">
                                            કોબી કોફતા<sup class="red">૪૬૧</sup>
                                        </a>
                                        <a class="recipe" data-id="R0462" href="?id=R0462" sup-id="">
                                            સૂરણ કોફતા<sup class="red">૪૬૨</sup>
                                        </a>
                                        , અન્ન<sub class="text-[10px]">૦</sub>
                                        <span class="text-12 invisible lg:hidden inline-box">૦૦૦</span>
                                        <br class="lg:hidden"/>
                                        <a class="recipe" data-id="R0463" href="?id=R0463" sup-id="">
                                            શાહી પનીર<sup class="red">૪૬૩</sup>
                                        </a>
                                        <a class="recipe" data-id="R0464" href="?id=R0464" sup-id="">
                                            દૂધી કોફતા<sup class="red">૪૬૪</sup>
                                        </a>
                                        , અન્ન<sub class="text-[10px]">૦</sub>
                                        <span class="text-12 invisible">૦૦૦</span>
                                    </p>
                                    <p>
                                        છે 
                                        <a class="recipe" data-id="R0465" href="?id=R0465" sup-id="">
                                            કાજુ-બટર મસાલા<sup class="red">૪૬૫</sup>
                                        </a>
                                        , અન્ન<sub class="text-[10px]">૦</sub>
                                        <span class="text-12 invisible lg:hidden inline-box">૦૦૦</span>
                                        <br class="lg:hidden"/>
                                        જમો 
                                        <a class="recipe" data-id="R0466" href="?id=R0466" sup-id="">
                                            પાલખ પનીર<sup class="red">૪૬૬</sup>
                                        </a>
                                        વ્હાલા, અન્ન<sub class="text-[10px]">૦</sub>
                                        <span class="text-12 inline-box">૦૯૪</span>
                                    </p>
                                    <p>
                                        <a class="recipe" data-id="R0467" href="?id=R0467" sup-id="">
                                            વેજિટેબલ મખ્ખનવાલા<sup class="red">૪૬૭</sup>
                                        </a>
                                        , અન્ન<sub class="text-[10px]">૦</sub>
                                        <span class="text-12 invisible lg:hidden inline-box">૦૦૦</span>
                                        <br class="lg:hidden"/>
                                        છે 
                                        <a class="recipe" data-id="R0468" href="?id=R0468" sup-id="">
                                            પનીર બટર મસાલા<sup class="red">૪૬૮</sup>
                                        </a>
                                        , અન્ન<sub class="text-[10px]">૦</sub>
                                        <span class="text-12 invisible">૦૦૦</span>
                                    </p>
                                    <p>
                                        <a class="recipe" data-id="R0469" href="?id=R0469" sup-id="">
                                            વેજિટેબલ છે જયપૂરી<sup class="red">૪૬૯</sup>
                                        </a>
                                        , અન્ન<sub class="text-[10px]">૦</sub>
                                        <span class="text-12 invisible lg:hidden inline-box">૦૦૦</span>
                                        <br class="lg:hidden"/>
                                        <a class="recipe" data-id="R0470" href="?id=R0470" sup-id="">
                                            વેજિટેબલ કોલાપૂરી<sup class="red">૪૭૦</sup>
                                        </a>
                                        , અન્ન<sub class="text-[10px]">૦</sub>
                                        <span class="text-12 inline-box">૦૯૫</span>
                                    </p>
                                    <p>
                                        <a class="recipe" data-id="R0471" href="?id=R0471" sup-id="">
                                            કાજુ કરી<sup class="red">૪૭૧</sup>
                                        </a>
                                        <a class="recipe" data-id="R0472" href="?id=R0472" sup-id="">
                                            તવાસબ્જી<sup class="red">૪૭૨</sup>
                                        </a>
                                        , અન્ન<sub class="text-[10px]">૦</sub>
                                        <span class="text-12 invisible lg:hidden inline-box">૦૦૦</span>
                                        <br class="lg:hidden"/>
                                        જમો 
                                        <a class="recipe" data-id="R0473" href="?id=R0473" sup-id="">
                                            વેજિટેબલ ક્રિસ્પી<sup class="red">૪૭૩</sup>
                                        </a>
                                        , અન્ન<sub class="text-[10px]">૦</sub>
                                        <span class="text-12 invisible">૦૦૦</span>
                                    </p>
                                    <p>
                                        <a class="recipe" data-id="R0474" href="?id=R0474" sup-id="">
                                            મિક્સ વેજિટેબલ ફ્રાય<sup class="red">૪૭૪</sup>
                                        </a>
                                        , અન્ન<sub class="text-[10px]">૦</sub>
                                        <span class="text-12 invisible lg:hidden inline-box">૦૦૦</span>
                                        <br class="lg:hidden"/>
                                        જમો જમોને મારા રાય, અન્ન<sub class="text-[10px]">૦</sub>
                                        <span class="text-12 inline-box">૦૯૬</span>
                                    </p>
                                    <p>
                                        જમો 
                                        <a class="recipe" data-id="R0475" href="?id=R0475" sup-id="">
                                            વેજિટેબલ કોરમા<sup class="red">૪૭૫</sup>
                                        </a>
                                        , અન્ન<sub class="text-[10px]">૦</sub>
                                        <span class="text-12 invisible lg:hidden inline-box">૦૦૦</span>
                                        <br class="lg:hidden"/>
                                        વળી છે 
                                        <a class="recipe" data-id="R0476" href="?id=R0476" sup-id="">
                                            નવરત્ન કોરમા<sup class="red">૪૭૬</sup>
                                        </a>
                                        , અન્ન<sub class="text-[10px]">૦</sub>
                                        <span class="text-12 invisible">૦૦૦</span>
                                    </p>
                                    <p>
                                        <a class="recipe" data-id="R0477" href="?id=R0477" sup-id="">
                                            પનીરટીકા<sup class="red">૪૭૭</sup>
                                        </a>
                                        <a class="recipe" data-id="R0478" href="?id=R0478" sup-id="">
                                            પનીરપસંદા<sup class="red">૪૭૮</sup>
                                        </a>
                                        , અન્ન<sub class="text-[10px]">૦</sub>
                                        <span class="text-12 invisible lg:hidden inline-box">૦૦૦</span>
                                        <br class="lg:hidden"/>
                                        <a class="recipe" data-id="R0479" href="?id=R0479" sup-id="">
                                            કાજુ ખોયા<sup class="red">૪૭૯</sup>
                                        </a>
                                        છે જગવંદા, અન્ન<sub class="text-[10px]">૦</sub>
                                        <span class="text-12 inline-box">૦૯૭</span>
                                    </p>
                                    <p>
                                        <a class="recipe" data-id="R0480" href="?id=R0480" sup-id="">
                                            સ્ટફ્ડ કેપ્સીકમ<sup class="red">૪૮૦</sup>
                                        </a>
                                        છે પ્યારા, અન્ન<sub class="text-[10px]">૦</sub>
                                        <span class="text-12 invisible lg:hidden inline-box">૦૦૦</span>
                                        <br class="lg:hidden"/>
                                        જમો 
                                        <a class="recipe" data-id="R0481" href="?id=R0481" sup-id="">
                                            સ્ટફ્ડ ટોમેટો<sup class="red">૪૮૧</sup>
                                        </a>
                                        ન્યારા, અન્ન<sub class="text-[10px]">૦</sub>
                                        <span class="text-12 invisible">૦૦૦</span>
                                    </p>
                                    <p>
                                        <a class="recipe" data-id="R0482" href="?id=R0482" sup-id="">
                                            દાલ મખની<sup class="red">૪૮૨</sup>
                                        </a>
                                        <a class="recipe" data-id="R0483" href="?id=R0483" sup-id="">
                                            પનીર ભૂરજી<sup class="red">૪૮૩</sup>
                                        </a>
                                        , અન્ન<sub class="text-[10px]">૦</sub>
                                        <span class="text-12 invisible lg:hidden inline-box">૦૦૦</span>
                                        <br class="lg:hidden"/>
                                        <a class="recipe" data-id="R0484" href="?id=R0484" sup-id="">
                                            મેથી બટર મસાલા<sup class="red">૪૮૪</sup>
                                        </a>
                                        હરજી, અન્ન<sub class="text-[10px]">૦</sub>
                                        <span class="text-12 inline-box">૦૯૮</span>
                                    </p>
                                    <p>
                                        <a class="recipe" data-id="R0485" href="?id=R0485" sup-id="">
                                            પનીર હાંડી<sup class="red">૪૮૫</sup>
                                        </a>
                                        <a class="recipe" data-id="R0486" href="?id=R0486" sup-id="">
                                            ખોયા મખ્ખન<sup class="red">૪૮૬</sup>
                                        </a>
                                        , અન્ન<sub class="text-[10px]">૦</sub>
                                        <span class="text-12 invisible lg:hidden inline-box">૦૦૦</span>
                                        <br class="lg:hidden"/>
                                        <a class="recipe" data-id="R0487" href="?id=R0487" sup-id="">
                                            થાઈકરી<sup class="red">૪૮૭</sup>
                                        </a>
                                        જમોને જીવન, અન્ન<sub class="text-[10px]">૦</sub>
                                        <span class="text-12 invisible">૦૦૦</span>
                                    </p>
                                    <p>
                                        જમો વિવિધ કઠોળ શ્યામ, અન્ન<sub class="text-[10px]">૦</sub>
                                        <span class="text-12 invisible lg:hidden inline-box">૦૦૦</span>
                                        <br class="lg:hidden"/>
                                        <a class="recipe" data-id="R0488" href="?id=R0488" sup-id="R0488">
                                            લીલા વટાણા<sup class="red">૪૮૮</sup>
                                        </a>
                                        સુખધામ, અન્ન<sub class="text-[10px]">૦</sub>
                                        <span class="text-12 inline-box">૦૯૯</span>
                                    </p>
                                    <p>
                                        <a class="recipe" data-id="R0489" href="?id=R0489" sup-id="R0489">
                                            મગ<sup class="red">૪૮૯</sup>
                                        </a>
                                        <a class="recipe" data-id="R0490" href="?id=R0490" sup-id="R0490">
                                            મઠ<sup class="red">૪૯૦</sup>
                                        </a>
                                        ને 
                                        <a class="recipe" data-id="R0491" href="?id=R0491" sup-id="R0491">
                                            છોલે ચણા<sup class="red">૪૯૧</sup>
                                        </a>
                                        , અન્ન<sub class="text-[10px]">૦</sub>
                                        <span class="text-12 invisible lg:hidden inline-box">૦૦૦</span>
                                        <br class="lg:hidden"/>
                                        <a class="recipe" data-id="R0492" href="?id=R0492" sup-id="">
                                            ચોળી<sup class="red">૪૯૨</sup>
                                        </a>
                                        <a class="recipe" data-id="R0493" href="?id=R0493" sup-id="R0493">
                                            ચોળા<sup class="red">૪૯૩</sup>
                                        </a>
                                        <a class="recipe" data-id="R0494" href="?id=R0494" sup-id="R0494">
                                            દેશી ચણા<sup class="red">૪૯૪</sup>
                                        </a>
                                        , અન્ન<sub class="text-[10px]">૦</sub>
                                        <span class="text-12 invisible">૦૦૦</span>
                                    </p>
                                    <p>
                                        <a class="recipe" data-id="R0495" href="?id=R0495" sup-id="R0495">
                                            વાલ<sup class="red">૪૯૫</sup>
                                        </a>
                                        <a class="recipe" data-id="R0496" href="?id=R0496" sup-id="R0496">
                                            અડદ<sup class="red">૪૯૬</sup>
                                        </a>
                                        ને 
                                        <a class="recipe" data-id="R0497" href="?id=R0497" sup-id="R0497">
                                            રાજમા<sup class="red">૪૯૭</sup>
                                        </a>
                                        , અન્ન<sub class="text-[10px]">૦</sub>
                                        <span class="text-12 invisible lg:hidden inline-box">૦૦૦</span>
                                        <br class="lg:hidden"/>
                                        <a class="recipe" data-id="R0498" href="?id=R0498" sup-id="R0498">
                                            મેથી<sup class="red">૪૯૮</sup>
                                        </a>
                                        <a class="recipe" data-id="R0499" href="?id=R0499" sup-id="">
                                            સોયાબીન<sup class="red">૪૯૯</sup>
                                        </a>
                                        વાલમા, અન્ન<sub class="text-[10px]">૦</sub>
                                        <span class="text-12 inline-box">૧૦૦</span>
                                    </p>
                                    <p>
                                        જમો 
                                        <a class="recipe" data-id="R0500" href="?id=R0500" sup-id="R0500">
                                            લીલી તુવેર<sup class="red">૫૦૦</sup>
                                        </a>
                                        પ્યારી, અન્ન<sub class="text-[10px]">૦</sub>
                                        <span class="text-12 invisible lg:hidden inline-box">૦૦૦</span>
                                        <br class="lg:hidden"/>
                                        <a class="recipe" data-id="R0501" href="?id=R0501" sup-id="R0501">
                                            મેથી<sup class="red">૫૦૧</sup>
                                        </a>
                                        ફણગાવેલી સારી, અન્ન<sub class="text-[10px]">૦</sub>
                                        <span class="text-12 invisible">૦૦૦</span>
                                    </p>
                                    <p>
                                        <a class="recipe" data-id="R0502" href="?id=R0502" sup-id="R0502">
                                            મગ<sup class="red">૫૦૨</sup>
                                        </a>
                                        <a class="recipe" data-id="R0503" href="?id=R0503" sup-id="R0503">
                                            મઠ<sup class="red">૫૦૩</sup>
                                        </a>
                                        છે ફણગાવેલા, અન્ન<sub class="text-[10px]">૦</sub>
                                        <span class="text-12 invisible lg:hidden inline-box">૦૦૦</span>
                                        <br class="lg:hidden"/>
                                        <a class="recipe" data-id="R0504" href="?id=R0504" sup-id="">
                                            લચકો દાળ<sup class="red">૫૦૪</sup>
                                        </a>
                                        જમોને છેલા, અન્ન<sub class="text-[10px]">૦</sub>
                                        <span class="text-12 inline-box">૧૦૧</span>
                                    </p>
                                    <p>
                                        જમો 
                                        <a class="recipe" data-id="R0505" href="?id=R0505" sup-id="R0505">
                                            કળથી<sup class="red">૫૦૫</sup>
                                        </a>
                                        <a class="recipe" data-id="R0506" href="?id=R0506" sup-id="R0506">
                                            લીલા ચણા<sup class="red">૫૦૬</sup>
                                        </a>
                                        , અન્ન<sub class="text-[10px]">૦</sub>
                                        <span class="text-12 invisible lg:hidden inline-box">૦૦૦</span>
                                        <br class="lg:hidden"/>
                                        જરી રાખશો નહિ મણા, અન્ન<sub class="text-[10px]">૦</sub>
                                        <span class="text-12 invisible">૦૦૦</span>
                                    </p>
                                    <h3>ફાસ્ટ ફૂડ</h3>
                                    <p>
                                        જમો ફાસ્ટ ફૂડ અલબેલા, અન્ન<sub class="text-[10px]">૦</sub>
                                        <span class="text-12 invisible lg:hidden inline-box">૦૦૦</span>
                                        <br class="lg:hidden"/>
                                        લાવ્યા ભક્તો પ્રેમઘેલા, અન્ન<sub class="text-[10px]">૦</sub>
                                        <span class="text-12 inline-box">૧૦૨</span>
                                    </p>
                                    <p>
                                        <a class="recipe" data-id="R0507" href="?id=R0507" sup-id="">
                                            સાદા ઢોસા<sup class="red">૫૦૭</sup>
                                        </a>
                                        <a class="recipe" data-id="R0508" href="?id=R0508" sup-id="">
                                            ઢોસા મસાલા<sup class="red">૫૦૮</sup>
                                        </a>
                                        , અન્ન<sub class="text-[10px]">૦</sub>
                                        <span class="text-12 invisible lg:hidden inline-box">૦૦૦</span>
                                        <br class="lg:hidden"/>
                                        જમો 
                                        <a class="recipe" data-id="R0509" href="?id=R0509" sup-id="">
                                            મૈસુરી ઢોસા<sup class="red">૫૦૯</sup>
                                        </a>
                                        વાલા, અન્ન<sub class="text-[10px]">૦</sub>
                                        <span class="text-12 invisible">૦૦૦</span>
                                    </p>
                                    <p>
                                        જમો 
                                        <a class="recipe" data-id="R0510" href="?id=R0510" sup-id="">
                                            સ્વીટકોર્નના આ ઢોસા<sup class="red">૫૧૦</sup>
                                        </a>
                                        , અન્ન<sub class="text-[10px]">૦</sub>
                                        <span class="text-12 invisible lg:hidden inline-box">૦૦૦</span>
                                        <br class="lg:hidden"/>
                                        <a class="recipe" data-id="R0511" href="?id=R0511" sup-id="">
                                            ચીઝ ઢોસા<sup class="red">૫૧૧</sup>
                                        </a>
                                        <a class="recipe" data-id="R0512" href="?id=R0512" sup-id="">
                                            સ્પ્રિંગ ઢોસા<sup class="red">૫૧૨</sup>
                                        </a>
                                        , અન્ન<sub class="text-[10px]">૦</sub>
                                        <span class="text-12 inline-box">૧૦૩</span>
                                    </p>
                                    <p>
                                        <a class="recipe" data-id="R0513" href="?id=R0513" sup-id="">
                                            મેંદુવડાં<sup class="red">૫૧૩</sup>
                                        </a>
                                        ને 
                                        <a class="recipe" data-id="R0514" href="?id=R0514" sup-id="">
                                            સ્ટફ ઇડલી<sup class="red">૫૧૪</sup>
                                        </a>
                                        , અન્ન<sub class="text-[10px]">૦</sub>
                                        <span class="text-12 invisible lg:hidden inline-box">૦૦૦</span>
                                        <br class="lg:hidden"/>
                                        <a class="recipe" data-id="R0515" href="?id=R0515" sup-id="">
                                            ઇડલી સાંભાર<sup class="red">૫૧૫</sup>
                                        </a>
                                        <a class="recipe" data-id="R0516" href="?id=R0516" sup-id="">
                                            રવા ઇડલી<sup class="red">૫૧૬</sup>
                                        </a>
                                        , અન્ન<sub class="text-[10px]">૦</sub>
                                        <span class="text-12 invisible">૦૦૦</span>
                                    </p>
                                    <p>
                                        છે સારા 
                                        <a class="recipe" data-id="R0517" href="?id=R0517" sup-id="">
                                            ટોમેટો ઉત્તપા<sup class="red">૫૧૭</sup>
                                        </a>
                                        , અન્ન<sub class="text-[10px]">૦</sub>
                                        <span class="text-12 invisible lg:hidden inline-box">૦૦૦</span>
                                        <br class="lg:hidden"/>
                                        વળી 
                                        <a class="recipe" data-id="R0518" href="?id=R0518" sup-id="">
                                            વેજિટેબલ ઉત્તપા<sup class="red">૫૧૮</sup>
                                        </a>
                                        , અન્ન<sub class="text-[10px]">૦</sub>
                                        <span class="text-12 inline-box">૧૦૪</span>
                                    </p>
                                    <p>
                                        <a class="recipe" data-id="R0519" href="?id=R0519" sup-id="R0519">
                                            પાંઉભાજી<sup class="red">૫૧૯</sup>
                                        </a>
                                        ને 
                                        <a class="recipe" data-id="R0520" href="?id=R0520" sup-id="">
                                            બફવડાં<sup class="red">૫૨૦</sup>
                                        </a>
                                        , અન્ન<sub class="text-[10px]">૦</sub>
                                        <span class="text-12 invisible lg:hidden inline-box">૦૦૦</span>
                                        <br class="lg:hidden"/>
                                        <a class="recipe" data-id="R0521" href="?id=R0521" sup-id="">
                                            ભેળપૂરી<sup class="red">૫૨૧</sup>
                                        </a>
                                        ને 
                                        <a class="recipe" data-id="R0522" href="?id=R0522" sup-id="">
                                            દહીંવડાં<sup class="red">૫૨૨</sup>
                                        </a>
                                        , અન્ન<sub class="text-[10px]">૦</sub>
                                        <span class="text-12 invisible">૦૦૦</span>
                                    </p>
                                    <p>
                                        ગોલગપ્પા જે 
                                        <a class="recipe" data-id="R0523" href="?id=R0523" sup-id="">
                                            પાણીપૂરી<sup class="red">૫૨૩</sup>
                                        </a>
                                        , અન્ન<sub class="text-[10px]">૦</sub>
                                        <span class="text-12 invisible lg:hidden inline-box">૦૦૦</span>
                                        <br class="lg:hidden"/>
                                        <a class="recipe" data-id="R0524" href="?id=R0524" sup-id="">
                                            રગડાપેટીસ<sup class="red">૫૨૪</sup>
                                        </a>
                                        <a class="recipe" data-id="R0525" href="?id=R0525" sup-id="">
                                            દહીંપૂરી<sup class="red">૫૨૫</sup>
                                        </a>
                                        , અન્ન<sub class="text-[10px]">૦</sub>
                                        <span class="text-12 inline-box">૧૦૫</span>
                                    </p>
                                    <p>
                                        <a class="recipe" data-id="R0526" href="?id=R0526" sup-id="">
                                            મેક્સિકન ભેળ<sup class="red">૫૨૬</sup>
                                        </a>
                                        <a class="recipe" data-id="R0527" href="?id=R0527" sup-id="R0527">
                                            સેવપૂરી<sup class="red">૫૨૭</sup>
                                        </a>
                                        , અન્ન<sub class="text-[10px]">૦</sub>
                                        <span class="text-12 invisible lg:hidden inline-box">૦૦૦</span>
                                        <br class="lg:hidden"/>
                                        <a class="recipe" data-id="R0528" href="?id=R0528" sup-id="">
                                            ચાઇનીઝ ભેળ<sup class="red">૫૨૮</sup>
                                        </a>
                                        <a class="recipe" data-id="R0529" href="?id=R0529" sup-id="">
                                            રગડાપૂરી<sup class="red">૫૨૯</sup>
                                        </a>
                                        , અન્ન<sub class="text-[10px]">૦</sub>
                                        <span class="text-12 invisible">૦૦૦</span>
                                    </p>
                                    <p>
                                        વાલા જમો 
                                        <a class="recipe" data-id="R0530" href="?id=R0530" sup-id="">
                                            કોલેજિયન ભેળ<sup class="red">૫૩૦</sup>
                                        </a>
                                        , અન્ન<sub class="text-[10px]">૦</sub>
                                        <span class="text-12 invisible lg:hidden inline-box">૦૦૦</span>
                                        <br class="lg:hidden"/>
                                        <a class="recipe" data-id="R0531" href="?id=R0531" sup-id="">
                                            સુરતી લોચો<sup class="red">૫૩૧</sup>
                                        </a>
                                        <a class="recipe" data-id="R0532" href="?id=R0532" sup-id="">
                                            સાદી ભેળ<sup class="red">૫૩૨</sup>
                                        </a>
                                        , અન્ન<sub class="text-[10px]">૦</sub>
                                        <span class="text-12 inline-box">૧૦૬</span>
                                    </p>
                                    <p>
                                        <a class="recipe" data-id="R0533" href="?id=R0533" sup-id="">
                                            સેવઉસળ<sup class="red">૫૩૩</sup>
                                        </a>
                                        <a class="recipe" data-id="R0534" href="?id=R0534" sup-id="">
                                            દિલ્લીચાટ<sup class="red">૫૩૪</sup>
                                        </a>
                                        , અન્ન<sub class="text-[10px]">૦</sub>
                                        <span class="text-12 invisible lg:hidden inline-box">૦૦૦</span>
                                        <br class="lg:hidden"/>
                                        <a class="recipe" data-id="R0535" href="?id=R0535" sup-id="">
                                            આલુચાટ<sup class="red">૫૩૫</sup>
                                        </a>
                                        <a class="recipe" data-id="R0536" href="?id=R0536" sup-id="">
                                            કટોરીચાટ<sup class="red">૫૩૬</sup>
                                        </a>
                                        , અન્ન<sub class="text-[10px]">૦</sub>
                                        <span class="text-12 invisible">૦૦૦</span>
                                    </p>
                                    <p>
                                        <a class="recipe" data-id="R0537" href="?id=R0537" sup-id="">
                                            વડાપાંઉ<sup class="red">૫૩૭</sup>
                                        </a>
                                        ને 
                                        <a class="recipe" data-id="R0538" href="?id=R0538" sup-id="">
                                            દાબેલી<sup class="red">૫૩૮</sup>
                                        </a>
                                        , અન્ન<sub class="text-[10px]">૦</sub>
                                        <span class="text-12 invisible lg:hidden inline-box">૦૦૦</span>
                                        <br class="lg:hidden"/>
                                        <a class="recipe" data-id="R0539" href="?id=R0539" sup-id="">
                                            તીખી બટેકી<sup class="red">૫૩૯</sup>
                                        </a>
                                        અલબેલી, અન્ન<sub class="text-[10px]">૦</sub>
                                        <span class="text-12 inline-box">૧૦૭</span>
                                    </p>
                                    <p>
                                        બહુ ભાવશે 
                                        <a class="recipe" data-id="R0540" href="?id=R0540" sup-id="">
                                            બટર દાબેલી<sup class="red">૫૪૦</sup>
                                        </a>
                                        , અન્ન<sub class="text-[10px]">૦</sub>
                                        <span class="text-12 invisible lg:hidden inline-box">૦૦૦</span>
                                        <br class="lg:hidden"/>
                                        <a class="recipe" data-id="R0541" href="?id=R0541" sup-id="">
                                            ચટપટી ચીઝ દાબેલી<sup class="red">૫૪૧</sup>
                                        </a>
                                        , અન્ન<sub class="text-[10px]">૦</sub>
                                        <span class="text-12 invisible">૦૦૦</span>
                                    </p>
                                    <p>
                                        <a class="recipe" data-id="R0542" href="?id=R0542" sup-id="">
                                            બટેકાભૂંગળાં<sup class="red">૫૪૨</sup>
                                        </a>
                                        સારા, અન્ન<sub class="text-[10px]">૦</sub>
                                        <span class="text-12 invisible lg:hidden inline-box">૦૦૦</span>
                                        <br class="lg:hidden"/>
                                        <a class="recipe" data-id="R0543" href="?id=R0543" sup-id="">
                                            છોલે ભટુરા<sup class="red">૫૪૩</sup>
                                        </a>
                                        પણ પ્યારા, અન્ન<sub class="text-[10px]">૦</sub>
                                        <span class="text-12 inline-box">૧૦૮</span>
                                    </p>
                                    <p>
                                        <a class="recipe" data-id="R0544" href="?id=R0544" sup-id="">
                                            ખાટો લોટ<sup class="red">૫૪૪</sup>
                                        </a>
                                        <a class="recipe" data-id="R0545" href="?id=R0545" sup-id="">
                                            દાલપકવાન<sup class="red">૫૪૫</sup>
                                        </a>
                                        , અન્ન<sub class="text-[10px]">૦</sub>
                                        <span class="text-12 invisible lg:hidden inline-box">૦૦૦</span>
                                        <br class="lg:hidden"/>
                                        તમે ભાવે જમો ભગવાન, અન્ન<sub class="text-[10px]">૦</sub>
                                        <span class="text-12 invisible">૦૦૦</span>
                                    </p>
                                    <p>
                                        જમો 
                                        <a class="recipe" data-id="R0546" href="?id=R0546" sup-id="">
                                            પાપડીનો લોટ<sup class="red">૫૪૬</sup>
                                        </a>
                                        શ્યામ, અન્ન<sub class="text-[10px]">૦</sub>
                                        <span class="text-12 invisible lg:hidden inline-box">૦૦૦</span>
                                        <br class="lg:hidden"/>
                                        <a class="recipe" data-id="R0547" href="?id=R0547" sup-id="">
                                            દાલબાટી<sup class="red">૫૪૭</sup>
                                        </a>
                                        જમો ઘનશ્યામ, અન્ન<sub class="text-[10px]">૦</sub>
                                        <span class="text-12 inline-box">૧૦૯</span>
                                    </p>
                                    <p>
                                        જમો 
                                        <a class="recipe" data-id="R0548" href="?id=R0548" sup-id="">
                                            પાઇનેપલ સેન્ડવીચ<sup class="red">૫૪૮</sup>
                                        </a>
                                        , અન્ન<sub class="text-[10px]">૦</sub>
                                        <span class="text-12 invisible lg:hidden inline-box">૦૦૦</span>
                                        <br class="lg:hidden"/>
                                        વળી જમો 
                                        <a class="recipe" data-id="R0549" href="?id=R0549" sup-id="">
                                            ચીઝ સેન્ડવીચ<sup class="red">૫૪૯</sup>
                                        </a>
                                        , અન્ન<sub class="text-[10px]">૦</sub>
                                        <span class="text-12 invisible">૦૦૦</span>
                                    </p>
                                    <p>
                                        <a class="recipe" data-id="R0550" href="?id=R0550" sup-id="">
                                            ગ્રીલ સેન્ડવીચ<sup class="red">૫૫૦</sup>
                                        </a>
                                        <a class="recipe" data-id="R0551" href="?id=R0551" sup-id="">
                                            ટોસ્ટ સેન્ડવીચ<sup class="red">૫૫૧</sup>
                                        </a>
                                        , અન્ન<sub class="text-[10px]">૦</sub>
                                        <span class="text-12 invisible lg:hidden inline-box">૦૦૦</span>
                                        <br class="lg:hidden"/>
                                        જમો આ 
                                        <a class="recipe" data-id="R0552" href="?id=R0552" sup-id="">
                                            ગ્રીલ્ડ ચીઝ સેન્ડવીચ<sup class="red">૫૫૨</sup>
                                        </a>
                                        , અન્ન<sub class="text-[10px]">૦</sub>
                                        <span class="text-12 inline-box">૧૧૦</span>
                                    </p>
                                    <p>
                                        જમો પ્યારી 
                                        <a class="recipe" data-id="R0553" href="?id=R0553" sup-id="">
                                            ક્લબ સેન્ડવીચ<sup class="red">૫૫૩</sup>
                                        </a>
                                        , અન્ન<sub class="text-[10px]">૦</sub>
                                        <span class="text-12 invisible lg:hidden inline-box">૦૦૦</span>
                                        <br class="lg:hidden"/>
                                        જમો 
                                        <a class="recipe" data-id="R0554" href="?id=R0554" sup-id="">
                                            વેજિટેબલ સેન્ડવીચ<sup class="red">૫૫૪</sup>
                                        </a>
                                        , અન્ન<sub class="text-[10px]">૦</sub>
                                        <span class="text-12 invisible">૦૦૦</span>
                                    </p>
                                    <p>
                                        આ 
                                        <a class="recipe" data-id="R0555" href="?id=R0555" sup-id="">
                                            પનીની સેન્ડવીચ<sup class="red">૫૫૫</sup>
                                        </a>
                                        પ્યારી, અન્ન<sub class="text-[10px]">૦</sub>
                                        <span class="text-12 invisible lg:hidden inline-box">૦૦૦</span>
                                        <br class="lg:hidden"/>
                                        જમો 
                                        <a class="recipe" data-id="R0556" href="?id=R0556" sup-id="">
                                            સબવે સેન્ડવીચ<sup class="red">૫૫૬</sup>
                                        </a>
                                        સારી, અન્ન<sub class="text-[10px]">૦</sub>
                                        <span class="text-12 inline-box">૧૧૧</span>
                                    </p>
                                    <p>
                                        <a class="recipe" data-id="R0557" href="?id=R0557" sup-id="">
                                            બ્રેડ પકોડા<sup class="red">૫૫૭</sup>
                                        </a>
                                        <a class="recipe" data-id="R0558" href="?id=R0558" sup-id="">
                                            ઝીની રોલ<sup class="red">૫૫૮</sup>
                                        </a>
                                        , અન્ન<sub class="text-[10px]">૦</sub>
                                        <span class="text-12 invisible lg:hidden inline-box">૦૦૦</span>
                                        <br class="lg:hidden"/>
                                        <a class="recipe" data-id="R0559" href="?id=R0559" sup-id="">
                                            પીઝા<sup class="red">૫૫૯</sup>
                                        </a>
                                        <a class="recipe" data-id="R0560" href="?id=R0560" sup-id="">
                                            બર્ગર<sup class="red">૫૬૦</sup>
                                        </a>
                                        છે 
                                        <a class="recipe" data-id="R0561" href="?id=R0561" sup-id="">
                                            સ્પ્રિંગ રોલ<sup class="red">૫૬૧</sup>
                                        </a>
                                        , અન્ન<sub class="text-[10px]">૦</sub>
                                        <span class="text-12 invisible">૦૦૦</span>
                                    </p>
                                    <p>
                                        <a class="recipe" data-id="R0562" href="?id=R0562" sup-id="">
                                            ચીઝ પકોડા<sup class="red">૫૬૨</sup>
                                        </a>
                                        <a class="recipe" data-id="R0563" href="?id=R0563" sup-id="">
                                            ચીઝ પીઝા<sup class="red">૫૬૩</sup>
                                        </a>
                                        , અન્ન<sub class="text-[10px]">૦</sub>
                                        <span class="text-12 invisible lg:hidden inline-box">૦૦૦</span>
                                        <br class="lg:hidden"/>
                                        <a class="recipe" data-id="R0564" href="?id=R0564" sup-id="">
                                            બ્રેડ પીઝા<sup class="red">૫૬૪</sup>
                                        </a>
                                        <a class="recipe" data-id="R0565" href="?id=R0565" sup-id="">
                                            ખાખરા પીઝા<sup class="red">૫૬૫</sup>
                                        </a>
                                        , અન્ન<sub class="text-[10px]">૦</sub>
                                        <span class="text-12 inline-box">૧૧૨</span>
                                    </p>
                                    <p>
                                        જમો 
                                        <a class="recipe" data-id="R0566" href="?id=R0566" sup-id="">
                                            માર્ગારીટા પીઝા<sup class="red">૫૬૬</sup>
                                        </a>
                                        , અન્ન<sub class="text-[10px]">૦</sub>
                                        <span class="text-12 invisible lg:hidden inline-box">૦૦૦</span>
                                        <br class="lg:hidden"/>
                                        સારા 
                                        <a class="recipe" data-id="R0567" href="?id=R0567" sup-id="">
                                            ચીઝી ચીઝબ્રસ્ટ પીઝા<sup class="red">૫૬૭</sup>
                                        </a>
                                        , અન્ન<sub class="text-[10px]">૦</sub>
                                        <span class="text-12 invisible">૦૦૦</span>
                                    </p>
                                    <p>
                                        <a class="recipe" data-id="R0568" href="?id=R0568" sup-id="">
                                            મીઠા પીઝા મેક્સિકન<sup class="red">૫૬૮</sup>
                                        </a>
                                        , અન્ન<sub class="text-[10px]">૦</sub>
                                        <span class="text-12 invisible lg:hidden inline-box">૦૦૦</span>
                                        <br class="lg:hidden"/>
                                        <a class="recipe" data-id="R0569" href="?id=R0569" sup-id="">
                                            ચીઝબોલ<sup class="red">૫૬૯</sup>
                                        </a>
                                        <a class="recipe" data-id="R0570" href="?id=R0570" sup-id="">
                                            કેલઝોન<sup class="red">૫૭૦</sup>
                                        </a>
                                        જીવન, અન્ન<sub class="text-[10px]">૦</sub>
                                        <span class="text-12 inline-box">૧૧૩</span>
                                    </p>
                                    <p>
                                        <a class="recipe" data-id="R0571" href="?id=R0571" sup-id="">
                                            મોઝરેલા સ્ટીક<sup class="red">૫૭૧</sup>
                                        </a>
                                        <a class="recipe" data-id="R0572" href="?id=R0572" sup-id="">
                                            ચીઝ પોપર<sup class="red">૫૭૨</sup>
                                        </a>
                                        , અન્ન<sub class="text-[10px]">૦</sub>
                                        <span class="text-12 invisible lg:hidden inline-box">૦૦૦</span>
                                        <br class="lg:hidden"/>
                                        જમો 
                                        <a class="recipe" data-id="R0573" href="?id=R0573" sup-id="">
                                            જેકેટ પોટેટો<sup class="red">૫૭૩</sup>
                                        </a>
                                        હરિવર, અન્ન<sub class="text-[10px]">૦</sub>
                                        <span class="text-12 invisible">૦૦૦</span>
                                    </p>
                                    <p>
                                        <a class="recipe" data-id="R0574" href="?id=R0574" sup-id="">
                                            મેથી પફ<sup class="red">૫૭૪</sup>
                                        </a>
                                        <a class="recipe" data-id="R0575" href="?id=R0575" sup-id="">
                                            ચાઇનીઝ પફ<sup class="red">૫૭૫</sup>
                                        </a>
                                        , અન્ન<sub class="text-[10px]">૦</sub>
                                        <span class="text-12 invisible lg:hidden inline-box">૦૦૦</span>
                                        <br class="lg:hidden"/>
                                        <a class="recipe" data-id="R0576" href="?id=R0576" sup-id="">
                                            પનીર પફ<sup class="red">૫૭૬</sup>
                                        </a>
                                        <a class="recipe" data-id="R0577" href="?id=R0577" sup-id="">
                                            પંજાબી પફ<sup class="red">૫૭૭</sup>
                                        </a>
                                        , અન્ન<sub class="text-[10px]">૦</sub>
                                        <span class="text-12 inline-box">૧૧૪</span>
                                    </p>
                                    <p>
                                        <a class="recipe" data-id="R0578" href="?id=R0578" sup-id="">
                                            વેજિટેબલ પફ<sup class="red">૫૭૮</sup>
                                        </a>
                                        <a class="recipe" data-id="R0579" href="?id=R0579" sup-id="">
                                            મોમોઝ<sup class="red">૫૭૯</sup>
                                        </a>
                                        , અન્ન<sub class="text-[10px]">૦</sub>
                                        <span class="text-12 invisible lg:hidden inline-box">૦૦૦</span>
                                        <br class="lg:hidden"/>
                                        <a class="recipe" data-id="R0580" href="?id=R0580" sup-id="">
                                            ફ્રેંચ ફ્રાય<sup class="red">૫૮૦</sup>
                                        </a>
                                        અને 
                                        <a class="recipe" data-id="R0581" href="?id=R0581" sup-id="">
                                            ટાકોઝ<sup class="red">૫૮૧</sup>
                                        </a>
                                        , અન્ન<sub class="text-[10px]">૦</sub>
                                        <span class="text-12 invisible">૦૦૦</span>
                                    </p>
                                    <p>
                                        <a class="recipe" data-id="R0582" href="?id=R0582" sup-id="">
                                            ટોસ્ટાડા<sup class="red">૫૮૨</sup>
                                        </a>
                                        <a class="recipe" data-id="R0583" href="?id=R0583" sup-id="">
                                            કેસેડીઆ<sup class="red">૫૮૩</sup>
                                        </a>
                                        , અન્ન<sub class="text-[10px]">૦</sub>
                                        <span class="text-12 invisible lg:hidden inline-box">૦૦૦</span>
                                        <br class="lg:hidden"/>
                                        <a class="recipe" data-id="R0584" href="?id=R0584" sup-id="">
                                            ચીમીચાન્ગા<sup class="red">૫૮૪</sup>
                                        </a>
                                        ને 
                                        <a class="recipe" data-id="R0585" href="?id=R0585" sup-id="">
                                            ચલુપા<sup class="red">૫૮૫</sup>
                                        </a>
                                        , અન્ન<sub class="text-[10px]">૦</sub>
                                        <span class="text-12 inline-box">૧૧૫</span>
                                    </p>
                                    <p>
                                        <a class="recipe" data-id="R0586" href="?id=R0586" sup-id="">
                                            કાઠીરોલ<sup class="red">૫૮૬</sup>
                                        </a>
                                        ને 
                                        <a class="recipe" data-id="R0587" href="?id=R0587" sup-id="">
                                            ફલાફલ<sup class="red">૫૮૭</sup>
                                        </a>
                                        , અન્ન<sub class="text-[10px]">૦</sub>
                                        <span class="text-12 invisible lg:hidden inline-box">૦૦૦</span>
                                        <br class="lg:hidden"/>
                                        <a class="recipe" data-id="R0588" href="?id=R0588" sup-id="">
                                            એન્ચીલાડા<sup class="red">૫૮૮</sup>
                                        </a>
                                        <a class="recipe" data-id="R0589" href="?id=R0589" sup-id="">
                                            ફહીતા<sup class="red">૫૮૯</sup>
                                        </a>
                                        નવલ, અન્ન<sub class="text-[10px]">૦</sub>
                                        <span class="text-12 invisible">૦૦૦</span>
                                    </p>
                                    <p>
                                        <a class="recipe" data-id="R0590" href="?id=R0590" sup-id="">
                                            બીન બરીતો<sup class="red">૫૯૦</sup>
                                        </a>
                                        ને 
                                        <a class="recipe" data-id="R0591" href="?id=R0591" sup-id="">
                                            ચીઝ વ્રેપ<sup class="red">૫૯૧</sup>
                                        </a>
                                        , અન્ન<sub class="text-[10px]">૦</sub>
                                        <span class="text-12 invisible lg:hidden inline-box">૦૦૦</span>
                                        <br class="lg:hidden"/>
                                        વાલા જમો 
                                        <a class="recipe" data-id="R0592" href="?id=R0592" sup-id="">
                                            ટોર્ટીલા વ્રેપ<sup class="red">૫૯૨</sup>
                                        </a>
                                        , અન્ન<sub class="text-[10px]">૦</sub>
                                        <span class="text-12 inline-box">૧૧૬</span>
                                    </p>
                                    <p>
                                        <a class="recipe" data-id="R0593" href="?id=R0593" sup-id="">
                                            વેજફ્રાય<sup class="red">૫૯૩</sup>
                                        </a>
                                        <a class="recipe" data-id="R0594" href="?id=R0594" sup-id="">
                                            મન્ચુરિયન<sup class="red">૫૯૪</sup>
                                        </a>
                                        , અન્ન<sub class="text-[10px]">૦</sub>
                                        <span class="text-12 invisible lg:hidden inline-box">૦૦૦</span>
                                        <br class="lg:hidden"/>
                                        જમો 
                                        <a class="recipe" data-id="R0595" href="?id=R0595" sup-id="">
                                            નાચોઝ<sup class="red">૫૯૫</sup>
                                        </a>
                                        હે જીવન, અન્ન<sub class="text-[10px]">૦</sub>
                                        <span class="text-12 invisible">૦૦૦</span>
                                    </p>
                                    <p>
                                        <a class="recipe" data-id="R0596" href="?id=R0596" sup-id="">
                                            સાલ્સા ચીપ્સ<sup class="red">૫૯૬</sup>
                                        </a>
                                        <a class="recipe" data-id="R0597" href="?id=R0597" sup-id="">
                                            બેક્ડ પોટેટો<sup class="red">૫૯૭</sup>
                                        </a>
                                        , અન્ન<sub class="text-[10px]">૦</sub>
                                        <span class="text-12 invisible lg:hidden inline-box">૦૦૦</span>
                                        <br class="lg:hidden"/>
                                        <a class="recipe" data-id="R0598" href="?id=R0598" sup-id="">
                                            ટોફુ બાઉલ<sup class="red">૫૯૮</sup>
                                        </a>
                                        બનાવ્યા મેં તો, અન્ન<sub class="text-[10px]">૦</sub>
                                        <span class="text-12 inline-box">૧૧૭</span>
                                    </p>
                                    <p>
                                        <a class="recipe" data-id="R0599" href="?id=R0599" sup-id="">
                                            સાદા પાસ્તા<sup class="red">૫૯૯</sup>
                                        </a>
                                        <a class="recipe" data-id="R0600" href="?id=R0600" sup-id="">
                                            મસાલા પાસ્તા<sup class="red">૬૦૦</sup>
                                        </a>
                                        , અન્ન<sub class="text-[10px]">૦</sub>
                                        <span class="text-12 invisible lg:hidden inline-box">૦૦૦</span>
                                        <br class="lg:hidden"/>
                                        પ્યારા 
                                        <a class="recipe" data-id="R0601" href="?id=R0601" sup-id="">
                                            વેજિટેબલ પાસ્તા<sup class="red">૬૦૧</sup>
                                        </a>
                                        , અન્ન<sub class="text-[10px]">૦</sub>
                                        <span class="text-12 invisible">૦૦૦</span>
                                    </p>
                                    <p>
                                        જમો 
                                        <a class="recipe" data-id="R0602" href="?id=R0602" sup-id="">
                                            અલ્ફ્રેડો પાસ્તા<sup class="red">૬૦૨</sup>
                                        </a>
                                        ભાવે, અન્ન<sub class="text-[10px]">૦</sub>
                                        <span class="text-12 invisible lg:hidden inline-box">૦૦૦</span>
                                        <br class="lg:hidden"/>
                                        વસ્તુ ઇટાલિયન એ કા’વે, અન્ન<sub class="text-[10px]">૦</sub>
                                        <span class="text-12 inline-box">૧૧૮</span>
                                    </p>
                                    <p>
                                        છે 
                                        <a class="recipe" data-id="R0603" href="?id=R0603" sup-id="">
                                            મેક એન્ડ ચીઝ<sup class="red">૬૦૩</sup>
                                        </a>
                                        સારી, અન્ન<sub class="text-[10px]">૦</sub>
                                        <span class="text-12 invisible lg:hidden inline-box">૦૦૦</span>
                                        <br class="lg:hidden"/>
                                        <a class="recipe" data-id="R0604" href="?id=R0604" sup-id="">
                                            રેવિયોલી<sup class="red">૬૦૪</sup>
                                        </a>
                                        <a class="recipe" data-id="R0605" href="?id=R0605" sup-id="R0605">
                                            સ્પગેટી<sup class="red">૬૦૫</sup>
                                        </a>
                                        પ્યારી, અન્ન<sub class="text-[10px]">૦</sub>
                                        <span class="text-12 invisible">૦૦૦</span>
                                    </p>
                                    <p>
                                        <a class="recipe" data-id="R0606" href="?id=R0606" sup-id="">
                                            વેજિટેબલ ફ્રેન્કી<sup class="red">૬૦૬</sup>
                                        </a>
                                        શ્યામ, અન્ન<sub class="text-[10px]">૦</sub>
                                        <span class="text-12 invisible lg:hidden inline-box">૦૦૦</span>
                                        <br class="lg:hidden"/>
                                        જમો 
                                        <a class="recipe" data-id="R0607" href="?id=R0607" sup-id="">
                                            ગોલ્ડ કોઇન<sup class="red">૬૦૭</sup>
                                        </a>
                                        ઘનશ્યામ, અન્ન<sub class="text-[10px]">૦</sub>
                                        <span class="text-12 inline-box">૧૧૯</span>
                                    </p>
                                    <p>
                                        <a class="recipe" data-id="R0608" href="?id=R0608" sup-id="">
                                            વેજિટેબલ નૂડલ્સ<sup class="red">૬૦૮</sup>
                                        </a>
                                        પ્યારા, અન્ન<sub class="text-[10px]">૦</sub>
                                        <span class="text-12 invisible lg:hidden inline-box">૦૦૦</span>
                                        <br class="lg:hidden"/>
                                        <a class="recipe" data-id="R0609" href="?id=R0609" sup-id="">
                                            ચીલી પનીર<sup class="red">૬૦૯</sup>
                                        </a>
                                        જમોને ન્યારા, અન્ન<sub class="text-[10px]">૦</sub>
                                        <span class="text-12 invisible">૦૦૦</span>
                                    </p>
                                    <p>
                                        આ 
                                        <a class="recipe" data-id="R0610" href="?id=R0610" sup-id="">
                                            ફ્રાઇડ રાઇસ નૂડલ્સ<sup class="red">૬૧૦</sup>
                                        </a>
                                        , અન્ન<sub class="text-[10px]">૦</sub>
                                        <span class="text-12 invisible lg:hidden inline-box">૦૦૦</span>
                                        <br class="lg:hidden"/>
                                        હરિ જમોને 
                                        <a class="recipe" data-id="R0611" href="?id=R0611" sup-id="">
                                            હક્કા નૂડલ્સ<sup class="red">૬૧૧</sup>
                                        </a>
                                        , અન્ન<sub class="text-[10px]">૦</sub>
                                        <span class="text-12 inline-box">૧૨૦</span>
                                    </p>
                                    <p>
                                        <a class="recipe" data-id="R0612" href="?id=R0612" sup-id="">
                                            વેજ લઝાનિયા<sup class="red">૬૧૨</sup>
                                        </a>
                                        <a class="recipe" data-id="R0613" href="?id=R0613" sup-id="">
                                            સીઝલર<sup class="red">૬૧૩</sup>
                                        </a>
                                        , અન્ન<sub class="text-[10px]">૦</sub>
                                        <span class="text-12 invisible lg:hidden inline-box">૦૦૦</span>
                                        <br class="lg:hidden"/>
                                        <a class="recipe" data-id="R0614" href="?id=R0614" sup-id="">
                                            પીનવ્હીલ<sup class="red">૬૧૪</sup>
                                        </a>
                                        <a class="recipe" data-id="R0615" href="?id=R0615" sup-id="">
                                            પોટેટો ફિંગર<sup class="red">૬૧૫</sup>
                                        </a>
                                        , અન્ન<sub class="text-[10px]">૦</sub>
                                        <span class="text-12 invisible">૦૦૦</span>
                                    </p>
                                    <p>
                                        <a class="recipe" data-id="R0616" href="?id=R0616" sup-id="">
                                            હાલાપીનો પોપર્સ<sup class="red">૬૧૬</sup>
                                        </a>
                                        અમૂલ, અન્ન<sub class="text-[10px]">૦</sub>
                                        <span class="text-12 invisible lg:hidden inline-box">૦૦૦</span>
                                        <br class="lg:hidden"/>
                                        <a class="recipe" data-id="R0617" href="?id=R0617" sup-id="">
                                            હેશ બ્રાઉન<sup class="red">૬૧૭</sup>
                                        </a>
                                        <a class="recipe" data-id="R0618" href="?id=R0618" sup-id="">
                                            ચીપોટલે બાઉલ<sup class="red">૬૧૮</sup>
                                        </a>
                                        , અન્ન<sub class="text-[10px]">૦</sub>
                                        <span class="text-12 inline-box">૧૨૧</span>
                                    </p>
                                    <p>
                                        જમો 
                                        <a class="recipe" data-id="R0619" href="?id=R0619" sup-id="">
                                            બ્રીંજલ પારમેઝન<sup class="red">૬૧૯</sup>
                                        </a>
                                        , અન્ન<sub class="text-[10px]">૦</sub>
                                        <span class="text-12 invisible lg:hidden inline-box">૦૦૦</span>
                                        <br class="lg:hidden"/>
                                        <a class="recipe" data-id="R0620" href="?id=R0620" sup-id="">
                                            એમ્પનાડસ<sup class="red">૬૨૦</sup>
                                        </a>
                                        જમો જીવન, અન્ન<sub class="text-[10px]">૦</sub>
                                        <span class="text-12 invisible">૦૦૦</span>
                                    </p>
                                    <h3>ચટણી</h3>
                                    <p>
                                        બહુ ચટણીઓ સુખકારી, અન્ન<sub class="text-[10px]">૦</sub>
                                        <span class="text-12 invisible lg:hidden inline-box">૦૦૦</span>
                                        <br class="lg:hidden"/>
                                        કરી અનેક પ્રકારની સારી, અન્ન<sub class="text-[10px]">૦</sub>
                                        <span class="text-12 inline-box">૧૨૨</span>
                                    </p>
                                    <p>
                                        જમો 
                                        <a class="recipe" data-id="R0621" href="?id=R0621" sup-id="">
                                            કોથમીરની ચટણી<sup class="red">૬૨૧</sup>
                                        </a>
                                        , અન્ન<sub class="text-[10px]">૦</sub>
                                        <span class="text-12 invisible lg:hidden inline-box">૦૦૦</span>
                                        <br class="lg:hidden"/>
                                        <a class="recipe" data-id="R0622" href="?id=R0622" sup-id="">
                                            લીલાં મરચાંની ચટણી<sup class="red">૬૨૨</sup>
                                        </a>
                                        , અન્ન<sub class="text-[10px]">૦</sub>
                                        <span class="text-12 invisible">૦૦૦</span>
                                    </p>
                                    <p>
                                        <a class="recipe" data-id="R0623" href="?id=R0623" sup-id="">
                                            શીંગદાણા-ટોપરાની ચટણી<sup class="red">૬૨૩</sup>
                                        </a>
                                        , અન્ન<sub class="text-[10px]">૦</sub>
                                        <span class="text-12 invisible lg:hidden inline-box">૦૦૦</span>
                                        <br class="lg:hidden"/>
                                        <a class="recipe" data-id="R0624" href="?id=R0624" sup-id="">
                                            દાળિયા-મરચાંની ચટણી<sup class="red">૬૨૪</sup>
                                        </a>
                                        , અન્ન<sub class="text-[10px]">૦</sub>
                                        <span class="text-12 inline-box">૧૨૩</span>
                                    </p>
                                    <p>
                                        <a class="recipe" data-id="R0625" href="?id=R0625" sup-id="R0625">
                                            ખજૂરની<sup class="red">૬૨૫</sup>
                                        </a>
                                        ને 
                                        <a class="recipe" data-id="R0626" href="?id=R0626" sup-id="R0626">
                                            આંબલીની<sup class="red">૬૨૬</sup>
                                        </a>
                                        , અન્ન<sub class="text-[10px]">૦</sub>
                                        <span class="text-12 invisible lg:hidden inline-box">૦૦૦</span>
                                        <br class="lg:hidden"/>
                                        સારી 
                                        <a class="recipe" data-id="R0627" href="?id=R0627" sup-id="">
                                            ચટણી છે દહીંની<sup class="red">૬૨૭</sup>
                                        </a>
                                        , અન્ન<sub class="text-[10px]">૦</sub>
                                        <span class="text-12 invisible">૦૦૦</span>
                                    </p>
                                    <p>
                                        <a class="recipe" data-id="R0628" href="?id=R0628" sup-id="">
                                            ફુદીનાની<sup class="red">૬૨૮</sup>
                                        </a>
                                        તથા 
                                        <a class="recipe" data-id="R0629" href="?id=R0629" sup-id="R0629">
                                            ટમેટાંની<sup class="red">૬૨૯</sup>
                                        </a>
                                        , અન્ન<sub class="text-[10px]">૦</sub>
                                        <span class="text-12 invisible lg:hidden inline-box">૦૦૦</span>
                                        <br class="lg:hidden"/>
                                        <a class="recipe" data-id="R0630" href="?id=R0630" sup-id="">
                                            કોઠાંની<sup class="red">૬૩૦</sup>
                                        </a>
                                        તથા 
                                        <a class="recipe" data-id="R0631" href="?id=R0631" sup-id="">
                                            બટેકાંની<sup class="red">૬૩૧</sup>
                                        </a>
                                        , અન્ન<sub class="text-[10px]">૦</sub>
                                        <span class="text-12 inline-box">૧૨૪</span>
                                    </p>
                                    <p>
                                        <a class="recipe" data-id="R0632" href="?id=R0632" sup-id="">
                                            આમચૂરની છે ચટણી<sup class="red">૬૩૨</sup>
                                        </a>
                                        , અન્ન<sub class="text-[10px]">૦</sub>
                                        <span class="text-12 invisible lg:hidden inline-box">૦૦૦</span>
                                        <br class="lg:hidden"/>
                                        સારી છે 
                                        <a class="recipe" data-id="R0633" href="?id=R0633" sup-id="">
                                            સીઝવાન ચટણી<sup class="red">૬૩૩</sup>
                                        </a>
                                        , અન્ન<sub class="text-[10px]">૦</sub>
                                        <span class="text-12 invisible">૦૦૦</span>
                                    </p>
                                    <p>
                                        <a class="recipe" data-id="R0634" href="?id=R0634" sup-id="">
                                            લીલી આંબલીની ચટણી<sup class="red">૬૩૪</sup>
                                        </a>
                                        , અન્ન<sub class="text-[10px]">૦</sub>
                                        <span class="text-12 invisible lg:hidden inline-box">૦૦૦</span>
                                        <br class="lg:hidden"/>
                                        લાવ્યા ચટણી અમે ઘણી, અન્ન<sub class="text-[10px]">૦</sub>
                                        <span class="text-12 inline-box">૧૨૫</span>
                                    </p>
                                    <p>
                                        <a class="recipe" data-id="R0635" href="?id=R0635" sup-id="">
                                            બીનડીપ<sup class="red">૬૩૫</sup>
                                        </a>
                                        <a class="recipe" data-id="R0636" href="?id=R0636" sup-id="">
                                            બાબાગનુષ<sup class="red">૬૩૬</sup>
                                        </a>
                                        , અન્ન<sub class="text-[10px]">૦</sub>
                                        <span class="text-12 invisible lg:hidden inline-box">૦૦૦</span>
                                        <br class="lg:hidden"/>
                                        જમો 
                                        <a class="recipe" data-id="R0637" href="?id=R0637" sup-id="">
                                            ગ્વાકામોલી<sup class="red">૬૩૭</sup>
                                        </a>
                                        ને 
                                        <a class="recipe" data-id="R0638" href="?id=R0638" sup-id="">
                                            હમસ<sup class="red">૬૩૮</sup>
                                        </a>
                                        , અન્ન<sub class="text-[10px]">૦</sub>
                                        <span class="text-12 invisible">૦૦૦</span>
                                    </p>
                                    <p>
                                        રૂડો 
                                        <a class="recipe" data-id="R0639" href="?id=R0639" sup-id="">
                                            ટમેટાંનો સોસ<sup class="red">૬૩૯</sup>
                                        </a>
                                        , અન્ન<sub class="text-[10px]">૦</sub>
                                        <span class="text-12 invisible lg:hidden inline-box">૦૦૦</span>
                                        <br class="lg:hidden"/>
                                        નહિ નડે તજો અફસોસ, અન્ન<sub class="text-[10px]">૦</sub>
                                        <span class="text-12 inline-box">૧૨૬</span>
                                    </p>
                                    <h3>સંભારો</h3>
                                    <p>
                                        મેં કર્યો 
                                        <a class="recipe" data-id="R0640" href="?id=R0640" sup-id="">
                                            સંભારો<sup class="red">૬૪૦</sup>
                                        </a>
                                        હરિ, અન્ન<sub class="text-[10px]">૦</sub>
                                        <span class="text-12 invisible lg:hidden inline-box">૦૦૦</span>
                                        <br class="lg:hidden"/>
                                        વિધવિધ કાચું ભેળું કરી, અન્ન<sub class="text-[10px]">૦</sub>
                                        <span class="text-12 invisible">૦૦૦</span>
                                    </p>
                                    <p>
                                        મરચાં ટીંડોરાં કાકડીનો, અન્ન<sub class="text-[10px]">૦</sub>
                                        <span class="text-12 invisible lg:hidden inline-box">૦૦૦</span>
                                        <br class="lg:hidden"/>
                                        કોબી ગાજર ટમેટાદિનો, અન્ન<sub class="text-[10px]">૦</sub>
                                        <span class="text-12 inline-box">૧૨૭</span>
                                    </p>
                                    <p>
                                        મીઠો બનાવ્યો સંભારો, અન્ન<sub class="text-[10px]">૦</sub>
                                        <span class="text-12 invisible lg:hidden inline-box">૦૦૦</span>
                                        <br class="lg:hidden"/>
                                        તમે ભાવ સ્વીકારો મારો, અન્ન<sub class="text-[10px]">૦</sub>
                                        <span class="text-12 invisible">૦૦૦</span>
                                    </p>
                                    <p>
                                        <a class="recipe" data-id="R0641" href="?id=R0641" sup-id="">
                                            કોબી-મરચાંનો સંભારો<sup class="red">૬૪૧</sup>
                                        </a>
                                        , અન્ન<sub class="text-[10px]">૦</sub>
                                        <span class="text-12 invisible lg:hidden inline-box">૦૦૦</span>
                                        <br class="lg:hidden"/>
                                        જમો 
                                        <a class="recipe" data-id="R0642" href="?id=R0642" sup-id="">
                                            પપૈયાનો<sup class="red">૬૪૨</sup>
                                        </a>
                                        સારો, અન્ન<sub class="text-[10px]">૦</sub>
                                        <span class="text-12 inline-box">૧૨૮</span>
                                    </p>
                                    <p>
                                        કાકડી ગાજર મૂળાનું, અન્ન<sub class="text-[10px]">૦</sub>
                                        <span class="text-12 invisible lg:hidden inline-box">૦૦૦</span>
                                        <br class="lg:hidden"/>
                                        બીટ કોબી ટમેટાનું, અન્ન<sub class="text-[10px]">૦</sub>
                                        <span class="text-12 invisible">૦૦૦</span>
                                    </p>
                                    <p>
                                        <a class="recipe" data-id="R0643" href="?id=R0643" sup-id="">
                                            કચુંબર<sup class="red">૬૪૩</sup>
                                        </a>
                                        કર્યું તે સહુનું, અન્ન<sub class="text-[10px]">૦</sub>
                                        <span class="text-12 invisible lg:hidden inline-box">૦૦૦</span>
                                        <br class="lg:hidden"/>
                                        <a class="recipe" data-id="R0644" href="?id=R0644" sup-id="">
                                            સલાડ ફણગાવેલ મગનું<sup class="red">૬૪૪</sup>
                                        </a>
                                        , અન્ન<sub class="text-[10px]">૦</sub>
                                        <span class="text-12 inline-box">૧૨૯</span>
                                    </p>
                                    <p>
                                        સલાડ સમાર્યું સુપર, અન્ન<sub class="text-[10px]">૦</sub>
                                        <span class="text-12 invisible lg:hidden inline-box">૦૦૦</span>
                                        <br class="lg:hidden"/>
                                        <a class="ingredient" data-id="I0048" href="?id=I0048" sup-id="">
                                            કોબી<sup class="red">૬૪૫</sup>
                                        </a>
                                        <a class="ingredient" data-id="I0030" href="?id=I0030" sup-id="">
                                            કાકડી<sup class="red">૬૪૬</sup>
                                        </a>
                                        ને 
                                        <a class="ingredient" data-id="I0061" href="?id=I0061" sup-id="">
                                            ગાજર<sup class="red">૬૪૭</sup>
                                        </a>
                                        , અન્ન<sub class="text-[10px]">૦</sub>
                                        <span class="text-12 invisible">૦૦૦</span>
                                    </p>
                                    <p>
                                        <a class="ingredient" data-id="I0039" href="?id=I0039" sup-id="">
                                            ભોલર કેપ્સીકમ મરચાં<sup class="red">૬૪૮</sup>
                                        </a>
                                        , અન્ન<sub class="text-[10px]">૦</sub>
                                        <span class="text-12 invisible lg:hidden inline-box">૦૦૦</span>
                                        <br class="lg:hidden"/>
                                        <a class="ingredient" data-id="I0133" href="?id=I0133" sup-id="">
                                            બીટ<sup class="red">૬૪૯</sup>
                                        </a>
                                        <a class="ingredient" data-id="I0090" href="?id=I0090" sup-id="">
                                            ટમેટાં<sup class="red">૬૫૦</sup>
                                        </a>
                                        <a class="ingredient" data-id="I0008" href="?id=I0008" sup-id="">
                                            આંબળાં<sup class="red">૬૫૧</sup>
                                        </a>
                                        , અન્ન<sub class="text-[10px]">૦</sub>
                                        <span class="text-12 inline-box">૧૩૦</span>
                                    </p>
                                    <p>
                                        <a class="ingredient" data-id="I0031" href="?id=I0031" sup-id="">
                                            કાચી કેરી<sup class="red">૬૫૨</sup>
                                        </a>
                                        <a class="ingredient" data-id="I0109" href="?id=I0109" sup-id="">
                                            લીલું ટોપરું<sup class="red">૬૫૩</sup>
                                        </a>
                                        , અન્ન<sub class="text-[10px]">૦</sub>
                                        <span class="text-12 invisible lg:hidden inline-box">૦૦૦</span>
                                        <br class="lg:hidden"/>
                                        <a class="ingredient" data-id="I0183" href="?id=I0183" sup-id="">
                                            લેટસ<sup class="red">૬૫૪</sup>
                                        </a>
                                        આદિ 
                                        <a class="ingredient" data-id="I0126" href="?id=I0126" sup-id="">
                                            ફુલેવર<sup class="red">૬૫૫</sup>
                                        </a>
                                        ખરું, અન્ન<sub class="text-[10px]">૦</sub>
                                        <span class="text-12 invisible">૦૦૦</span>
                                    </p>
                                    <p>
                                        <a class="ingredient" data-id="I0182" href="?id=I0182" sup-id="">
                                            લીલી હળદર<sup class="red">૬૫૬</sup>
                                        </a>
                                        <a class="ingredient" data-id="I0009" href="?id=I0009" sup-id="">
                                            આંબામોર<sup class="red">૬૫૭</sup>
                                        </a>
                                        , અન્ન<sub class="text-[10px]">૦</sub>
                                        <span class="text-12 invisible lg:hidden inline-box">૦૦૦</span>
                                        <br class="lg:hidden"/>
                                        <a class="ingredient" data-id="I0152" href="?id=I0152" sup-id="">
                                            તીખા મૂળા<sup class="red">૬૫૮</sup>
                                        </a>
                                        જમો ચિત્તચોર, અન્ન<sub class="text-[10px]">૦</sub>
                                        <span class="text-12 inline-box">૧૩૧</span>
                                    </p>
                                    <p>
                                        જમો 
                                        <a class="ingredient" data-id="I0156" href="?id=I0156" sup-id="">
                                            મોગરી<sup class="red">૬૫૯</sup>
                                        </a>
                                        <a class="recipe" data-id="R0660" href="?id=R0660" sup-id="">
                                            મૂળાપાન<sup class="red">૬૬૦</sup>
                                        </a>
                                        , અન્ન<sub class="text-[10px]">૦</sub>
                                        <span class="text-12 invisible lg:hidden inline-box">૦૦૦</span>
                                        <br class="lg:hidden"/>
                                        અમે ધરીએ તમારું ધ્યાન, અન્ન<sub class="text-[10px]">૦</sub>
                                        <span class="text-12 invisible">૦૦૦</span>
                                    </p>
                                    <p>
                                        જમો મકાઈ ડોડા છેલા, અન્ન<sub class="text-[10px]">૦</sub>
                                        <span class="text-12 invisible lg:hidden inline-box">૦૦૦</span>
                                        <br class="lg:hidden"/>
                                        <a class="recipe" data-id="R0661" href="?id=R0661" sup-id="R0661">
                                            શેકેલા<sup class="red">૬૬૧</sup>
                                        </a>
                                        ને વળી 
                                        <a class="recipe" data-id="R0662" href="?id=R0662" sup-id="R0662">
                                            બાફેલા<sup class="red">૬૬૨</sup>
                                        </a>
                                        , અન્ન<sub class="text-[10px]">૦</sub>
                                        <span class="text-12 inline-box">૧૩૨</span>
                                    </p>
                                    <p>
                                        <a class="recipe" data-id="R0663" href="?id=R0663" sup-id="">
                                            જારનો<sup class="red">૬૬૩</sup>
                                        </a>
                                        ને 
                                        <a class="recipe" data-id="R0664" href="?id=R0664" sup-id="">
                                            ઘઉંનો પોંક<sup class="red">૬૬૪</sup>
                                        </a>
                                        , અન્ન<sub class="text-[10px]">૦</sub>
                                        <span class="text-12 invisible lg:hidden inline-box">૦૦૦</span>
                                        <br class="lg:hidden"/>
                                        જમો 
                                        <a class="recipe" data-id="R0665" href="?id=R0665" sup-id="R0665">
                                            બાજરાનો<sup class="red">૬૬૫</sup>
                                        </a>
                                        પણ પોંક, અન્ન<sub class="text-[10px]">૦</sub>
                                        <span class="text-12 invisible">૦૦૦</span>
                                    </p>
                                    <h3>અથાણાં</h3>
                                    <p>
                                        વાલા ધર્યાં અથાણાં અનેક, અન્ન<sub class="text-[10px]">૦</sub>
                                        <span class="text-12 invisible lg:hidden inline-box">૦૦૦</span>
                                        <br class="lg:hidden"/>
                                        તમે જમજો એકેએક, અન્ન<sub class="text-[10px]">૦</sub>
                                        <span class="text-12 inline-box">૧૩૩</span>
                                    </p>
                                    <p>
                                        અથાણાં 
                                        <a class="recipe" data-id="R0666" href="?id=R0666" sup-id="">
                                            રાઈતાં કેરીનાં<sup class="red">૬૬૬</sup>
                                        </a>
                                        , અન્ન<sub class="text-[10px]">૦</sub>
                                        <span class="text-12 invisible lg:hidden inline-box">૦૦૦</span>
                                        <br class="lg:hidden"/>
                                        <a class="recipe" data-id="R0667" href="?id=R0667" sup-id="">
                                            ખાટી કેરી<sup class="red">૬૬૭</sup>
                                        </a>
                                        <a class="recipe" data-id="R0668" href="?id=R0668" sup-id="">
                                            ગોળ-કેરીનાં<sup class="red">૬૬૮</sup>
                                        </a>
                                        , અન્ન<sub class="text-[10px]">૦</sub>
                                        <span class="text-12 invisible">૦૦૦</span>
                                    </p>
                                    <p>
                                        <a class="recipe" data-id="R0669" href="?id=R0669" sup-id="R0669">
                                            કેરડા<sup class="red">૬૬૯</sup>
                                        </a>
                                        <a class="recipe" data-id="R0670" href="?id=R0670" sup-id="R0670">
                                            ગાજર<sup class="red">૬૭૦</sup>
                                        </a>
                                        <a class="recipe" data-id="R0671" href="?id=R0671" sup-id="">
                                            ગૂંદાંનાં<sup class="red">૬૭૧</sup>
                                        </a>
                                        , અન્ન<sub class="text-[10px]">૦</sub>
                                        <span class="text-12 invisible lg:hidden inline-box">૦૦૦</span>
                                        <br class="lg:hidden"/>
                                        <a class="recipe" data-id="R0672" href="?id=R0672" sup-id="R0672">
                                            ખારેક<sup class="red">૬૭૨</sup>
                                        </a>
                                        <a class="recipe" data-id="R0673" href="?id=R0673" sup-id="">
                                            આખા મરચાંનાં<sup class="red">૬૭૩</sup>
                                        </a>
                                        , અન્ન<sub class="text-[10px]">૦</sub>
                                        <span class="text-12 inline-box">૧૩૪</span>
                                    </p>
                                    <p>
                                        <a class="recipe" data-id="R0674" href="?id=R0674" sup-id="">
                                            ડારા ગરમર<sup class="red">૬૭૪</sup>
                                        </a>
                                        <a class="recipe" data-id="R0675" href="?id=R0675" sup-id="">
                                            કરમદાનાં<sup class="red">૬૭૫</sup>
                                        </a>
                                        , અન્ન<sub class="text-[10px]">૦</sub>
                                        <span class="text-12 invisible lg:hidden inline-box">૦૦૦</span>
                                        <br class="lg:hidden"/>
                                        <a class="recipe" data-id="R0676" href="?id=R0676" sup-id="">
                                            પંજાબી<sup class="red">૬૭૬</sup>
                                        </a>
                                        ને 
                                        <a class="recipe" data-id="R0677" href="?id=R0677" sup-id="">
                                            મેથી-ચણાનાં<sup class="red">૬૭૭</sup>
                                        </a>
                                        , અન્ન<sub class="text-[10px]">૦</sub>
                                        <span class="text-12 invisible">૦૦૦</span>
                                    </p>
                                    <p>
                                        <a class="recipe" data-id="R0678" href="?id=R0678" sup-id="">
                                            કાજુ-ખારેક<sup class="red">૬૭૮</sup>
                                        </a>
                                        <a class="recipe" data-id="R0679" href="?id=R0679" sup-id="">
                                            કેરી-ખજૂરનાં<sup class="red">૬૭૯</sup>
                                        </a>
                                        , અન્ન<sub class="text-[10px]">૦</sub>
                                        <span class="text-12 invisible lg:hidden inline-box">૦૦૦</span>
                                        <br class="lg:hidden"/>
                                        <a class="recipe" data-id="R0680" href="?id=R0680" sup-id="R0680">
                                            બિલા<sup class="red">૬૮૦</sup>
                                        </a>
                                        <a class="recipe" data-id="R0681" href="?id=R0681" sup-id="R0681">
                                            ટીંડોરાં<sup class="red">૬૮૧</sup>
                                        </a>
                                        <a class="recipe" data-id="R0682" href="?id=R0682" sup-id="">
                                            બિજોરાંનાં<sup class="red">૬૮૨</sup>
                                        </a>
                                        , અન્ન<sub class="text-[10px]">૦</sub>
                                        <span class="text-12 inline-box">૧૩૫</span>
                                    </p>
                                    <p>
                                        <a class="recipe" data-id="R0683" href="?id=R0683" sup-id="R0683">
                                            લીંબુનાં<sup class="red">૬૮૩</sup>
                                        </a>
                                        ને 
                                        <a class="recipe" data-id="R0684" href="?id=R0684" sup-id="">
                                            ચીભડાંનાં<sup class="red">૬૮૪</sup>
                                        </a>
                                        , અન્ન<sub class="text-[10px]">૦</sub>
                                        <span class="text-12 invisible lg:hidden inline-box">૦૦૦</span>
                                        <br class="lg:hidden"/>
                                        <a class="recipe" data-id="R0685" href="?id=R0685" sup-id="">
                                            વાંસનાં<sup class="red">૬૮૫</sup>
                                        </a>
                                        ને 
                                        <a class="recipe" data-id="R0686" href="?id=R0686" sup-id="">
                                            આંબળાંનાં<sup class="red">૬૮૬</sup>
                                        </a>
                                        , અન્ન<sub class="text-[10px]">૦</sub>
                                        <span class="text-12 invisible">૦૦૦</span>
                                    </p>
                                    <p>
                                        જમો 
                                        <a class="recipe" data-id="R0687" href="?id=R0687" sup-id="">
                                            કેરીનો મુરબ્બો<sup class="red">૬૮૭</sup>
                                        </a>
                                        , અન્ન<sub class="text-[10px]">૦</sub>
                                        <span class="text-12 invisible lg:hidden inline-box">૦૦૦</span>
                                        <br class="lg:hidden"/>
                                        વળી 
                                        <a class="recipe" data-id="R0688" href="?id=R0688" sup-id="">
                                            આંબળાંનો મુરબ્બો<sup class="red">૬૮૮</sup>
                                        </a>
                                        , અન્ન<sub class="text-[10px]">૦</sub>
                                        <span class="text-12 inline-box">૧૩૬</span>
                                    </p>
                                    <p>
                                        <a class="recipe" data-id="R0689" href="?id=R0689" sup-id="">
                                            છુંદો કેરીનો<sup class="red">૬૮૯</sup>
                                        </a>
                                        <a class="recipe" data-id="R0690" href="?id=R0690" sup-id="">
                                            રાઈતાં મરચાં<sup class="red">૬૯૦</sup>
                                        </a>
                                        , અન્ન<sub class="text-[10px]">૦</sub>
                                        <span class="text-12 invisible lg:hidden inline-box">૦૦૦</span>
                                        <br class="lg:hidden"/>
                                        જમો 
                                        <a class="recipe" data-id="R0691" href="?id=R0691" sup-id="">
                                            વડતાલનાં આ મરચાં<sup class="red">૬૯૧</sup>
                                        </a>
                                        , અન્ન<sub class="text-[10px]">૦</sub>
                                        <span class="text-12 invisible">૦૦૦</span>
                                    </p>
                                    <p>
                                        તળી 
                                        <a class="recipe" data-id="R0692" href="?id=R0692" sup-id="">
                                            ગુવારની કાચરી<sup class="red">૬૯૨</sup>
                                        </a>
                                        , અન્ન<sub class="text-[10px]">૦</sub>
                                        <span class="text-12 invisible lg:hidden inline-box">૦૦૦</span>
                                        <br class="lg:hidden"/>
                                        <a class="recipe" data-id="R0693" href="?id=R0693" sup-id="">
                                            ભીંડાની કાચરી<sup class="red">૬૯૩</sup>
                                        </a>
                                        છે કરી, અન્ન<sub class="text-[10px]">૦</sub>
                                        <span class="text-12 inline-box">૧૩૭</span>
                                    </p>
                                    <p>
                                        <a class="recipe" data-id="R0694" href="?id=R0694" sup-id="">
                                            કાચરી મરચાંની<sup class="red">૬૯૪</sup>
                                        </a>
                                        <a class="recipe" data-id="R0695" href="?id=R0695" sup-id="">
                                            તૂરિયાંની<sup class="red">૬૯૫</sup>
                                        </a>
                                        , અન્ન<sub class="text-[10px]">૦</sub>
                                        <span class="text-12 invisible lg:hidden inline-box">૦૦૦</span>
                                        <br class="lg:hidden"/>
                                        જમો કાચરી 
                                        <a class="recipe" data-id="R0696" href="?id=R0696" sup-id="">
                                            કોઠીંબાની<sup class="red">૬૯૬</sup>
                                        </a>
                                        , અન્ન<sub class="text-[10px]">૦</sub>
                                        <span class="text-12 invisible">૦૦૦</span>
                                    </p>
                                    <p>
                                        સ્વાદિષ્ટ રાઈતાં નવીનાં અન્ન<sub class="text-[10px]">૦</sub>
                                        <span class="text-12 invisible lg:hidden inline-box">૦૦૦</span>
                                        <br class="lg:hidden"/>
                                        જમો વિધવિધ શાકભાજીનાં, અન્ન<sub class="text-[10px]">૦</sub>
                                        <span class="text-12 inline-box">૧૩૮</span>
                                    </p>
                                    <p>
                                        રૂડું 
                                        <a class="recipe" data-id="R0697" href="?id=R0697" sup-id="">
                                            રાઈતું ધર્યું કાકડીનું<sup class="red">૬૯૭</sup>
                                        </a>
                                        , અન્ન<sub class="text-[10px]">૦</sub>
                                        <span class="text-12 invisible lg:hidden inline-box">૦૦૦</span>
                                        <br class="lg:hidden"/>
                                        <a class="recipe" data-id="R0698" href="?id=R0698" sup-id="R0698">
                                            ગાજરનું<sup class="red">૬૯૮</sup>
                                        </a>
                                        ને 
                                        <a class="recipe" data-id="R0699" href="?id=R0699" sup-id="">
                                            મોગરીનું<sup class="red">૬૯૯</sup>
                                        </a>
                                        , અન્ન<sub class="text-[10px]">૦</sub>
                                        <span class="text-12 invisible">૦૦૦</span>
                                    </p>
                                    <p>
                                        ખાસ 
                                        <a class="recipe" data-id="R0700" href="?id=R0700" sup-id="">
                                            રાઈતું વેજિટેબલ<sup class="red">૭૦૦</sup>
                                        </a>
                                        , અન્ન<sub class="text-[10px]">૦</sub>
                                        <span class="text-12 invisible lg:hidden inline-box">૦૦૦</span>
                                        <br class="lg:hidden"/>
                                        <a class="recipe" data-id="R0701" href="?id=R0701" sup-id="">
                                            કેળાંદિનાં રાઈતાં<sup class="red">૭૦૧</sup>
                                        </a>
                                        અવલ, અન્ન<sub class="text-[10px]">૦</sub>
                                        <span class="text-12 inline-box">૧૩૯</span>
                                    </p>
                                    <h3>રાબ</h3>
                                    <p>
                                        રૂડી 
                                        <a class="recipe" data-id="R0702" href="?id=R0702" sup-id="">
                                            રાબ જમો બાજરાની<sup class="red">૭૦૨</sup>
                                        </a>
                                        , અન્ન<sub class="text-[10px]">૦</sub>
                                        <span class="text-12 invisible lg:hidden inline-box">૦૦૦</span>
                                        <br class="lg:hidden"/>
                                        વળી કરી છે 
                                        <a class="recipe" data-id="R0703" href="?id=R0703" sup-id="R0703">
                                            રાજગરાની<sup class="red">૭૦૩</sup>
                                        </a>
                                        , અન્ન<sub class="text-[10px]">૦</sub>
                                        <span class="text-12 invisible">૦૦૦</span>
                                    </p>
                                    <p>
                                        રાબ 
                                        <a class="recipe" data-id="R0704" href="?id=R0704" sup-id="R0704">
                                            જુવારની<sup class="red">૭૦૪</sup>
                                        </a>
                                        <a class="recipe" data-id="R0705" href="?id=R0705" sup-id="R0705">
                                            ઘઉંની<sup class="red">૭૦૫</sup>
                                        </a>
                                        , અન્ન<sub class="text-[10px]">૦</sub>
                                        <span class="text-12 invisible lg:hidden inline-box">૦૦૦</span>
                                        <br class="lg:hidden"/>
                                        નાખી તેજાના કરી ઊની, અન્ન<sub class="text-[10px]">૦</sub>
                                        <span class="text-12 inline-box">૧૪૦</span>
                                    </p>
                                    <h3>ભાત</h3>
                                    <p>
                                        કર્યા ભાતભાતના ભાત, અન્ન<sub class="text-[10px]">૦</sub>
                                        <span class="text-12 invisible lg:hidden inline-box">૦૦૦</span>
                                        <br class="lg:hidden"/>
                                        તમે જમોને મારા તાત, અન્ન<sub class="text-[10px]">૦</sub>
                                        <span class="text-12 invisible">૦૦૦</span>
                                    </p>
                                    <p>
                                        <a class="recipe" data-id="R0706" href="?id=R0706" sup-id="">
                                            સાદા ભાત<sup class="red">૭૦૬</sup>
                                        </a>
                                        <a class="recipe" data-id="R0707" href="?id=R0707" sup-id="">
                                            વઘારેલ ભાત<sup class="red">૭૦૭</sup>
                                        </a>
                                        , અન્ન<sub class="text-[10px]">૦</sub>
                                        <span class="text-12 invisible lg:hidden inline-box">૦૦૦</span>
                                        <br class="lg:hidden"/>
                                        <a class="recipe" data-id="R0708" href="?id=R0708" sup-id="">
                                            કરમલડો<sup class="red">૭૦૮</sup>
                                        </a>
                                        જે દહીં-ભાત, અન્ન<sub class="text-[10px]">૦</sub>
                                        <span class="text-12 inline-box">૧૪૧</span>
                                    </p>
                                    <p>
                                        <a class="recipe" data-id="R0709" href="?id=R0709" sup-id="">
                                            સેલણ<sup class="red">૭૦૯</sup>
                                        </a>
                                        જે ઘી ગોળ ભાત, અન્ન<sub class="text-[10px]">૦</sub>
                                        <span class="text-12 invisible lg:hidden inline-box">૦૦૦</span>
                                        <br class="lg:hidden"/>
                                        જમો 
                                        <a class="recipe" data-id="R0710" href="?id=R0710" sup-id="">
                                            ઘી-ખાંડ સાથે ભાત<sup class="red">૭૧૦</sup>
                                        </a>
                                        , અન્ન<sub class="text-[10px]">૦</sub>
                                        <span class="text-12 invisible">૦૦૦</span>
                                    </p>
                                    <p>
                                        <a class="recipe" data-id="R0711" href="?id=R0711" sup-id="">
                                            જીરા રાઇસ<sup class="red">૭૧૧</sup>
                                        </a>
                                        <a class="recipe" data-id="R0712" href="?id=R0712" sup-id="">
                                            ટોમેટો રાઇસ<sup class="red">૭૧૨</sup>
                                        </a>
                                        , અન્ન<sub class="text-[10px]">૦</sub>
                                        <span class="text-12 invisible lg:hidden inline-box">૦૦૦</span>
                                        <br class="lg:hidden"/>
                                        જમો 
                                        <a class="recipe" data-id="R0713" href="?id=R0713" sup-id="">
                                            કોકોનટ રાઇસ<sup class="red">૭૧૩</sup>
                                        </a>
                                        , અન્ન<sub class="text-[10px]">૦</sub>
                                        <span class="text-12 inline-box">૧૪૨</span>
                                    </p>
                                    <p>
                                        છે 
                                        <a class="recipe" data-id="R0714" href="?id=R0714" sup-id="">
                                            રાઇસ રૂડા સીઝવાન<sup class="red">૭૧૪</sup>
                                        </a>
                                        , અન્ન<sub class="text-[10px]">૦</sub>
                                        <span class="text-12 invisible lg:hidden inline-box">૦૦૦</span>
                                        <br class="lg:hidden"/>
                                        તમે ભાવે જમો ભગવાન, અન્ન<sub class="text-[10px]">૦</sub>
                                        <span class="text-12 invisible">૦૦૦</span>
                                    </p>
                                    <p>
                                        <a class="recipe" data-id="R0715" href="?id=R0715" sup-id="">
                                            લેમન રાઇસ<sup class="red">૭૧૫</sup>
                                        </a>
                                        <a class="recipe" data-id="R0716" href="?id=R0716" sup-id="">
                                            ચિત્રાના રાઇસ<sup class="red">૭૧૬</sup>
                                        </a>
                                        , અન્ન<sub class="text-[10px]">૦</sub>
                                        <span class="text-12 invisible lg:hidden inline-box">૦૦૦</span>
                                        <br class="lg:hidden"/>
                                        <a class="recipe" data-id="R0717" href="?id=R0717" sup-id="">
                                            ફ્રાઇડ રાઇસ<sup class="red">૭૧૭</sup>
                                        </a>
                                        <a class="recipe" data-id="R0718" href="?id=R0718" sup-id="">
                                            ફુદીના રાઇસ<sup class="red">૭૧૮</sup>
                                        </a>
                                        , અન્ન<sub class="text-[10px]">૦</sub>
                                        <span class="text-12 inline-box">૧૪૩</span>
                                    </p>
                                    <p>
                                        <a class="recipe" data-id="R0719" href="?id=R0719" sup-id="">
                                            રાઇસ મેક્સિકન<sup class="red">૭૧૯</sup>
                                        </a>
                                        સુખદાની, અન્ન<sub class="text-[10px]">૦</sub>
                                        <span class="text-12 invisible lg:hidden inline-box">૦૦૦</span>
                                        <br class="lg:hidden"/>
                                        જમો 
                                        <a class="recipe" data-id="R0720" href="?id=R0720" sup-id="">
                                            વેજિટેબલ બિરયાની<sup class="red">૭૨૦</sup>
                                        </a>
                                        , અન્ન<sub class="text-[10px]">૦</sub>
                                        <span class="text-12 invisible">૦૦૦</span>
                                    </p>
                                    <p>
                                        જમો 
                                        <a class="recipe" data-id="R0721" href="?id=R0721" sup-id="">
                                            વેજિટેબલ પુલાવ<sup class="red">૭૨૧</sup>
                                        </a>
                                        , અન્ન<sub class="text-[10px]">૦</sub>
                                        <span class="text-12 invisible lg:hidden inline-box">૦૦૦</span>
                                        <br class="lg:hidden"/>
                                        <a class="recipe" data-id="R0722" href="?id=R0722" sup-id="">
                                            શાહી પુલાવ<sup class="red">૭૨૨</sup>
                                        </a>
                                        <a class="recipe" data-id="R0723" href="?id=R0723" sup-id="">
                                            ગ્રીન પુલાવ<sup class="red">૭૨૩</sup>
                                        </a>
                                        , અન્ન<sub class="text-[10px]">૦</sub>
                                        <span class="text-12 inline-box">૧૪૪</span>
                                    </p>
                                    <p>
                                        <a class="recipe" data-id="R0724" href="?id=R0724" sup-id="">
                                            મીઠો કાશ્મીરી પુલાવ<sup class="red">૭૨૪</sup>
                                        </a>
                                        , અન્ન<sub class="text-[10px]">૦</sub>
                                        <span class="text-12 invisible lg:hidden inline-box">૦૦૦</span>
                                        <br class="lg:hidden"/>
                                        જમો 
                                        <a class="recipe" data-id="R0725" href="?id=R0725" sup-id="">
                                            તીખો તવા પુલાવ<sup class="red">૭૨૫</sup>
                                        </a>
                                        , અન્ન<sub class="text-[10px]">૦</sub>
                                        <span class="text-12 invisible">૦૦૦</span>
                                    </p>
                                    <p>
                                        <a class="recipe" data-id="R0726" href="?id=R0726" sup-id="R0726">
                                            થૂલી<sup class="red">૭૨૬</sup>
                                        </a>
                                        <a class="recipe" data-id="R0727" href="?id=R0727" sup-id="">
                                            ઉપમા<sup class="red">૭૨૭</sup>
                                        </a>
                                        ને 
                                        <a class="recipe" data-id="R0728" href="?id=R0728" sup-id="">
                                            પોંગલ<sup class="red">૭૨૮</sup>
                                        </a>
                                        , અન્ન<sub class="text-[10px]">૦</sub>
                                        <span class="text-12 invisible lg:hidden inline-box">૦૦૦</span>
                                        <br class="lg:hidden"/>
                                        જો જો ભાવ અમારો અવલ, અન્ન<sub class="text-[10px]">૦</sub>
                                        <span class="text-12 inline-box">૧૪૫</span>
                                    </p>
                                    <p>
                                        <a class="recipe" data-id="R0729" href="?id=R0729" sup-id="">
                                            તુવેરદાળની છે ખીચડી<sup class="red">૭૨૯</sup>
                                        </a>
                                        , અન્ન<sub class="text-[10px]">૦</sub>
                                        <span class="text-12 invisible lg:hidden inline-box">૦૦૦</span>
                                        <br class="lg:hidden"/>
                                        <a class="recipe" data-id="R0730" href="?id=R0730" sup-id="">
                                            મગ-ચોખાની આ ખીચડી<sup class="red">૭૩૦</sup>
                                        </a>
                                        , અન્ન<sub class="text-[10px]">૦</sub>
                                        <span class="text-12 invisible">૦૦૦</span>
                                    </p>
                                    <p>
                                        <a class="recipe" data-id="R0731" href="?id=R0731" sup-id="">
                                            ઓટ ખીચડી<sup class="red">૭૩૧</sup>
                                        </a>
                                        <a class="recipe" data-id="R0732" href="?id=R0732" sup-id="">
                                            ક્વિનવા ખીચડી<sup class="red">૭૩૨</sup>
                                        </a>
                                        , અન્ન<sub class="text-[10px]">૦</sub>
                                        <span class="text-12 invisible lg:hidden inline-box">૦૦૦</span>
                                        <br class="lg:hidden"/>
                                        મેં તો બનાવી 
                                        <a class="recipe" data-id="R0733" href="?id=R0733" sup-id="">
                                            કચ્છી ખીચડી<sup class="red">૭૩૩</sup>
                                        </a>
                                        , અન્ન<sub class="text-[10px]">૦</sub>
                                        <span class="text-12 inline-box">૧૪૬</span>
                                    </p>
                                    <p>
                                        જમો 
                                        <a class="recipe" data-id="R0734" href="?id=R0734" sup-id="">
                                            વેજિટેબલ ખીચડી<sup class="red">૭૩૪</sup>
                                        </a>
                                        , અન્ન<sub class="text-[10px]">૦</sub>
                                        <span class="text-12 invisible lg:hidden inline-box">૦૦૦</span>
                                        <br class="lg:hidden"/>
                                        બહુ ભાતના 
                                        <a class="recipe" data-id="R0735" href="?id=R0735" sup-id="">
                                            ફ્રૂટની ખીચડી<sup class="red">૭૩૫</sup>
                                        </a>
                                        , અન્ન<sub class="text-[10px]">૦</sub>
                                        <span class="text-12 invisible">૦૦૦</span>
                                    </p>
                                    <h3>દાળ</h3>
                                    <p>
                                        <a class="recipe" data-id="R0736" href="?id=R0736" sup-id="R0736">
                                            તુવેરદાળ<sup class="red">૭૩૬</sup>
                                        </a>
                                        <a class="recipe" data-id="R0737" href="?id=R0737" sup-id="R0737">
                                            મગની દાળ<sup class="red">૭૩૭</sup>
                                        </a>
                                        , અન્ન<sub class="text-[10px]">૦</sub>
                                        <span class="text-12 invisible lg:hidden inline-box">૦૦૦</span>
                                        <br class="lg:hidden"/>
                                        <a class="recipe" data-id="R0738" href="?id=R0738" sup-id="">
                                            તડકાદાળ<sup class="red">૭૩૮</sup>
                                        </a>
                                        <a class="recipe" data-id="R0739" href="?id=R0739" sup-id="R0739">
                                            મસુરદાળ<sup class="red">૭૩૯</sup>
                                        </a>
                                        , અન્ન<sub class="text-[10px]">૦</sub>
                                        <span class="text-12 inline-box">૧૪૭</span>
                                    </p>
                                    <p>
                                        <a class="recipe" data-id="R0740" href="?id=R0740" sup-id="">
                                            દાળ ત્રેવડી<sup class="red">૭૪૦</sup>
                                        </a>
                                        <a class="recipe" data-id="R0741" href="?id=R0741" sup-id="R0741">
                                            અડદની દાળ<sup class="red">૭૪૧</sup>
                                        </a>
                                        , અન્ન<sub class="text-[10px]">૦</sub>
                                        <span class="text-12 invisible lg:hidden inline-box">૦૦૦</span>
                                        <br class="lg:hidden"/>
                                        તમે જમો 
                                        <a class="recipe" data-id="R0742" href="?id=R0742" sup-id="">
                                            પાલખની દાળ<sup class="red">૭૪૨</sup>
                                        </a>
                                        , અન્ન<sub class="text-[10px]">૦</sub>
                                        <span class="text-12 invisible">૦૦૦</span>
                                    </p>
                                    <p>
                                        <a class="recipe" data-id="R0743" href="?id=R0743" sup-id="R0743">
                                            કાઠિયાવાડી<sup class="red">૭૪૩</sup>
                                        </a>
                                        <a class="recipe" data-id="R0744" href="?id=R0744" sup-id="R0744">
                                            સુરતી<sup class="red">૭૪૪</sup>
                                        </a>
                                        કઢી, અન્ન<sub class="text-[10px]">૦</sub>
                                        <span class="text-12 invisible lg:hidden inline-box">૦૦૦</span>
                                        <br class="lg:hidden"/>
                                        <a class="recipe" data-id="R0745" href="?id=R0745" sup-id="">
                                            ગોળની<sup class="red">૭૪૫</sup>
                                        </a>
                                        <a class="recipe" data-id="R0746" href="?id=R0746" sup-id="">
                                            કોકમની<sup class="red">૭૪૬</sup>
                                        </a>
                                        કઢી, અન્ન<sub class="text-[10px]">૦</sub>
                                        <span class="text-12 inline-box">૧૪૮</span>
                                    </p>
                                    <p>
                                        કઢી છે 
                                        <a class="recipe" data-id="R0747" href="?id=R0747" sup-id="">
                                            આખા મરચાંની<sup class="red">૭૪૭</sup>
                                        </a>
                                        , અન્ન<sub class="text-[10px]">૦</sub>
                                        <span class="text-12 invisible lg:hidden inline-box">૦૦૦</span>
                                        <br class="lg:hidden"/>
                                        રોગનાશક 
                                        <a class="recipe" data-id="R0748" href="?id=R0748" sup-id="R0748">
                                            સરગવાની<sup class="red">૭૪૮</sup>
                                        </a>
                                        , અન્ન<sub class="text-[10px]">૦</sub>
                                        <span class="text-12 invisible">૦૦૦</span>
                                    </p>
                                    <p>
                                        <a class="recipe" data-id="R0749" href="?id=R0749" sup-id="">
                                            કઢી રીંગણાંની<sup class="red">૭૪૯</sup>
                                        </a>
                                        <a class="recipe" data-id="R0750" href="?id=R0750" sup-id="">
                                            ભીંડાની<sup class="red">૭૫૦</sup>
                                        </a>
                                        , અન્ન<sub class="text-[10px]">૦</sub>
                                        <span class="text-12 invisible lg:hidden inline-box">૦૦૦</span>
                                        <br class="lg:hidden"/>
                                        ઘીમાં વઘારી તાજી મઝાની, અન્ન<sub class="text-[10px]">૦</sub>
                                        <span class="text-12 inline-box">૧૪૯</span>
                                    </p>
                                    <p>
                                        રૂડા 
                                        <a class="recipe" data-id="R0751" href="?id=R0751" sup-id="">
                                            દહીંની છે તીખારી<sup class="red">૭૫૧</sup>
                                        </a>
                                        , અન્ન<sub class="text-[10px]">૦</sub>
                                        <span class="text-12 invisible lg:hidden inline-box">૦૦૦</span>
                                        <br class="lg:hidden"/>
                                        બહુ સારા મસાલે વઘારી, અન્ન<sub class="text-[10px]">૦</sub>
                                        <span class="text-12 invisible">૦૦૦</span>
                                    </p>
                                    <p>
                                        <a class="recipe" data-id="R0752" href="?id=R0752" sup-id="">
                                            દાલફ્રાય<sup class="red">૭૫૨</sup>
                                        </a>
                                        <a class="recipe" data-id="R0753" href="?id=R0753" sup-id="">
                                            રસમ<sup class="red">૭૫૩</sup>
                                        </a>
                                        <a class="recipe" data-id="R0754" href="?id=R0754" sup-id="R0754">
                                            સાંભાર<sup class="red">૭૫૪</sup>
                                        </a>
                                        , અન્ન<sub class="text-[10px]">૦</sub>
                                        <span class="text-12 invisible lg:hidden inline-box">૦૦૦</span>
                                        <br class="lg:hidden"/>
                                        તમે જમજો મારા યાર, અન્ન<sub class="text-[10px]">૦</sub>
                                        <span class="text-12 inline-box">૧૫૦</span>
                                    </p>
                                    <h3>સૂપ</h3>
                                    <p>
                                        રૂડું 
                                        <a class="recipe" data-id="R0755" href="?id=R0755" sup-id="">
                                            ટમેટાનું છે સૂપ<sup class="red">૭૫૫</sup>
                                        </a>
                                        , અન્ન<sub class="text-[10px]">૦</sub>
                                        <span class="text-12 invisible lg:hidden inline-box">૦૦૦</span>
                                        <br class="lg:hidden"/>
                                        <a class="recipe" data-id="R0756" href="?id=R0756" sup-id="">
                                            દૂધીનું<sup class="red">૭૫૬</sup>
                                        </a>
                                        <a class="recipe" data-id="R0757" href="?id=R0757" sup-id="">
                                            પાલખનું સૂપ<sup class="red">૭૫૭</sup>
                                        </a>
                                        , અન્ન<sub class="text-[10px]">૦</sub>
                                        <span class="text-12 invisible">૦૦૦</span>
                                    </p>
                                    <p>
                                        જમો 
                                        <a class="recipe" data-id="R0758" href="?id=R0758" sup-id="">
                                            વેજિટેબલ સૂપ<sup class="red">૭૫૮</sup>
                                        </a>
                                        , અન્ન<sub class="text-[10px]">૦</sub>
                                        <span class="text-12 invisible lg:hidden inline-box">૦૦૦</span>
                                        <br class="lg:hidden"/>
                                        <a class="recipe" data-id="R0759" href="?id=R0759" sup-id="">
                                            ગાજરનું સૂપ<sup class="red">૭૫૯</sup>
                                        </a>
                                        અનુપ, અન્ન<sub class="text-[10px]">૦</sub>
                                        <span class="text-12 inline-box">૧૫૧</span>
                                    </p>
                                    <p>
                                        <a class="recipe" data-id="R0760" href="?id=R0760" sup-id="">
                                            મીનીસ્ટ્રોન સૂપ<sup class="red">૭૬૦</sup>
                                        </a>
                                        છે સારું, અન્ન<sub class="text-[10px]">૦</sub>
                                        <span class="text-12 invisible lg:hidden inline-box">૦૦૦</span>
                                        <br class="lg:hidden"/>
                                        <a class="recipe" data-id="R0761" href="?id=R0761" sup-id="">
                                            કોર્નસૂપ<sup class="red">૭૬૧</sup>
                                        </a>
                                        છે બહુ પ્યારું, અન્ન<sub class="text-[10px]">૦</sub>
                                        <span class="text-12 invisible">૦૦૦</span>
                                    </p>
                                    <p>
                                        <a class="recipe" data-id="R0762" href="?id=R0762" sup-id="">
                                            વેજિટેબલ મન્ચાવ સૂપ<sup class="red">૭૬૨</sup>
                                        </a>
                                        , અન્ન<sub class="text-[10px]">૦</sub>
                                        <span class="text-12 invisible lg:hidden inline-box">૦૦૦</span>
                                        <br class="lg:hidden"/>
                                        <a class="recipe" data-id="R0763" href="?id=R0763" sup-id="">
                                            ચીલી સૂપ<sup class="red">૭૬૩</sup>
                                        </a>
                                        <a class="recipe" data-id="R0764" href="?id=R0764" sup-id="">
                                            મેક્રોની સૂપ<sup class="red">૭૬૪</sup>
                                        </a>
                                        , અન્ન<sub class="text-[10px]">૦</sub>
                                        <span class="text-12 inline-box">૧૫૨</span>
                                    </p>
                                    <p>
                                        <a class="recipe" data-id="R0765" href="?id=R0765" sup-id="R0765">
                                            ટોર્ટીલા<sup class="red">૭૬૫</sup>
                                        </a>
                                        ને 
                                        <a class="recipe" data-id="R0766" href="?id=R0766" sup-id="">
                                            બ્રોકોલી સૂપ<sup class="red">૭૬૬</sup>
                                        </a>
                                        , અન્ન<sub class="text-[10px]">૦</sub>
                                        <span class="text-12 invisible lg:hidden inline-box">૦૦૦</span>
                                        <br class="lg:hidden"/>
                                        પીઓ 
                                        <a class="recipe" data-id="R0767" href="?id=R0767" sup-id="">
                                            હોટ એન્ડ સોર સૂપ<sup class="red">૭૬૭</sup>
                                        </a>
                                        , અન્ન<sub class="text-[10px]">૦</sub>
                                        <span class="text-12 invisible">૦૦૦</span>
                                    </p>
                                    <p>
                                        રૂડું 
                                        <a class="recipe" data-id="R0768" href="?id=R0768" sup-id="">
                                            સરગવાનું સૂપ<sup class="red">૭૬૮</sup>
                                        </a>
                                        , અન્ન<sub class="text-[10px]">૦</sub>
                                        <span class="text-12 invisible lg:hidden inline-box">૦૦૦</span>
                                        <br class="lg:hidden"/>
                                        શાકભાજીનાં અનેક સૂપ, અન્ન<sub class="text-[10px]">૦</sub>
                                        <span class="text-12 inline-box">૧૫૩</span>
                                    </p>
                                    <h3>પાપડ</h3>
                                    <p>
                                        જમો પાપડ મારા પ્યારા, અન્ન<sub class="text-[10px]">૦</sub>
                                        <span class="text-12 invisible lg:hidden inline-box">૦૦૦</span>
                                        <br class="lg:hidden"/>
                                        આગે ધર્યા ન્યારા ન્યારા, અન્ન<sub class="text-[10px]">૦</sub>
                                        <span class="text-12 invisible">૦૦૦</span>
                                    </p>
                                    <p>
                                        <a class="recipe" data-id="R0769" href="?id=R0769" sup-id="">
                                            પાપડ મકાઈના<sup class="red">૭૬૯</sup>
                                        </a>
                                        <a class="recipe" data-id="R0770" href="?id=R0770" sup-id="">
                                            ચોખાના<sup class="red">૭૭૦</sup>
                                        </a>
                                        , અન્ન<sub class="text-[10px]">૦</sub>
                                        <span class="text-12 invisible lg:hidden inline-box">૦૦૦</span>
                                        <br class="lg:hidden"/>
                                        <a class="recipe" data-id="R0771" href="?id=R0771" sup-id="">
                                            પાપડ ઘઉંના<sup class="red">૭૭૧</sup>
                                        </a>
                                        <a class="recipe" data-id="R0772" href="?id=R0772" sup-id="R0772">
                                            અડદના<sup class="red">૭૭૨</sup>
                                        </a>
                                        , અન્ન<sub class="text-[10px]">૦</sub>
                                        <span class="text-12 inline-box">૧૫૪</span>
                                    </p>
                                    <p>
                                        જમો રૂડા પાપડ શેકેલા, અન્ન<sub class="text-[10px]">૦</sub>
                                        <span class="text-12 invisible lg:hidden inline-box">૦૦૦</span>
                                        <br class="lg:hidden"/>
                                        <a class="recipe" data-id="R0773" href="?id=R0773" sup-id="">
                                            મસાલા પાપડ<sup class="red">૭૭૩</sup>
                                        </a>
                                        તળેલા, અન્ન<sub class="text-[10px]">૦</sub>
                                        <span class="text-12 invisible">૦૦૦</span>
                                    </p>
                                    <p>
                                        જમો 
                                        <a class="recipe" data-id="R0774" href="?id=R0774" sup-id="">
                                            જુવારના પાપડ<sup class="red">૭૭૪</sup>
                                        </a>
                                        , અન્ન<sub class="text-[10px]">૦</sub>
                                        <span class="text-12 invisible lg:hidden inline-box">૦૦૦</span>
                                        <br class="lg:hidden"/>
                                        થશે જમતા બહુ કડકડ, અન્ન<sub class="text-[10px]">૦</sub>
                                        <span class="text-12 inline-box">૧૫૫</span>
                                    </p>
                                    <p>
                                        પ્યારી 
                                        <a class="ingredient" data-id="I0231" href="?id=I0231" sup-id="">
                                            પાપડી<sup class="red">૭૭૫</sup>
                                        </a>
                                        ને 
                                        <a class="recipe" data-id="R0776" href="?id=R0776" sup-id="">
                                            ફરફર<sup class="red">૭૭૬</sup>
                                        </a>
                                        , અન્ન<sub class="text-[10px]">૦</sub>
                                        <span class="text-12 invisible lg:hidden inline-box">૦૦૦</span>
                                        <br class="lg:hidden"/>
                                        ભાવે કકડાવો હરિવર, અન્ન<sub class="text-[10px]">૦</sub>
                                        <span class="text-12 invisible">૦૦૦</span>
                                    </p>
                                    <h3>બેકરીની આઇટમ</h3>
                                    <p>
                                        જમો બેકરીની વાનગી, અન્ન<sub class="text-[10px]">૦</sub>
                                        <span class="text-12 invisible lg:hidden inline-box">૦૦૦</span>
                                        <br class="lg:hidden"/>
                                        છે અનેકવિધ મનગમી, અન્ન<sub class="text-[10px]">૦</sub>
                                        <span class="text-12 inline-box">૧૫૬</span>
                                    </p>
                                    <p>
                                        જમો 
                                        <a class="recipe" data-id="R0777" href="?id=R0777" sup-id="">
                                            બિસ્કિટ છે કાજુના<sup class="red">૭૭૭</sup>
                                        </a>
                                        , અન્ન<sub class="text-[10px]">૦</sub>
                                        <span class="text-12 invisible lg:hidden inline-box">૦૦૦</span>
                                        <br class="lg:hidden"/>
                                        વળી 
                                        <a class="recipe" data-id="R0778" href="?id=R0778" sup-id="">
                                            કેસરના<sup class="red">૭૭૮</sup>
                                        </a>
                                        <a class="recipe" data-id="R0779" href="?id=R0779" sup-id="">
                                            કોકોના<sup class="red">૭૭૯</sup>
                                        </a>
                                        , અન્ન<sub class="text-[10px]">૦</sub>
                                        <span class="text-12 invisible">૦૦૦</span>
                                    </p>
                                    <p>
                                        <a class="recipe" data-id="R0780" href="?id=R0780" sup-id="">
                                            બિસ્કિટ છે કોપરાના<sup class="red">૭૮૦</sup>
                                        </a>
                                        , અન્ન<sub class="text-[10px]">૦</sub>
                                        <span class="text-12 invisible lg:hidden inline-box">૦૦૦</span>
                                        <br class="lg:hidden"/>
                                        જમો પ્યારા આ 
                                        <a class="recipe" data-id="R0781" href="?id=R0781" sup-id="R0781">
                                            અખરોટના<sup class="red">૭૮૧</sup>
                                        </a>
                                        , અન્ન<sub class="text-[10px]">૦</sub>
                                        <span class="text-12 inline-box">૧૫૭</span>
                                    </p>
                                    <p>
                                        પ્યારા 
                                        <a class="recipe" data-id="R0782" href="?id=R0782" sup-id="">
                                            પીનટના<sup class="red">૭૮૨</sup>
                                        </a>
                                        <a class="recipe" data-id="R0783" href="?id=R0783" sup-id="">
                                            બટરના<sup class="red">૭૮૩</sup>
                                        </a>
                                        , અન્ન<sub class="text-[10px]">૦</sub>
                                        <span class="text-12 invisible lg:hidden inline-box">૦૦૦</span>
                                        <br class="lg:hidden"/>
                                        <a class="recipe" data-id="R0784" href="?id=R0784" sup-id="">
                                            બોરબોન<sup class="red">૭૮૪</sup>
                                        </a>
                                        તથા 
                                        <a class="recipe" data-id="R0785" href="?id=R0785" sup-id="R0785">
                                            બદામના<sup class="red">૭૮૫</sup>
                                        </a>
                                        , અન્ન<sub class="text-[10px]">૦</sub>
                                        <span class="text-12 invisible">૦૦૦</span>
                                    </p>
                                    <p>
                                        <a class="recipe" data-id="R0786" href="?id=R0786" sup-id="">
                                            ક્રીમ બિસ્કિટ<sup class="red">૭૮૬</sup>
                                        </a>
                                        <a class="recipe" data-id="R0787" href="?id=R0787" sup-id="">
                                            જીરા બિસ્કિટ<sup class="red">૭૮૭</sup>
                                        </a>
                                        , અન્ન<sub class="text-[10px]">૦</sub>
                                        <span class="text-12 invisible lg:hidden inline-box">૦૦૦</span>
                                        <br class="lg:hidden"/>
                                        વાલા જમો 
                                        <a class="recipe" data-id="R0788" href="?id=R0788" sup-id="">
                                            વેફર બિસ્કિટ<sup class="red">૭૮૮</sup>
                                        </a>
                                        , અન્ન<sub class="text-[10px]">૦</sub>
                                        <span class="text-12 inline-box">૧૫૮</span>
                                    </p>
                                    <p>
                                        જમો છે 
                                        <a class="recipe" data-id="R0789" href="?id=R0789" sup-id="">
                                            ડ્રાયફ્રૂટ કુકિઝ<sup class="red">૭૮૯</sup>
                                        </a>
                                        , અન્ન<sub class="text-[10px]">૦</sub>
                                        <span class="text-12 invisible lg:hidden inline-box">૦૦૦</span>
                                        <br class="lg:hidden"/>
                                        <a class="recipe" data-id="R0790" href="?id=R0790" sup-id="">
                                            કેસર-બદામ-પિસ્તા કુકિઝ<sup class="red">૭૯૦</sup>
                                        </a>
                                        , અન્ન<sub class="text-[10px]">૦</sub>
                                        <span class="text-12 invisible">૦૦૦</span>
                                    </p>
                                    <p>
                                        જમો 
                                        <a class="recipe" data-id="R0791" href="?id=R0791" sup-id="">
                                            ચોકો ઓટ્સ કુકિઝ<sup class="red">૭૯૧</sup>
                                        </a>
                                        , અન્ન<sub class="text-[10px]">૦</sub>
                                        <span class="text-12 invisible lg:hidden inline-box">૦૦૦</span>
                                        <br class="lg:hidden"/>
                                        વળી 
                                        <a class="recipe" data-id="R0792" href="?id=R0792" sup-id="">
                                            કાજુ-હની કુકિઝ<sup class="red">૭૯૨</sup>
                                        </a>
                                        , અન્ન<sub class="text-[10px]">૦</sub>
                                        <span class="text-12 inline-box">૧૫૯</span>
                                    </p>
                                    <p>
                                        જમો 
                                        <a class="recipe" data-id="R0793" href="?id=R0793" sup-id="">
                                            કોકોનટ કુકિઝ<sup class="red">૭૯૩</sup>
                                        </a>
                                        , અન્ન<sub class="text-[10px]">૦</sub>
                                        <span class="text-12 invisible lg:hidden inline-box">૦૦૦</span>
                                        <br class="lg:hidden"/>
                                        રૂડી 
                                        <a class="recipe" data-id="R0794" href="?id=R0794" sup-id="">
                                            હની ઓટ્સ કુકિઝ<sup class="red">૭૯૪</sup>
                                        </a>
                                        , અન્ન<sub class="text-[10px]">૦</sub>
                                        <span class="text-12 invisible">૦૦૦</span>
                                    </p>
                                    <p>
                                        <a class="recipe" data-id="R0795" href="?id=R0795" sup-id="">
                                            શીંગ-રાજગરા કુકિઝ<sup class="red">૭૯૫</sup>
                                        </a>
                                        , અન્ન<sub class="text-[10px]">૦</sub>
                                        <span class="text-12 invisible lg:hidden inline-box">૦૦૦</span>
                                        <br class="lg:hidden"/>
                                        વાલા 
                                        <a class="recipe" data-id="R0796" href="?id=R0796" sup-id="">
                                            ચોકલેટ ચીપ કુકિઝ<sup class="red">૭૯૬</sup>
                                        </a>
                                        , અન્ન<sub class="text-[10px]">૦</sub>
                                        <span class="text-12 inline-box">૧૬૦</span>
                                    </p>
                                    <p>
                                        <a class="recipe" data-id="R0797" href="?id=R0797" sup-id="">
                                            ચોકોલેટ કુકિઝ<sup class="red">૭૯૭</sup>
                                        </a>
                                        છે સાર, અન્ન<sub class="text-[10px]">૦</sub>
                                        <span class="text-12 invisible lg:hidden inline-box">૦૦૦</span>
                                        <br class="lg:hidden"/>
                                        વાલા જમો 
                                        <a class="recipe" data-id="R0798" href="?id=R0798" sup-id="">
                                            ગ્રનોલા બાર<sup class="red">૭૯૮</sup>
                                        </a>
                                        , અન્ન<sub class="text-[10px]">૦</sub>
                                        <span class="text-12 invisible">૦૦૦</span>
                                    </p>
                                    <p>
                                        જમો 
                                        <a class="recipe" data-id="R0799" href="?id=R0799" sup-id="">
                                            સુરતી નાનખટાઈ<sup class="red">૭૯૯</sup>
                                        </a>
                                        , અન્ન<sub class="text-[10px]">૦</sub>
                                        <span class="text-12 invisible lg:hidden inline-box">૦૦૦</span>
                                        <br class="lg:hidden"/>
                                        વળી 
                                        <a class="recipe" data-id="R0800" href="?id=R0800" sup-id="">
                                            બદામ નાનખટાઈ<sup class="red">૮૦૦</sup>
                                        </a>
                                        , અન્ન<sub class="text-[10px]">૦</sub>
                                        <span class="text-12 inline-box">૧૬૧</span>
                                    </p>
                                    <p>
                                        <a class="recipe" data-id="R0801" href="?id=R0801" sup-id="">
                                            વેનીલા નાનખટાઈ<sup class="red">૮૦૧</sup>
                                        </a>
                                        , અન્ન<sub class="text-[10px]">૦</sub>
                                        <span class="text-12 invisible lg:hidden inline-box">૦૦૦</span>
                                        <br class="lg:hidden"/>
                                        <a class="recipe" data-id="R0802" href="?id=R0802" sup-id="">
                                            ઓરેંજ નાનખટાઈ<sup class="red">૮૦૨</sup>
                                        </a>
                                        , અન્ન<sub class="text-[10px]">૦</sub>
                                        <span class="text-12 invisible">૦૦૦</span>
                                    </p>
                                    <p>
                                        <a class="recipe" data-id="R0803" href="?id=R0803" sup-id="">
                                            પાઇનેપલ નાનખટાઈ<sup class="red">૮૦૩</sup>
                                        </a>
                                        , અન્ન<sub class="text-[10px]">૦</sub>
                                        <span class="text-12 invisible lg:hidden inline-box">૦૦૦</span>
                                        <br class="lg:hidden"/>
                                        છે 
                                        <a class="recipe" data-id="R0804" href="?id=R0804" sup-id="">
                                            ચોકલેટ નાનખટાઈ<sup class="red">૮૦૪</sup>
                                        </a>
                                        , અન્ન<sub class="text-[10px]">૦</sub>
                                        <span class="text-12 inline-box">૧૬૨</span>
                                    </p>
                                    <p>
                                        <a class="recipe" data-id="R0805" href="?id=R0805" sup-id="">
                                            પિસ્તાની નાનખટાઈ<sup class="red">૮૦૫</sup>
                                        </a>
                                        , અન્ન<sub class="text-[10px]">૦</sub>
                                        <span class="text-12 invisible lg:hidden inline-box">૦૦૦</span>
                                        <br class="lg:hidden"/>
                                        એવી અનેક જમો મુજ રાય, અન્ન<sub class="text-[10px]">૦</sub>
                                        <span class="text-12 invisible">૦૦૦</span>
                                    </p>
                                    <p>
                                        <a class="recipe" data-id="R0806" href="?id=R0806" sup-id="">
                                            કાજુપૂરી<sup class="red">૮૦૬</sup>
                                        </a>
                                        ને 
                                        <a class="recipe" data-id="R0807" href="?id=R0807" sup-id="">
                                            બદામપૂરી<sup class="red">૮૦૭</sup>
                                        </a>
                                        , અન્ન<sub class="text-[10px]">૦</sub>
                                        <span class="text-12 invisible lg:hidden inline-box">૦૦૦</span>
                                        <br class="lg:hidden"/>
                                        જમો 
                                        <a class="recipe" data-id="R0808" href="?id=R0808" sup-id="">
                                            કાજુ-પિસ્તાપૂરી<sup class="red">૮૦૮</sup>
                                        </a>
                                        , અન્ન<sub class="text-[10px]">૦</sub>
                                        <span class="text-12 inline-box">૧૬૩</span>
                                    </p>
                                    <p>
                                        <a class="recipe" data-id="R0809" href="?id=R0809" sup-id="">
                                            મેંગો કેક<sup class="red">૮૦૯</sup>
                                        </a>
                                        <a class="recipe" data-id="R0810" href="?id=R0810" sup-id="">
                                            ચોકલેટ કેક<sup class="red">૮૧૦</sup>
                                        </a>
                                        , અન્ન<sub class="text-[10px]">૦</sub>
                                        <span class="text-12 invisible lg:hidden inline-box">૦૦૦</span>
                                        <br class="lg:hidden"/>
                                        જમો 
                                        <a class="recipe" data-id="R0811" href="?id=R0811" sup-id="">
                                            પાઇનેપલની કેક<sup class="red">૮૧૧</sup>
                                        </a>
                                        , અન્ન<sub class="text-[10px]">૦</sub>
                                        <span class="text-12 invisible">૦૦૦</span>
                                    </p>
                                    <p>
                                        <a class="recipe" data-id="R0812" href="?id=R0812" sup-id="">
                                            કેરટ કેક<sup class="red">૮૧૨</sup>
                                        </a>
                                        <a class="recipe" data-id="R0813" href="?id=R0813" sup-id="">
                                            સ્ટ્રોબેરી કેક<sup class="red">૮૧૩</sup>
                                        </a>
                                        , અન્ન<sub class="text-[10px]">૦</sub>
                                        <span class="text-12 invisible lg:hidden inline-box">૦૦૦</span>
                                        <br class="lg:hidden"/>
                                        વળી 
                                        <a class="recipe" data-id="R0814" href="?id=R0814" sup-id="">
                                            બ્લેક ફોરેસ્ટ કેક<sup class="red">૮૧૪</sup>
                                        </a>
                                        , અન્ન<sub class="text-[10px]">૦</sub>
                                        <span class="text-12 inline-box">૧૬૪</span>
                                    </p>
                                    <p>
                                        <a class="recipe" data-id="R0815" href="?id=R0815" sup-id="">
                                            મીલ્ક કેક<sup class="red">૮૧૫</sup>
                                        </a>
                                        <a class="recipe" data-id="R0816" href="?id=R0816" sup-id="">
                                            બિસ્કિટ કેક<sup class="red">૮૧૬</sup>
                                        </a>
                                        , અન્ન<sub class="text-[10px]">૦</sub>
                                        <span class="text-12 invisible lg:hidden inline-box">૦૦૦</span>
                                        <br class="lg:hidden"/>
                                        <a class="recipe" data-id="R0817" href="?id=R0817" sup-id="">
                                            કપ કેક<sup class="red">૮૧૭ </sup>
                                        </a>
                                        ને 
                                        <a class="recipe" data-id="R0818" href="?id=R0818" sup-id="">
                                            પેસ્ટ્રી કેક<sup class="red">૮૧૮</sup>
                                        </a>
                                        , અન્ન<sub class="text-[10px]">૦</sub>
                                        <span class="text-12 invisible">૦૦૦</span>
                                    </p>
                                    <p>
                                        <a class="recipe" data-id="R0819" href="?id=R0819" sup-id="">
                                            ચીઝ કેક<sup class="red">૮૧૯</sup>
                                        </a>
                                        <a class="recipe" data-id="R0820" href="?id=R0820" sup-id="">
                                            જામફળ કેક<sup class="red">૮૨૦</sup>
                                        </a>
                                        , અન્ન<sub class="text-[10px]">૦</sub>
                                        <span class="text-12 invisible lg:hidden inline-box">૦૦૦</span>
                                        <br class="lg:hidden"/>
                                        <a class="recipe" data-id="R0821" href="?id=R0821" sup-id="">
                                            પેન કેક<sup class="red">૮૨૧</sup>
                                        </a>
                                        ને 
                                        <a class="recipe" data-id="R0822" href="?id=R0822" sup-id="">
                                            પાઉન્ડ કેક<sup class="red">૮૨૨</sup>
                                        </a>
                                        , અન્ન<sub class="text-[10px]">૦</sub>
                                        <span class="text-12 inline-box">૧૬૫</span>
                                    </p>
                                    <p>
                                        <a class="recipe" data-id="R0823" href="?id=R0823" sup-id="">
                                            ફનલ કેક<sup class="red">૮૨૩</sup>
                                        </a>
                                        <a class="recipe" data-id="R0824" href="?id=R0824" sup-id="">
                                            આઇસક્રીમ કેક<sup class="red">૮૨૪</sup>
                                        </a>
                                        , અન્ન<sub class="text-[10px]">૦</sub>
                                        <span class="text-12 invisible lg:hidden inline-box">૦૦૦</span>
                                        <br class="lg:hidden"/>
                                        જમો 
                                        <a class="recipe" data-id="R0825" href="?id=R0825" sup-id="">
                                            રેડ વેલ્વેટ કેક<sup class="red">૮૨૫</sup>
                                        </a>
                                        , અન્ન<sub class="text-[10px]">૦</sub>
                                        <span class="text-12 invisible">૦૦૦</span>
                                    </p>
                                    <p>
                                        જમો 
                                        <a class="recipe" data-id="R0826" href="?id=R0826" sup-id="">
                                            સ્ટ્રોબેરી શોર્ટ કેક<sup class="red">૮૨૬</sup>
                                        </a>
                                        , અન્ન<sub class="text-[10px]">૦</sub>
                                        <span class="text-12 invisible lg:hidden inline-box">૦૦૦</span>
                                        <br class="lg:hidden"/>
                                        આવી કેક જમોને અનેક, અન્ન<sub class="text-[10px]">૦</sub>
                                        <span class="text-12 inline-box">૧૬૬</span>
                                    </p>
                                    <p>
                                        <a class="recipe" data-id="R0827" href="?id=R0827" sup-id="">
                                            એપલ પાઈ<sup class="red">૮૨૭</sup>
                                        </a>
                                        <a class="recipe" data-id="R0828" href="?id=R0828" sup-id="">
                                            પમ્પકીન પાઈ<sup class="red">૮૨૮</sup>
                                        </a>
                                        , અન્ન<sub class="text-[10px]">૦</sub>
                                        <span class="text-12 invisible lg:hidden inline-box">૦૦૦</span>
                                        <br class="lg:hidden"/>
                                        તમે હેતે જમો મારા રાય, અન્ન<sub class="text-[10px]">૦</sub>
                                        <span class="text-12 invisible">૦૦૦</span>
                                    </p>
                                    <p>
                                        <a class="recipe" data-id="R0829" href="?id=R0829" sup-id="">
                                            ઘઉં ટોસ્ટ<sup class="red">૮૨૯</sup>
                                        </a>
                                        ને 
                                        <a class="recipe" data-id="R0830" href="?id=R0830" sup-id="">
                                            જીરા ટોસ્ટ<sup class="red">૮૩૦</sup>
                                        </a>
                                        , અન્ન<sub class="text-[10px]">૦</sub>
                                        <span class="text-12 invisible lg:hidden inline-box">૦૦૦</span>
                                        <br class="lg:hidden"/>
                                        <a class="recipe" data-id="R0831" href="?id=R0831" sup-id="">
                                            ફ્રૂટ ટોસ્ટ<sup class="red">૮૩૧</sup>
                                        </a>
                                        ને 
                                        <a class="recipe" data-id="R0832" href="?id=R0832" sup-id="">
                                            મિલ્ક ટોસ્ટ<sup class="red">૮૩૨</sup>
                                        </a>
                                        , અન્ન<sub class="text-[10px]">૦</sub>
                                        <span class="text-12 inline-box">૧૬૭</span>
                                    </p>
                                    <p>
                                        <a class="recipe" data-id="R0833" href="?id=R0833" sup-id="">
                                            કેક રસ્ક<sup class="red">૮૩૩</sup>
                                        </a>
                                        <a class="recipe" data-id="R0834" href="?id=R0834" sup-id="">
                                            માવા ટોસ્ટ<sup class="red">૮૩૪</sup>
                                        </a>
                                        , અન્ન<sub class="text-[10px]">૦</sub>
                                        <span class="text-12 invisible lg:hidden inline-box">૦૦૦</span>
                                        <br class="lg:hidden"/>
                                        <a class="recipe" data-id="R0835" href="?id=R0835" sup-id="">
                                            ફ્રેંચ ટોસ્ટ<sup class="red">૮૩૫</sup>
                                        </a>
                                        <a class="recipe" data-id="R0836" href="?id=R0836" sup-id="R0836">
                                            ટૂટીફ્રૂટી ટોસ્ટ<sup class="red">૮૩૬</sup>
                                        </a>
                                        , અન્ન<sub class="text-[10px]">૦</sub>
                                        <span class="text-12 invisible">૦૦૦</span>
                                    </p>
                                    <p>
                                        જમો છે 
                                        <a class="recipe" data-id="R0837" href="?id=R0837" sup-id="">
                                            આવકાડો ટોસ્ટ<sup class="red">૮૩૭</sup>
                                        </a>
                                        , અન્ન<sub class="text-[10px]">૦</sub>
                                        <span class="text-12 invisible lg:hidden inline-box">૦૦૦</span>
                                        <br class="lg:hidden"/>
                                        સારા 
                                        <a class="recipe" data-id="R0838" href="?id=R0838" sup-id="">
                                            ચીલી ચીઝ ટોસ્ટ<sup class="red">૮૩૮</sup>
                                        </a>
                                        , અન્ન<sub class="text-[10px]">૦</sub>
                                        <span class="text-12 inline-box">૧૬૮</span>
                                    </p>
                                    <p>
                                        <a class="recipe" data-id="R0839" href="?id=R0839" sup-id="">
                                            જીરા ખારી<sup class="red">૮૩૯</sup>
                                        </a>
                                        <a class="recipe" data-id="R0840" href="?id=R0840" sup-id="">
                                            બટર ખારી<sup class="red">૮૪૦</sup>
                                        </a>
                                        , અન્ન<sub class="text-[10px]">૦</sub>
                                        <span class="text-12 invisible lg:hidden inline-box">૦૦૦</span>
                                        <br class="lg:hidden"/>
                                        <a class="recipe" data-id="R0841" href="?id=R0841" sup-id="">
                                            મેથી ખારી<sup class="red">૮૪૧</sup>
                                        </a>
                                        <a class="recipe" data-id="R0842" href="?id=R0842" sup-id="">
                                            મસાલા ખારી<sup class="red">૮૪૨</sup>
                                        </a>
                                        , અન્ન<sub class="text-[10px]">૦</sub>
                                        <span class="text-12 invisible">૦૦૦</span>
                                    </p>
                                    <p>
                                        <a class="recipe" data-id="R0843" href="?id=R0843" sup-id="">
                                            ચીઝ ખારી<sup class="red">૮૪૩</sup>
                                        </a>
                                        છે બહુ ન્યારી, અન્ન<sub class="text-[10px]">૦</sub>
                                        <span class="text-12 invisible lg:hidden inline-box">૦૦૦</span>
                                        <br class="lg:hidden"/>
                                        પ્રભુ લાગશે તમને પ્યારી, અન્ન<sub class="text-[10px]">૦</sub>
                                        <span class="text-12 inline-box">૧૬૯</span>
                                    </p>
                                    <p>
                                        <a class="recipe" data-id="R0844" href="?id=R0844" sup-id="">
                                            પાઇનેપલના ક્રિમરોલ<sup class="red">૮૪૪</sup>
                                        </a>
                                        , અન્ન<sub class="text-[10px]">૦</sub>
                                        <span class="text-12 invisible lg:hidden inline-box">૦૦૦</span>
                                        <br class="lg:hidden"/>
                                        <a class="recipe" data-id="R0845" href="?id=R0845" sup-id="R0845">
                                            વેનીલા<sup class="red">૮૪૫</sup>
                                        </a>
                                        <a class="recipe" data-id="R0846" href="?id=R0846" sup-id="">
                                            સ્ટ્રોબેરી રોલ<sup class="red">૮૪૬</sup>
                                        </a>
                                        , અન્ન<sub class="text-[10px]">૦</sub>
                                        <span class="text-12 invisible">૦૦૦</span>
                                    </p>
                                    <p>
                                        જમો 
                                        <a class="recipe" data-id="R0847" href="?id=R0847" sup-id="">
                                            ચોકલેટ ક્રિમરોલ<sup class="red">૮૪૭</sup>
                                        </a>
                                        , અન્ન<sub class="text-[10px]">૦</sub>
                                        <span class="text-12 invisible lg:hidden inline-box">૦૦૦</span>
                                        <br class="lg:hidden"/>
                                        છે 
                                        <a class="recipe" data-id="R0848" href="?id=R0848" sup-id="">
                                            બટરસ્કોચ ક્રિમરોલ<sup class="red">૮૪૮</sup>
                                        </a>
                                        , અન્ન<sub class="text-[10px]">૦</sub>
                                        <span class="text-12 inline-box">૧૭૦</span>
                                    </p>
                                    <p>
                                        <a class="recipe" data-id="R0849" href="?id=R0849" sup-id="">
                                            ચૂરોઝ<sup class="red">૮૪૯</sup>
                                        </a>
                                        <a class="recipe" data-id="R0850" href="?id=R0850" sup-id="">
                                            ઓરેંજ ક્રિમરોલ<sup class="red">૮૫૦</sup>
                                        </a>
                                        , અન્ન<sub class="text-[10px]">૦</sub>
                                        <span class="text-12 invisible lg:hidden inline-box">૦૦૦</span>
                                        <br class="lg:hidden"/>
                                        <a class="recipe" data-id="R0851" href="?id=R0851" sup-id="">
                                            સિનેમન<sup class="red">૮૫૧</sup>
                                        </a>
                                        ને 
                                        <a class="recipe" data-id="R0852" href="?id=R0852" sup-id="">
                                            ક્રોસન્ટ રોલ<sup class="red">૮૫૨</sup>
                                        </a>
                                        , અન્ન<sub class="text-[10px]">૦</sub>
                                        <span class="text-12 invisible">૦૦૦</span>
                                    </p>
                                    <p>
                                        જમો 
                                        <a class="recipe" data-id="R0853" href="?id=R0853" sup-id="">
                                            મસાલા બન<sup class="red">૮૫૩</sup>
                                        </a>
                                        <a class="recipe" data-id="R0854" href="?id=R0854" sup-id="">
                                            મફીન<sup class="red">૮૫૪</sup>
                                        </a>
                                        , અન્ન<sub class="text-[10px]">૦</sub>
                                        <span class="text-12 invisible lg:hidden inline-box">૦૦૦</span>
                                        <br class="lg:hidden"/>
                                        <a class="recipe" data-id="R0855" href="?id=R0855" sup-id="">
                                            ડોનટ<sup class="red">૮૫૫</sup>
                                        </a>
                                        <a class="recipe" data-id="R0856" href="?id=R0856" sup-id="">
                                            બેગલ<sup class="red">૮૫૬</sup>
                                        </a>
                                        <a class="recipe" data-id="R0857" href="?id=R0857" sup-id="">
                                            મંચકીન<sup class="red">૮૫૭</sup>
                                        </a>
                                        , અન્ન<sub class="text-[10px]">૦</sub>
                                        <span class="text-12 inline-box">૧૭૧</span>
                                    </p>
                                    <p>
                                        <a class="recipe" data-id="R0858" href="?id=R0858" sup-id="">
                                            પીનટ બટર જેલી સેન્ડવીચ<sup class="red">૮૫૮</sup>
                                        </a>
                                        , અન્ન<sub class="text-[10px]">૦</sub>
                                        <span class="text-12 invisible lg:hidden inline-box">૦૦૦</span>
                                        <br class="lg:hidden"/>
                                        વચ્ચે જેલી ભરી છે ગીચ, અન્ન<sub class="text-[10px]">૦</sub>
                                        <span class="text-12 invisible">૦૦૦</span>
                                    </p>
                                    <p>
                                        જમો 
                                        <a class="recipe" data-id="R0859" href="?id=R0859" sup-id="">
                                            એપલ ક્રિસ્પ<sup class="red">૮૫૯</sup>
                                        </a>
                                        <a class="recipe" data-id="R0860" href="?id=R0860" sup-id="">
                                            વફલ<sup class="red">૮૬૦</sup>
                                        </a>
                                        , અન્ન<sub class="text-[10px]">૦</sub>
                                        <span class="text-12 invisible lg:hidden inline-box">૦૦૦</span>
                                        <br class="lg:hidden"/>
                                        જમો 
                                        <a class="recipe" data-id="R0861" href="?id=R0861" sup-id="">
                                            મસ્કાબન<sup class="red">૮૬૧</sup>
                                        </a>
                                        નવલ, અન્ન<sub class="text-[10px]">૦</sub>
                                        <span class="text-12 inline-box">૧૭૨</span>
                                    </p>
                                    <p>
                                        <a class="recipe" data-id="R0862" href="?id=R0862" sup-id="">
                                            તિરામીસુ<sup class="red">૮૬૨</sup>
                                        </a>
                                        ને 
                                        <a class="recipe" data-id="R0863" href="?id=R0863" sup-id="">
                                            ડ્રીમબાર<sup class="red">૮૬૩</sup>
                                        </a>
                                        , અન્ન<sub class="text-[10px]">૦</sub>
                                        <span class="text-12 invisible lg:hidden inline-box">૦૦૦</span>
                                        <br class="lg:hidden"/>
                                        <a class="recipe" data-id="R0864" href="?id=R0864" sup-id="">
                                            બકલાવા<sup class="red">૮૬૪</sup>
                                        </a>
                                        જમો કરી પ્યાર, અન્ન<sub class="text-[10px]">૦</sub>
                                        <span class="text-12 invisible">૦૦૦</span>
                                    </p>
                                    <p>
                                        <a class="recipe" data-id="R0865" href="?id=R0865" sup-id="">
                                            કેરેમલ ફજ<sup class="red">૮૬૫</sup>
                                        </a>
                                        ને 
                                        <a class="recipe" data-id="R0866" href="?id=R0866" sup-id="">
                                            બ્રાઉની<sup class="red">૮૬૬</sup>
                                        </a>
                                        , અન્ન<sub class="text-[10px]">૦</sub>
                                        <span class="text-12 invisible lg:hidden inline-box">૦૦૦</span>
                                        <br class="lg:hidden"/>
                                        ભાવના છે ભક્ત સહુની, અન્ન<sub class="text-[10px]">૦</sub>
                                        <span class="text-12 inline-box">૧૭૩</span>
                                    </p>
                                    <p>
                                        <a class="recipe" data-id="R0867" href="?id=R0867" sup-id="">
                                            બ્રુશેટા<sup class="red">૮૬૭</sup>
                                        </a>
                                        <a class="recipe" data-id="R0868" href="?id=R0868" sup-id="">
                                            વેનીલા પુડીંગ<sup class="red">૮૬૮</sup>
                                        </a>
                                        , અન્ન<sub class="text-[10px]">૦</sub>
                                        <span class="text-12 invisible lg:hidden inline-box">૦૦૦</span>
                                        <br class="lg:hidden"/>
                                        <a class="recipe" data-id="R0869" href="?id=R0869" sup-id="">
                                            કુલ વીપ<sup class="red">૮૬૯</sup>
                                        </a>
                                        <a class="recipe" data-id="R0870" href="?id=R0870" sup-id="">
                                            ચોકલેટ પુડીંગ<sup class="red">૮૭૦</sup>
                                        </a>
                                        , અન્ન<sub class="text-[10px]">૦</sub>
                                        <span class="text-12 invisible">૦૦૦</span>
                                    </p>
                                    <p>
                                        હરિ જમો 
                                        <a class="recipe" data-id="R0871" href="?id=R0871" sup-id="">
                                            ટૂટીફ્રૂટી બ્રેડ<sup class="red">૮૭૧</sup>
                                        </a>
                                        , અન્ન<sub class="text-[10px]">૦</sub>
                                        <span class="text-12 invisible lg:hidden inline-box">૦૦૦</span>
                                        <br class="lg:hidden"/>
                                        સારી બની 
                                        <a class="recipe" data-id="R0872" href="?id=R0872" sup-id="">
                                            બનાના બ્રેડ<sup class="red">૮૭૨</sup>
                                        </a>
                                        , અન્ન<sub class="text-[10px]">૦</sub>
                                        <span class="text-12 inline-box">૧૭૪</span>
                                    </p>
                                    <p>
                                        <a class="recipe" data-id="R0873" href="?id=R0873" sup-id="">
                                            ચોકલેટ ફોન્ડુ<sup class="red">૮૭૩</sup>
                                        </a>
                                        છે ન્યારા, અન્ન<sub class="text-[10px]">૦</sub>
                                        <span class="text-12 invisible lg:hidden inline-box">૦૦૦</span>
                                        <br class="lg:hidden"/>
                                        જમો વિધવિધ આઇટમ પ્યારા, અન્ન<sub class="text-[10px]">૦</sub>
                                        <span class="text-12 invisible">૦૦૦</span>
                                    </p>
                                    <p>
                                        <a class="recipe" data-id="R0874" href="?id=R0874" sup-id="">
                                            ચોકલેટ<sup class="red">૮૭૪</sup>
                                        </a>
                                        છે બહુ પ્રકાર, અન્ન<sub class="text-[10px]">૦</sub>
                                        <span class="text-12 invisible lg:hidden inline-box">૦૦૦</span>
                                        <br class="lg:hidden"/>
                                        અતિ હેતે કરો આહાર, અન્ન<sub class="text-[10px]">૦</sub>
                                        <span class="text-12 inline-box">૧૭૫</span>
                                    </p>
                                    <h3>જામ</h3>
                                    <p>
                                        તમે વિધવિધ જમો જામ, અન્ન<sub class="text-[10px]">૦</sub>
                                        <span class="text-12 invisible lg:hidden inline-box">૦૦૦</span>
                                        <br class="lg:hidden"/>
                                        મારા ઇષ્ટદેવ ઘનશ્યામ, અન્ન<sub class="text-[10px]">૦</sub>
                                        <span class="text-12 invisible">૦૦૦</span>
                                    </p>
                                    <p>
                                        <a class="recipe" data-id="R0875" href="?id=R0875" sup-id="">
                                            મેંગો જામ<sup class="red">૮૭૫</sup>
                                        </a>
                                        ને 
                                        <a class="recipe" data-id="R0876" href="?id=R0876" sup-id="">
                                            એપલ જામ<sup class="red">૮૭૬</sup>
                                        </a>
                                        , અન્ન<sub class="text-[10px]">૦</sub>
                                        <span class="text-12 invisible lg:hidden inline-box">૦૦૦</span>
                                        <br class="lg:hidden"/>
                                        જમો 
                                        <a class="recipe" data-id="R0877" href="?id=R0877" sup-id="">
                                            મિક્સ ફ્રૂટનો જામ<sup class="red">૮૭૭</sup>
                                        </a>
                                        , અન્ન<sub class="text-[10px]">૦</sub>
                                        <span class="text-12 inline-box">૧૭૬</span>
                                    </p>
                                    <p>
                                        <a class="recipe" data-id="R0878" href="?id=R0878" sup-id="">
                                            પીચ જામ<sup class="red">૮૭૮</sup>
                                        </a>
                                        ને 
                                        <a class="recipe" data-id="R0879" href="?id=R0879" sup-id="">
                                            ગ્વાવા જામ<sup class="red">૮૭૯</sup>
                                        </a>
                                        , અન્ન<sub class="text-[10px]">૦</sub>
                                        <span class="text-12 invisible lg:hidden inline-box">૦૦૦</span>
                                        <br class="lg:hidden"/>
                                        આરોગો 
                                        <a class="recipe" data-id="R0880" href="?id=R0880" sup-id="">
                                            ઓરેન્જ જામ<sup class="red">૮૮૦</sup>
                                        </a>
                                        , અન્ન<sub class="text-[10px]">૦</sub>
                                        <span class="text-12 invisible">૦૦૦</span>
                                    </p>
                                    <p>
                                        જમો 
                                        <a class="recipe" data-id="R0881" href="?id=R0881" sup-id="">
                                            પાઇનેપલનો જામ<sup class="red">૮૮૧</sup>
                                        </a>
                                        , અન્ન<sub class="text-[10px]">૦</sub>
                                        <span class="text-12 invisible lg:hidden inline-box">૦૦૦</span>
                                        <br class="lg:hidden"/>
                                        સ્નેહે જમો 
                                        <a class="recipe" data-id="R0882" href="?id=R0882" sup-id="">
                                            સ્ટ્રોબેરી જામ<sup class="red">૮૮૨</sup>
                                        </a>
                                        , અન્ન<sub class="text-[10px]">૦</sub>
                                        <span class="text-12 inline-box">૧૭૭</span>
                                    </p>
                                    <p>
                                        અમે બનાવી લાવ્યા ખાસ, અન્ન<sub class="text-[10px]">૦</sub>
                                        <span class="text-12 invisible lg:hidden inline-box">૦૦૦</span>
                                        <br class="lg:hidden"/>
                                        આરોગ્યદ 
                                        <a class="recipe" data-id="R0883" href="?id=R0883" sup-id="">
                                            ચ્યવનપ્રાસ<sup class="red">૮૮૩</sup>
                                        </a>
                                        , અન્ન<sub class="text-[10px]">૦</sub>
                                        <span class="text-12 invisible">૦૦૦</span>
                                    </p>
                                    <h3>ફ્રૂટ</h3>
                                    <p>
                                        રૂડાં ફ્રૂટ તાજાં રસાળ, અન્ન<sub class="text-[10px]">૦</sub>
                                        <span class="text-12 invisible lg:hidden inline-box">૦૦૦</span>
                                        <br class="lg:hidden"/>
                                        તમે જમોને મારા દયાળ, અન્ન<sub class="text-[10px]">૦</sub>
                                        <span class="text-12 inline-box">૧૭૮</span>
                                    </p>
                                    <p>
                                        <a class="ingredient" data-id="I0075" href="?id=I0075" sup-id="">
                                            ચીકુ<sup class="red">૮૮૪</sup>
                                        </a>
                                        <a class="ingredient" data-id="I0040" href="?id=I0040" sup-id="">
                                            કેરી<sup class="red">૮૮૫</sup>
                                        </a>
                                        <a class="ingredient" data-id="I0180" href="?id=I0180" sup-id="">
                                            લીલી દ્રાક્ષ<sup class="red">૮૮૬</sup>
                                        </a>
                                        , અન્ન<sub class="text-[10px]">૦</sub>
                                        <span class="text-12 invisible lg:hidden inline-box">૦૦૦</span>
                                        <br class="lg:hidden"/>
                                        <a class="ingredient" data-id="I0042" href="?id=I0042" sup-id="">
                                            કેળાં સોનેરી<sup class="red">૮૮૭</sup>
                                        </a>
                                        <a class="ingredient" data-id="I0177" href="?id=I0177" sup-id="">
                                            કાળી દ્રાક્ષ<sup class="red">૮૮૮</sup>
                                        </a>
                                        , અન્ન<sub class="text-[10px]">૦</sub>
                                        <span class="text-12 invisible">૦૦૦</span>
                                    </p>
                                    <p>
                                        <a class="ingredient" data-id="I0059" href="?id=I0059" sup-id="">
                                            ગલેલી<sup class="red">૮૮૯</sup>
                                        </a>
                                        ને 
                                        <a class="ingredient" data-id="I0064" href="?id=I0064" sup-id="">
                                            ગોરસઆંબલી<sup class="red">૮૯૦</sup>
                                        </a>
                                        , અન્ન<sub class="text-[10px]">૦</sub>
                                        <span class="text-12 invisible lg:hidden inline-box">૦૦૦</span>
                                        <br class="lg:hidden"/>
                                        તૂરી ગળી ને વળી ભલી, અન્ન<sub class="text-[10px]">૦</sub>
                                        <span class="text-12 inline-box">૧૭૯</span>
                                    </p>
                                    <p>
                                        <a class="ingredient" data-id="I0085" href="?id=I0085" sup-id="">
                                            જામફળ<sup class="red">૮૯૧</sup>
                                        </a>
                                        <a class="ingredient" data-id="I0103" href="?id=I0103" sup-id="">
                                            દાડમ<sup class="red">૮૯૨</sup>
                                        </a>
                                        ને 
                                        <a class="ingredient" data-id="I0078" href="?id=I0078" sup-id="">
                                            ચેરી<sup class="red">૮૯૩</sup>
                                        </a>
                                        , અન્ન<sub class="text-[10px]">૦</sub>
                                        <span class="text-12 invisible lg:hidden inline-box">૦૦૦</span>
                                        <br class="lg:hidden"/>
                                        <a class="ingredient" data-id="I0121" href="?id=I0121" sup-id="">
                                            પેર<sup class="red">૮૯૪</sup>
                                        </a>
                                        <a class="ingredient" data-id="I0113" href="?id=I0113" sup-id="">
                                            પપૈયાં<sup class="red">૮૯૫</sup>
                                        </a>
                                        <a class="ingredient" data-id="I0215" href="?id=I0215" sup-id="">
                                            સ્ટ્રોબેરી<sup class="red">૮૯૬</sup>
                                        </a>
                                        , અન્ન<sub class="text-[10px]">૦</sub>
                                        <span class="text-12 invisible">૦૦૦</span>
                                    </p>
                                    <p>
                                        <a class="ingredient" data-id="I0189" href="?id=I0189" sup-id="">
                                            સાકરટેટી<sup class="red">૮૯૭</sup>
                                        </a>
                                        ને 
                                        <a class="ingredient" data-id="I0108" href="?id=I0108" sup-id="">
                                            નારંગી<sup class="red">૮૯૮</sup>
                                        </a>
                                        , અન્ન<sub class="text-[10px]">૦</sub>
                                        <span class="text-12 invisible lg:hidden inline-box">૦૦૦</span>
                                        <br class="lg:hidden"/>
                                        <a class="ingredient" data-id="I0110" href="?id=I0110" sup-id="">
                                            નાસપતી<sup class="red">૮૯૯</sup>
                                        </a>
                                        ને 
                                        <a class="ingredient" data-id="I0158" href="?id=I0158" sup-id="">
                                            મોસંબી<sup class="red">૯૦૦</sup>
                                        </a>
                                        , અન્ન<sub class="text-[10px]">૦</sub>
                                        <span class="text-12 inline-box">૧૮૦</span>
                                    </p>
                                    <p>
                                        <a class="ingredient" data-id="I0097" href="?id=I0097" sup-id="">
                                            તરબૂચ<sup class="red">૯૦૧</sup>
                                        </a>
                                        ને 
                                        <a class="ingredient" data-id="I0204" href="?id=I0204" sup-id="">
                                            સીતાફળ<sup class="red">૯૦૨</sup>
                                        </a>
                                        , અન્ન<sub class="text-[10px]">૦</sub>
                                        <span class="text-12 invisible lg:hidden inline-box">૦૦૦</span>
                                        <br class="lg:hidden"/>
                                        <a class="ingredient" data-id="I0038" href="?id=I0038" sup-id="">
                                            કીવી<sup class="red">૯૦૩</sup>
                                        </a>
                                        <a class="ingredient" data-id="I0196" href="?id=I0196" sup-id="">
                                            સંતરાં<sup class="red">૯૦૪</sup>
                                        </a>
                                        ને 
                                        <a class="ingredient" data-id="I0163" href="?id=I0163" sup-id="">
                                            રામફળ<sup class="red">૯૦૫</sup>
                                        </a>
                                        , અન્ન<sub class="text-[10px]">૦</sub>
                                        <span class="text-12 invisible">૦૦૦</span>
                                    </p>
                                    <p>
                                        <a class="ingredient" data-id="I0072" href="?id=I0072" sup-id="">
                                            ચણીબોર<sup class="red">૯૦૬</sup>
                                        </a>
                                        <a class="ingredient" data-id="I0017" href="?id=I0017" sup-id="">
                                            એપલબોર<sup class="red">૯૦૭</sup>
                                        </a>
                                        , અન્ન<sub class="text-[10px]">૦</sub>
                                        <span class="text-12 invisible lg:hidden inline-box">૦૦૦</span>
                                        <br class="lg:hidden"/>
                                        <a class="ingredient" data-id="I0035" href="?id=I0035" sup-id="">
                                            કાશીબોર<sup class="red">૯૦૮</sup>
                                        </a>
                                        <a class="ingredient" data-id="I0065" href="?id=I0065" sup-id="">
                                            ગોલાબોર<sup class="red">૯૦૯</sup>
                                        </a>
                                        , અન્ન<sub class="text-[10px]">૦</sub>
                                        <span class="text-12 inline-box">૧૮૧</span>
                                    </p>
                                    <p>
                                        <a class="ingredient" data-id="I0263" href="?id=I0263" sup-id="">
                                            લીલા નાળિયેર<sup class="red">૯૧૦</sup>
                                        </a>
                                        <a class="ingredient" data-id="I0169" href="?id=I0169" sup-id="">
                                            લાલ ખારેક<sup class="red">૯૧૧</sup>
                                        </a>
                                        , અન્ન<sub class="text-[10px]">૦</sub>
                                        <span class="text-12 invisible lg:hidden inline-box">૦૦૦</span>
                                        <br class="lg:hidden"/>
                                        <a class="ingredient" data-id="I0054" href="?id=I0054" sup-id="">
                                            ખલેલાં<sup class="red">૯૧૨</sup>
                                        </a>
                                        ને 
                                        <a class="ingredient" data-id="I0120" href="?id=I0120" sup-id="">
                                            પીળી ખારેક<sup class="red">૯૧૩</sup>
                                        </a>
                                        , અન્ન<sub class="text-[10px]">૦</sub>
                                        <span class="text-12 invisible">૦૦૦</span>
                                    </p>
                                    <p>
                                        જમો 
                                        <a class="ingredient" data-id="I0194" href="?id=I0194" sup-id="">
                                            શેરડી<sup class="red">૯૧૪</sup>
                                        </a>
                                        <a class="ingredient" data-id="I0197" href="?id=I0197" sup-id="">
                                            સફરજન<sup class="red">૯૧૫</sup>
                                        </a>
                                        , અન્ન<sub class="text-[10px]">૦</sub>
                                        <span class="text-12 invisible lg:hidden inline-box">૦૦૦</span>
                                        <br class="lg:hidden"/>
                                        <a class="ingredient" data-id="I0060" href="?id=I0060" sup-id="">
                                            ગળી આંબલી<sup class="red">૯૧૬</sup>
                                        </a>
                                        <a class="ingredient" data-id="I0114" href="?id=I0114" sup-id="">
                                            પર્શીમન<sup class="red">૯૧૭</sup>
                                        </a>
                                        , અન્ન<sub class="text-[10px]">૦</sub>
                                        <span class="text-12 inline-box">૧૮૨</span>
                                    </p>
                                    <p>
                                        <a class="ingredient" data-id="I0045" href="?id=I0045" sup-id="">
                                            કોઠાં<sup class="red">૯૧૮</sup>
                                        </a>
                                        <a class="ingredient" data-id="I0174" href="?id=I0174" sup-id="">
                                            લીચી<sup class="red">૯૧૯</sup>
                                        </a>
                                        <a class="ingredient" data-id="I0005" href="?id=I0005" sup-id="">
                                            અન્નાનસ<sup class="red">૯૨૦</sup>
                                        </a>
                                        , અન્ન<sub class="text-[10px]">૦</sub>
                                        <span class="text-12 invisible lg:hidden inline-box">૦૦૦</span>
                                        <br class="lg:hidden"/>
                                        <a class="ingredient" data-id="I0084" href="?id=I0084" sup-id="">
                                            જાંબુ<sup class="red">૯૨૧</sup>
                                        </a>
                                        <a class="recipe" data-id="R0922" href="?id=R0922" sup-id="">
                                            શિંગોડાં<sup class="red">૯૨૨</sup>
                                        </a>
                                        <a class="ingredient" data-id="I0123" href="?id=I0123" sup-id="">
                                            ફણસ<sup class="red">૯૨૩</sup>
                                        </a>
                                        , અન્ન<sub class="text-[10px]">૦</sub>
                                        <span class="text-12 invisible">૦૦૦</span>
                                    </p>
                                    <p>
                                        <a class="ingredient" data-id="I0132" href="?id=I0132" sup-id="">
                                            બીજોરાં<sup class="red">૯૨૪</sup>
                                        </a>
                                        <a class="ingredient" data-id="I0181" href="?id=I0181" sup-id="">
                                            લીલી બદામ<sup class="red">૯૨૫</sup>
                                        </a>
                                        , અન્ન<sub class="text-[10px]">૦</sub>
                                        <span class="text-12 invisible lg:hidden inline-box">૦૦૦</span>
                                        <br class="lg:hidden"/>
                                        <a class="ingredient" data-id="I0094" href="?id=I0094" sup-id="">
                                            ડ્રેગન<sup class="red">૯૨૬</sup>
                                        </a>
                                        ફ્રૂટ જમો શ્યામ, અન્ન<sub class="text-[10px]">૦</sub>
                                        <span class="text-12 inline-box">૧૮૩</span>
                                    </p>
                                    <p>
                                        <a class="ingredient" data-id="I0119" href="?id=I0119" sup-id="">
                                            પીચ<sup class="red">૯૨૭</sup>
                                        </a>
                                        <a class="ingredient" data-id="I0164" href="?id=I0164" sup-id="">
                                            રાયણ<sup class="red">૯૨૮</sup>
                                        </a>
                                        <a class="ingredient" data-id="I0014" href="?id=I0014" sup-id="">
                                            રૂડા આલુ<sup class="red">૯૨૯</sup>
                                        </a>
                                        , અન્ન<sub class="text-[10px]">૦</sub>
                                        <span class="text-12 invisible lg:hidden inline-box">૦૦૦</span>
                                        <br class="lg:hidden"/>
                                        <a class="ingredient" data-id="I0063" href="?id=I0063" sup-id="">
                                            ગૂંદાં<sup class="red">૯૩૦</sup>
                                        </a>
                                        <a class="ingredient" data-id="I0023" href="?id=I0023" sup-id="">
                                            કટગૂંદી<sup class="red">૯૩૧</sup>
                                        </a>
                                        <a class="ingredient" data-id="I0082" href="?id=I0082" sup-id="">
                                            જરદાલુ<sup class="red">૯૩૨</sup>
                                        </a>
                                        , અન્ન<sub class="text-[10px]">૦</sub>
                                        <span class="text-12 invisible">૦૦૦</span>
                                    </p>
                                    <p>
                                        <a class="ingredient" data-id="I0175" href="?id=I0175" sup-id="">
                                            લીલા અંજીર<sup class="red">૯૩૩</sup>
                                        </a>
                                        <a class="ingredient" data-id="I0046" href="?id=I0046" sup-id="">
                                            કોઠીંબાં<sup class="red">૯૩૪</sup>
                                        </a>
                                        <a class="ingredient" data-id="I0193" href="?id=I0193" sup-id="">
                                            શેતૂર<sup class="red">૯૩૫</sup>
                                        </a>
                                        , અન્ન<sub class="text-[10px]">૦</sub>
                                        <span class="text-12 invisible lg:hidden inline-box">૦૦૦</span>
                                        <br class="lg:hidden"/>
                                        જમો 
                                        <a class="ingredient" data-id="I0077" href="?id=I0077" sup-id="">
                                            ચીભડાં<sup class="red">૯૩૬</sup>
                                        </a>
                                        <a class="ingredient" data-id="I0013" href="?id=I0013" sup-id="">
                                            આરિયાં<sup class="red">૯૩૭</sup>
                                        </a>
                                        મધુર, અન્ન<sub class="text-[10px]">૦</sub>
                                        <span class="text-12 inline-box">૧૮૪</span>
                                    </p>
                                    <p>
                                        જમો 
                                        <a class="ingredient" data-id="I0024" href="?id=I0024" sup-id="">
                                            કમરખ<sup class="red">૯૩૮</sup>
                                        </a>
                                        <a class="ingredient" data-id="I0053" href="?id=I0053" sup-id="">
                                            ખટુમડા<sup class="red">૯૩૯</sup>
                                        </a>
                                        , અન્ન<sub class="text-[10px]">૦</sub>
                                        <span class="text-12 invisible lg:hidden inline-box">૦૦૦</span>
                                        <br class="lg:hidden"/>
                                        <a class="ingredient" data-id="I0091" href="?id=I0091" sup-id="">
                                            ટીંબરું<sup class="red">૯૪૦</sup>
                                        </a>
                                        <a class="ingredient" data-id="I0026" href="?id=I0026" sup-id="">
                                            કરમદાં<sup class="red">૯૪૧</sup>
                                        </a>
                                        <a class="ingredient" data-id="I0015" href="?id=I0015" sup-id="">
                                            અવાકડાં<sup class="red">૯૪૨</sup>
                                        </a>
                                        , અન્ન<sub class="text-[10px]">૦</sub>
                                        <span class="text-12 invisible">૦૦૦</span>
                                    </p>
                                    <p>
                                        <a class="ingredient" data-id="I0070" href="?id=I0070" sup-id="">
                                            ચકોતરાં<sup class="red">૯૪૩</sup>
                                        </a>
                                        <a class="ingredient" data-id="I0021" href="?id=I0021" sup-id="">
                                            ઓલિવ<sup class="red">૯૪૪</sup>
                                        </a>
                                        પ્યારાં, અન્ન<sub class="text-[10px]">૦</sub>
                                        <span class="text-12 invisible lg:hidden inline-box">૦૦૦</span>
                                        <br class="lg:hidden"/>
                                        ફ્રૂટ 
                                        <a class="ingredient" data-id="I0124" href="?id=I0124" sup-id="">
                                            ફાલસા<sup class="red">૯૪૫</sup>
                                        </a>
                                        છે બહુ સારાં, અન્ન<sub class="text-[10px]">૦</sub>
                                        <span class="text-12 inline-box">૧૮૫</span>
                                    </p>
                                    <p>
                                        <a class="ingredient" data-id="I0051" href="?id=I0051" sup-id="">
                                            ક્રેનબેરી<sup class="red">૯૪૬</sup>
                                        </a>
                                        ને 
                                        <a class="ingredient" data-id="I0137" href="?id=I0137" sup-id="">
                                            બ્લૂબેરી<sup class="red">૯૪૭</sup>
                                        </a>
                                        , અન્ન<sub class="text-[10px]">૦</sub>
                                        <span class="text-12 invisible lg:hidden inline-box">૦૦૦</span>
                                        <br class="lg:hidden"/>
                                        <a class="ingredient" data-id="I0138" href="?id=I0138" sup-id="">
                                            બ્લેકબેરી<sup class="red">૯૪૮</sup>
                                        </a>
                                        ને 
                                        <a class="ingredient" data-id="I0166" href="?id=I0166" sup-id="">
                                            રાસબેરી<sup class="red">૯૪૯</sup>
                                        </a>
                                        , અન્ન<sub class="text-[10px]">૦</sub>
                                        <span class="text-12 invisible">૦૦૦</span>
                                    </p>
                                    <p>
                                        <a class="recipe" data-id="R0950" href="?id=R0950" sup-id="">
                                            છાશ<sup class="red">૯૫૦</sup>
                                        </a>
                                        <a class="recipe" data-id="R0951" href="?id=R0951" sup-id="">
                                            દહીં<sup class="red">૯૫૧</sup>
                                        </a>
                                        <a class="recipe" data-id="R0952" href="?id=R0952" sup-id="">
                                            કઢિયેલ દૂધ<sup class="red">૯૫૨</sup>
                                        </a>
                                        , અન્ન<sub class="text-[10px]">૦</sub>
                                        <span class="text-12 invisible lg:hidden inline-box">૦૦૦</span>
                                        <br class="lg:hidden"/>
                                        ઓર્ગેનિક છે બહુ શુદ્ધ, અન્ન<sub class="text-[10px]">૦</sub>
                                        <span class="text-12 inline-box">૧૮૬</span>
                                    </p>
                                    <p>
                                        હવે ચળું કરો અવતારી, અન્ન<sub class="text-[10px]">૦</sub>
                                        <span class="text-12 invisible lg:hidden inline-box">૦૦૦</span>
                                        <br class="lg:hidden"/>
                                        હું લાવી છું જળઝારી, અન્ન<sub class="text-[10px]">૦</sub>
                                        <span class="text-12 invisible">૦૦૦</span>
                                    </p>
                                    <p>
                                        હેતે કર ધોવરાવું નાથ, અન્ન<sub class="text-[10px]">૦</sub>
                                        <span class="text-12 invisible lg:hidden inline-box">૦૦૦</span>
                                        <br class="lg:hidden"/>
                                        મુખ લૂછું ને લૂછું હાથ, અન્ન<sub class="text-[10px]">૦</sub>
                                        <span class="text-12 inline-box">૧૮૭</span>
                                    </p>
                                    <p>
                                        સળી સોનાની લઈ હાથ, અન્ન<sub class="text-[10px]">૦</sub>
                                        <span class="text-12 invisible lg:hidden inline-box">૦૦૦</span>
                                        <br class="lg:hidden"/>
                                        દંત શુદ્ધિ કરોને નાથ, અન્ન<sub class="text-[10px]">૦</sub>
                                        <span class="text-12 invisible">૦૦૦</span>
                                    </p>
                                    <p>
                                        આવો સોફે બિરાજો સ્વામી, અન્ન<sub class="text-[10px]">૦</sub>
                                        <span class="text-12 invisible lg:hidden inline-box">૦૦૦</span>
                                        <br class="lg:hidden"/>
                                        તમે અનંત ધામના ધામી, અન્ન<sub class="text-[10px]">૦</sub>
                                        <span class="text-12 inline-box">૧૮૮</span>
                                    </p>
                                    <h3>જ્યૂસ</h3>
                                    <p>
                                        રૂડાં અનેક પ્રકારનાં જ્યૂસ, અન્ન<sub class="text-[10px]">૦</sub>
                                        <span class="text-12 invisible lg:hidden inline-box">૦૦૦</span>
                                        <br class="lg:hidden"/>
                                        પિયુ પીજો થઈને ખુશ, અન્ન<sub class="text-[10px]">૦</sub>
                                        <span class="text-12 invisible">૦૦૦</span>
                                    </p>
                                    <p>
                                        <a class="recipe" data-id="R0953" href="?id=R0953" sup-id="">
                                            જ્યૂસ ઓરેંજ<sup class="red">૯૫૩</sup>
                                        </a>
                                        <a class="recipe" data-id="R0954" href="?id=R0954" sup-id="">
                                            તરબૂચ જ્યૂસ<sup class="red">૯૫૪</sup>
                                        </a>
                                        , અન્ન<sub class="text-[10px]">૦</sub>
                                        <span class="text-12 invisible lg:hidden inline-box">૦૦૦</span>
                                        <br class="lg:hidden"/>
                                        પીવો 
                                        <a class="recipe" data-id="R0955" href="?id=R0955" sup-id="">
                                            પાઇનેપલનું જ્યૂસ<sup class="red">૯૫૫</sup>
                                        </a>
                                        , અન્ન<sub class="text-[10px]">૦</sub>
                                        <span class="text-12 inline-box">૧૮૯</span>
                                    </p>
                                    <p>
                                        <a class="recipe" data-id="R0956" href="?id=R0956" sup-id="">
                                            એપલ જ્યૂસ<sup class="red">૯૫૬</sup>
                                        </a>
                                        <a class="recipe" data-id="R0957" href="?id=R0957" sup-id="">
                                            દાડમ જ્યૂસ<sup class="red">૯૫૭</sup>
                                        </a>
                                        , અન્ન<sub class="text-[10px]">૦</sub>
                                        <span class="text-12 invisible lg:hidden inline-box">૦૦૦</span>
                                        <br class="lg:hidden"/>
                                        પીવો 
                                        <a class="recipe" data-id="R0958" href="?id=R0958" sup-id="">
                                            ગંગા-જમુના જ્યૂસ<sup class="red">૯૫૮</sup>
                                        </a>
                                        , અન્ન<sub class="text-[10px]">૦</sub>
                                        <span class="text-12 invisible">૦૦૦</span>
                                    </p>
                                    <p>
                                        <a class="recipe" data-id="R0959" href="?id=R0959" sup-id="">
                                            લીચીનું<sup class="red">૯૫૯</sup>
                                        </a>
                                        <a class="recipe" data-id="R0960" href="?id=R0960" sup-id="">
                                            દ્રાક્ષનું જ્યૂસ<sup class="red">૯૬૦</sup>
                                        </a>
                                        , અન્ન<sub class="text-[10px]">૦</sub>
                                        <span class="text-12 invisible lg:hidden inline-box">૦૦૦</span>
                                        <br class="lg:hidden"/>
                                        <a class="recipe" data-id="R0961" href="?id=R0961" sup-id="">
                                            ખાટું મીઠું મોસંબી જ્યૂસ<sup class="red">૯૬૧</sup>
                                        </a>
                                        , અન્ન<sub class="text-[10px]">૦</sub>
                                        <span class="text-12 inline-box">૧૯૦</span>
                                    </p>
                                    <p>
                                        <a class="recipe" data-id="R0962" href="?id=R0962" sup-id="">
                                            લેમોનેડ<sup class="red">૯૬૨</sup>
                                        </a>
                                        ને 
                                        <a class="recipe" data-id="R0963" href="?id=R0963" sup-id="">
                                            જાંબુ જ્યૂસ<sup class="red">૯૬૩</sup>
                                        </a>
                                        , અન્ન<sub class="text-[10px]">૦</sub>
                                        <span class="text-12 invisible lg:hidden inline-box">૦૦૦</span>
                                        <br class="lg:hidden"/>
                                        વાલા પીઓ ને થાઓ ખુશ, અન્ન<sub class="text-[10px]">૦</sub>
                                        <span class="text-12 invisible">૦૦૦</span>
                                    </p>
                                    <h3>શેક</h3>
                                    <p>
                                        <a class="recipe" data-id="R0964" href="?id=R0964" sup-id="">
                                            સ્મૂધી<sup class="red">૯૬૪</sup>
                                        </a>
                                        <a class="recipe" data-id="R0965" href="?id=R0965" sup-id="">
                                            હોટ ચોકલેટ<sup class="red">૯૬૫</sup>
                                        </a>
                                        સારી, અન્ન<sub class="text-[10px]">૦</sub>
                                        <span class="text-12 invisible lg:hidden inline-box">૦૦૦</span>
                                        <br class="lg:hidden"/>
                                        તમે પીઓને હે અવતારી, અન્ન<sub class="text-[10px]">૦</sub>
                                        <span class="text-12 inline-box">૧૯૧</span>
                                    </p>
                                    <p>
                                        વાલા વિવિધ પીઓ શેક, અન્ન<sub class="text-[10px]">૦</sub>
                                        <span class="text-12 invisible lg:hidden inline-box">૦૦૦</span>
                                        <br class="lg:hidden"/>
                                        <a class="recipe" data-id="R0966" href="?id=R0966" sup-id="">
                                            પિનાકોલાડા<sup class="red">૯૬૬</sup>
                                        </a>
                                        <a class="recipe" data-id="R0967" href="?id=R0967" sup-id="">
                                            મેંગો શેક<sup class="red">૯૬૭</sup>
                                        </a>
                                        , અન્ન<sub class="text-[10px]">૦</sub>
                                        <span class="text-12 invisible">૦૦૦</span>
                                    </p>
                                    <p>
                                        <a class="recipe" data-id="R0968" href="?id=R0968" sup-id="">
                                            ચીકુ શેક<sup class="red">૯૬૮</sup>
                                        </a>
                                        <a class="recipe" data-id="R0969" href="?id=R0969" sup-id="">
                                            ચોકલેટ શેક<sup class="red">૯૬૯</sup>
                                        </a>
                                        , અન્ન<sub class="text-[10px]">૦</sub>
                                        <span class="text-12 invisible lg:hidden inline-box">૦૦૦</span>
                                        <br class="lg:hidden"/>
                                        <a class="recipe" data-id="R0970" href="?id=R0970" sup-id="R0970">
                                            ફાલુદા<sup class="red">૯૭૦</sup>
                                        </a>
                                        <a class="recipe" data-id="R0971" href="?id=R0971" sup-id="">
                                            કાજુ-અંજીર શેક<sup class="red">૯૭૧</sup>
                                        </a>
                                        , અન્ન<sub class="text-[10px]">૦</sub>
                                        <span class="text-12 inline-box">૧૯૨</span>
                                    </p>
                                    <p>
                                        <a class="ingredient" data-id="I0005" href="?id=I0005" sup-id="">
                                            પાઇનેપલ<sup class="red">૯૭૨</sup>
                                        </a>
                                        <a class="recipe" data-id="R0973" href="?id=R0973" sup-id="">
                                            બદામ શેક<sup class="red">૯૭૩</sup>
                                        </a>
                                        , અન્ન<sub class="text-[10px]">૦</sub>
                                        <span class="text-12 invisible lg:hidden inline-box">૦૦૦</span>
                                        <br class="lg:hidden"/>
                                        <a class="recipe" data-id="R0974" href="?id=R0974" sup-id="">
                                            એપલ શેક<sup class="red">૯૭૪</sup>
                                        </a>
                                        <a class="recipe" data-id="R0975" href="?id=R0975" sup-id="">
                                            બનાના શેક<sup class="red">૯૭૫</sup>
                                        </a>
                                        , અન્ન<sub class="text-[10px]">૦</sub>
                                        <span class="text-12 invisible">૦૦૦</span>
                                    </p>
                                    <p>
                                        પીઓ 
                                        <a class="recipe" data-id="R0976" href="?id=R0976" sup-id="">
                                            કેસર-એલચી શેક<sup class="red">૯૭૬</sup>
                                        </a>
                                        , અન્ન<sub class="text-[10px]">૦</sub>
                                        <span class="text-12 invisible lg:hidden inline-box">૦૦૦</span>
                                        <br class="lg:hidden"/>
                                        <a class="recipe" data-id="R0977" href="?id=R0977" sup-id="">
                                            સારજા શેક<sup class="red">૯૭૭</sup>
                                        </a>
                                        <a class="recipe" data-id="R0978" href="?id=R0978" sup-id="">
                                            ગુલકંદ શેક<sup class="red">૯૭૮</sup>
                                        </a>
                                        , અન્ન<sub class="text-[10px]">૦</sub>
                                        <span class="text-12 inline-box">૧૯૩</span>
                                    </p>
                                    <p>
                                        <a class="recipe" data-id="R0979" href="?id=R0979" sup-id="">
                                            મીઠી લસ્સી<sup class="red">૯૭૯</sup>
                                        </a>
                                        <a class="recipe" data-id="R0980" href="?id=R0980" sup-id="">
                                            ખારી લસ્સી<sup class="red">૯૮૦</sup>
                                        </a>
                                        , અન્ન<sub class="text-[10px]">૦</sub>
                                        <span class="text-12 invisible lg:hidden inline-box">૦૦૦</span>
                                        <br class="lg:hidden"/>
                                        પીઓ 
                                        <a class="recipe" data-id="R0981" href="?id=R0981" sup-id="">
                                            પાઇનેપલની લસ્સી<sup class="red">૯૮૧</sup>
                                        </a>
                                        , અન્ન<sub class="text-[10px]">૦</sub>
                                        <span class="text-12 invisible">૦૦૦</span>
                                    </p>
                                    <p>
                                        <a class="recipe" data-id="R0982" href="?id=R0982" sup-id="">
                                            મેંગો લસ્સી<sup class="red">૯૮૨</sup>
                                        </a>
                                        <a class="recipe" data-id="R0983" href="?id=R0983" sup-id="">
                                            લસ્સી સ્ટ્રોબેરી<sup class="red">૯૮૩</sup>
                                        </a>
                                        , અન્ન<sub class="text-[10px]">૦</sub>
                                        <span class="text-12 invisible lg:hidden inline-box">૦૦૦</span>
                                        <br class="lg:hidden"/>
                                        <a class="recipe" data-id="R0984" href="?id=R0984" sup-id="">
                                            કોલ્ડ કોકો<sup class="red">૯૮૪</sup>
                                        </a>
                                        પીઓ લહેરી, અન્ન<sub class="text-[10px]">૦</sub>
                                        <span class="text-12 inline-box">૧૯૪</span>
                                    </p>
                                    <h3>પ્રવાહી</h3>
                                    <p>
                                        <a class="recipe" data-id="R0985" href="?id=R0985" sup-id="">
                                            કાચી કેરીનો બાફલો<sup class="red">૯૮૫</sup>
                                        </a>
                                        , અન્ન<sub class="text-[10px]">૦</sub>
                                        <span class="text-12 invisible lg:hidden inline-box">૦૦૦</span>
                                        <br class="lg:hidden"/>
                                        પીવા જેવો છે અતિ ભલો, અન્ન<sub class="text-[10px]">૦</sub>
                                        <span class="text-12 invisible">૦૦૦</span>
                                    </p>
                                    <p>
                                        પીઓ 
                                        <a class="recipe" data-id="R0986" href="?id=R0986" sup-id="">
                                            સીકંજી<sup class="red">૯૮૬</sup>
                                        </a>
                                        <a class="recipe" data-id="R0987" href="?id=R0987" sup-id="">
                                            ગોળનું પાણી<sup class="red">૯૮૭</sup>
                                        </a>
                                        , અન્ન<sub class="text-[10px]">૦</sub>
                                        <span class="text-12 invisible lg:hidden inline-box">૦૦૦</span>
                                        <br class="lg:hidden"/>
                                        વળી તાજું 
                                        <a class="ingredient" data-id="I0098" href="?id=I0098" sup-id="">
                                            તરોપાનું પાણી<sup class="red">૯૮૮</sup>
                                        </a>
                                        , અન્ન<sub class="text-[10px]">૦</sub>
                                        <span class="text-12 inline-box">૧૯૫</span>
                                    </p>
                                    <p>
                                        પીઓ 
                                        <a class="recipe" data-id="R0989" href="?id=R0989" sup-id="">
                                            સાકરનું ઠંડું પાણી<sup class="red">૯૮૯</sup>
                                        </a>
                                        , અન્ન<sub class="text-[10px]">૦</sub>
                                        <span class="text-12 invisible lg:hidden inline-box">૦૦૦</span>
                                        <br class="lg:hidden"/>
                                        કર્યું અતિશે પ્રેમ આણી, અન્ન<sub class="text-[10px]">૦</sub>
                                        <span class="text-12 invisible">૦૦૦</span>
                                    </p>
                                    <p>
                                        <a class="recipe" data-id="R0990" href="?id=R0990" sup-id="">
                                            લીંબુ શરબત<sup class="red">૯૯૦</sup>
                                        </a>
                                        <a class="recipe" data-id="R0991" href="?id=R0991" sup-id="">
                                            કોકમ શરબત<sup class="red">૯૯૧</sup>
                                        </a>
                                        , અન્ન<sub class="text-[10px]">૦</sub>
                                        <span class="text-12 invisible lg:hidden inline-box">૦૦૦</span>
                                        <br class="lg:hidden"/>
                                        ટાઢું 
                                        <a class="recipe" data-id="R0992" href="?id=R0992" sup-id="">
                                            વરિયાળીનું શરબત<sup class="red">૯૯૨</sup>
                                        </a>
                                        , અન્ન<sub class="text-[10px]">૦</sub>
                                        <span class="text-12 inline-box">૧૯૬</span>
                                    </p>
                                    <p>
                                        પીઓ 
                                        <a class="recipe" data-id="R0993" href="?id=R0993" sup-id="">
                                            જલઝીરા શરબત<sup class="red">૯૯૩</sup>
                                        </a>
                                        , અન્ન<sub class="text-[10px]">૦</sub>
                                        <span class="text-12 invisible lg:hidden inline-box">૦૦૦</span>
                                        <br class="lg:hidden"/>
                                        <a class="ingredient" data-id="I0194" href="?id=I0194" sup-id="">
                                            શેરડી<sup class="red">૯૯૪</sup>
                                        </a>
                                        રસ 
                                        <a class="recipe" data-id="R0995" href="?id=R0995" sup-id="">
                                            બીલાં શરબત<sup class="red">૯૯૫</sup>
                                        </a>
                                        , અન્ન<sub class="text-[10px]">૦</sub>
                                        <span class="text-12 invisible">૦૦૦</span>
                                    </p>
                                    <p>
                                        <a class="recipe" data-id="R0996" href="?id=R0996" sup-id="">
                                            તકમરિયાં શરબત<sup class="red">૯૯૬</sup>
                                        </a>
                                        નાથ, અન્ન<sub class="text-[10px]">૦</sub>
                                        <span class="text-12 invisible lg:hidden inline-box">૦૦૦</span>
                                        <br class="lg:hidden"/>
                                        હેતે પીજો કહું જોડી હાથ, અન્ન<sub class="text-[10px]">૦</sub>
                                        <span class="text-12 inline-box">૧૯૭</span>
                                    </p>
                                    <h3>આઇસક્રીમ-કોન-કેન્ડી</h3>
                                    <p>
                                        લાવ્યા આઇસક્રીમ અનેક પ્રકાર, અન્ન<sub class="text-[10px]">૦</sub>
                                        <span class="text-12 invisible lg:hidden inline-box">૦૦૦</span>
                                        <br class="lg:hidden"/>
                                        તમે જમોને ભક્તિકુમાર, અન્ન<sub class="text-[10px]">૦</sub>
                                        <span class="text-12 invisible">૦૦૦</span>
                                    </p>
                                    <p>
                                        <a class="recipe" data-id="R0997" href="?id=R0997" sup-id="">
                                            કેસર-ઇલાયચી આઇસક્રીમ<sup class="red">૯૯૭</sup>
                                        </a>
                                        , અન્ન<sub class="text-[10px]">૦</sub>
                                        <span class="text-12 invisible lg:hidden inline-box">૦૦૦</span>
                                        <br class="lg:hidden"/>
                                        <a class="recipe" data-id="R0998" href="?id=R0998" sup-id="R0998">
                                            બટરસ્કોચ<sup class="red">૯૯૮</sup>
                                        </a>
                                        <a class="recipe" data-id="R0999" href="?id=R0999" sup-id="">
                                            વેનીલા આઇસક્રીમ<sup class="red">૯૯૯</sup>
                                        </a>
                                        , અન્ન<sub class="text-[10px]">૦</sub>
                                        <span class="text-12 inline-box">૧૯૮</span>
                                    </p>
                                    <p>
                                        <a class="recipe" data-id="R1000" href="?id=R1000" sup-id="">
                                            કેસર-પિસ્તાનો આઇસક્રીમ<sup class="red">૧૦૦૦</sup>
                                        </a>
                                        , અન્ન<sub class="text-[10px]">૦</sub>
                                        <span class="text-12 invisible lg:hidden inline-box">૦૦૦</span>
                                        <br class="lg:hidden"/>
                                        <a class="recipe" data-id="R1001" href="?id=R1001" sup-id="">
                                            કાજુ-દ્રાક્ષનો આઇસક્રીમ<sup class="red">૧૦૦૧</sup>
                                        </a>
                                        , અન્ન<sub class="text-[10px]">૦</sub>
                                        <span class="text-12 invisible">૦૦૦</span>
                                    </p>
                                    <p>
                                        <a class="recipe" data-id="R1002" href="?id=R1002" sup-id="">
                                            કાજુ-અંજીરનો આઇસક્રીમ<sup class="red">૧૦૦૨</sup>
                                        </a>
                                        , અન્ન<sub class="text-[10px]">૦</sub>
                                        <span class="text-12 invisible lg:hidden inline-box">૦૦૦</span>
                                        <br class="lg:hidden"/>
                                        <a class="recipe" data-id="R1003" href="?id=R1003" sup-id="">
                                            કાજુ કસાટાનો આઇસક્રીમ<sup class="red">૧૦૦૩</sup>
                                        </a>
                                        , અન્ન<sub class="text-[10px]">૦</sub>
                                        <span class="text-12 inline-box">૧૯૯</span>
                                    </p>
                                    <p>
                                        જમો 
                                        <a class="recipe" data-id="R1004" href="?id=R1004" sup-id="">
                                            રાજભોગ આઇસક્રીમ<sup class="red">૧૦૦૪</sup>
                                        </a>
                                        , અન્ન<sub class="text-[10px]">૦</sub>
                                        <span class="text-12 invisible lg:hidden inline-box">૦૦૦</span>
                                        <br class="lg:hidden"/>
                                        રૂડો 
                                        <a class="recipe" data-id="R1005" href="?id=R1005" sup-id="">
                                            ચોકો ચીપ્સ આઇસક્રીમ<sup class="red">૧૦૦૫</sup>
                                        </a>
                                        , અન્ન<sub class="text-[10px]">૦</sub>
                                        <span class="text-12 invisible">૦૦૦</span>
                                    </p>
                                    <p>
                                        જમો 
                                        <a class="recipe" data-id="R1006" href="?id=R1006" sup-id="">
                                            ફ્રૂટ એન્ડ નટ આઇસક્રીમ<sup class="red">૧૦૦૬</sup>
                                        </a>
                                        , અન્ન<sub class="text-[10px]">૦</sub>
                                        <span class="text-12 invisible lg:hidden inline-box">૦૦૦</span>
                                        <br class="lg:hidden"/>
                                        છે 
                                        <a class="recipe" data-id="R1007" href="?id=R1007" sup-id="">
                                            બ્લેક કરંટ આઇસક્રીમ<sup class="red">૧૦૦૭</sup>
                                        </a>
                                        , અન્ન<sub class="text-[10px]">૦</sub>
                                        <span class="text-12 inline-box">૨૦૦</span>
                                    </p>
                                    <p>
                                        <a class="recipe" data-id="R1008" href="?id=R1008" sup-id="">
                                            સન્ડે ખટા-મીઠા મેંગો<sup class="red">૧૦૦૮</sup>
                                        </a>
                                        , અન્ન<sub class="text-[10px]">૦</sub>
                                        <span class="text-12 invisible lg:hidden inline-box">૦૦૦</span>
                                        <br class="lg:hidden"/>
                                        <a class="recipe" data-id="R1009" href="?id=R1009" sup-id="R1009">
                                            ટૂટીફ્રૂટી<sup class="red">૧૦૦૯</sup>
                                        </a>
                                        ને 
                                        <a class="recipe" data-id="R1010" href="?id=R1010" sup-id="">
                                            આઇસક્રીમ મેંગો<sup class="red">૧૦૧૦</sup>
                                        </a>
                                        , અન્ન<sub class="text-[10px]">૦</sub>
                                        <span class="text-12 invisible">૦૦૦</span>
                                    </p>
                                    <p>
                                        <a class="recipe" data-id="R1011" href="?id=R1011" sup-id="">
                                            તવા<sup class="red">૧૦૧૧</sup>
                                        </a>
                                        <a class="recipe" data-id="R1012" href="?id=R1012" sup-id="">
                                            વરિયાળી આઇસક્રીમ<sup class="red">૧૦૧૨</sup>
                                        </a>
                                        , અન્ન<sub class="text-[10px]">૦</sub>
                                        <span class="text-12 invisible lg:hidden inline-box">૦૦૦</span>
                                        <br class="lg:hidden"/>
                                        <a class="recipe" data-id="R1013" href="?id=R1013" sup-id="">
                                            ગ્રીન કોકોનટ આઇસક્રીમ<sup class="red">૧૦૧૩</sup>
                                        </a>
                                        , અન્ન<sub class="text-[10px]">૦</sub>
                                        <span class="text-12 inline-box">૨૦૧</span>
                                    </p>
                                    <p>
                                        <a class="recipe" data-id="R1014" href="?id=R1014" sup-id="">
                                            પાનમસાલા આઇસક્રીમ<sup class="red">૧૦૧૪</sup>
                                        </a>
                                        , અન્ન<sub class="text-[10px]">૦</sub>
                                        <span class="text-12 invisible lg:hidden inline-box">૦૦૦</span>
                                        <br class="lg:hidden"/>
                                        <a class="recipe" data-id="R1015" href="?id=R1015" sup-id="">
                                            માવા મલાઈ આઇસક્રીમ<sup class="red">૧૦૧૫</sup>
                                        </a>
                                        , અન્ન<sub class="text-[10px]">૦</sub>
                                        <span class="text-12 invisible">૦૦૦</span>
                                    </p>
                                    <p>
                                        વળી 
                                        <a class="recipe" data-id="R1016" href="?id=R1016" sup-id="">
                                            જાંબુ આઇસક્રીમ<sup class="red">૧૦૧૬</sup>
                                        </a>
                                        સારો, અન્ન<sub class="text-[10px]">૦</sub>
                                        <span class="text-12 invisible lg:hidden inline-box">૦૦૦</span>
                                        <br class="lg:hidden"/>
                                        <a class="recipe" data-id="R1017" href="?id=R1017" sup-id="">
                                            સ્ટ્રોબેરી આઇસક્રીમ<sup class="red">૧૦૧૭</sup>
                                        </a>
                                        ન્યારો, અન્ન<sub class="text-[10px]">૦</sub>
                                        <span class="text-12 inline-box">૨૦૨</span>
                                    </p>
                                    <p>
                                        <a class="recipe" data-id="R1018" href="?id=R1018" sup-id="">
                                            સીતાફળ આઇસક્રીમ<sup class="red">૧૦૧૮</sup>
                                        </a>
                                        અનુપ, અન્ન<sub class="text-[10px]">૦</sub>
                                        <span class="text-12 invisible lg:hidden inline-box">૦૦૦</span>
                                        <br class="lg:hidden"/>
                                        ભાવે જમો હરિ રસરૂપ, અન્ન<sub class="text-[10px]">૦</sub>
                                        <span class="text-12 invisible">૦૦૦</span>
                                    </p>
                                    <p>
                                        <a class="recipe" data-id="R1019" href="?id=R1019" sup-id="">
                                            અફઘાન મેવો આઇસક્રીમ<sup class="red">૧૦૧૯</sup>
                                        </a>
                                        , અન્ન<sub class="text-[10px]">૦</sub>
                                        <span class="text-12 invisible lg:hidden inline-box">૦૦૦</span>
                                        <br class="lg:hidden"/>
                                        <a class="recipe" data-id="R1020" href="?id=R1020" sup-id="">
                                            પાઇનેપલનો આઇસક્રીમ<sup class="red">૧૦૨૦</sup>
                                        </a>
                                        , અન્ન<sub class="text-[10px]">૦</sub>
                                        <span class="text-12 inline-box">૨૦૩</span>
                                    </p>
                                    <p>
                                        <a class="recipe" data-id="R1021" href="?id=R1021" sup-id="">
                                            યોગર્ટ પરફે<sup class="red">૧૦૨૧</sup>
                                        </a>
                                        બહુ સારા, અન્ન<sub class="text-[10px]">૦</sub>
                                        <span class="text-12 invisible lg:hidden inline-box">૦૦૦</span>
                                        <br class="lg:hidden"/>
                                        એ આદિક આઇસક્રીમ ન્યારા, અન્ન<sub class="text-[10px]">૦</sub>
                                        <span class="text-12 invisible">૦૦૦</span>
                                    </p>
                                    <p>
                                        તમે કોન જમો અળવીલા, અન્ન<sub class="text-[10px]">૦</sub>
                                        <span class="text-12 invisible lg:hidden inline-box">૦૦૦</span>
                                        <br class="lg:hidden"/>
                                        <a class="recipe" data-id="R1022" href="?id=R1022" sup-id="">
                                            ચોકો ક્રંચ<sup class="red">૧૦૨૨</sup>
                                        </a>
                                        <a class="recipe" data-id="R1023" href="?id=R1023" sup-id="">
                                            ચોકો વેનીલા<sup class="red">૧૦૨૩</sup>
                                        </a>
                                        , અન્ન<sub class="text-[10px]">૦</sub>
                                        <span class="text-12 inline-box">૨૦૪</span>
                                    </p>
                                    <p>
                                        <a class="recipe" data-id="R1024" href="?id=R1024" sup-id="R1024">
                                            બદામ-પિસ્તા<sup class="red">૧૦૨૪</sup>
                                        </a>
                                        <a class="recipe" data-id="R1025" href="?id=R1025" sup-id="">
                                            ટુ ઇન વન<sup class="red">૧૦૨૫</sup>
                                        </a>
                                        , અન્ન<sub class="text-[10px]">૦</sub>
                                        <span class="text-12 invisible lg:hidden inline-box">૦૦૦</span>
                                        <br class="lg:hidden"/>
                                        અતિ હેતે જમોને જીવન, અન્ન<sub class="text-[10px]">૦</sub>
                                        <span class="text-12 invisible">૦૦૦</span>
                                    </p>
                                    <p>
                                        જમો 
                                        <a class="recipe" data-id="R1026" href="?id=R1026" sup-id="">
                                            કનોલી કોન<sup class="red">૧૦૨૬</sup>
                                        </a>
                                        પ્યારા, અન્ન<sub class="text-[10px]">૦</sub>
                                        <span class="text-12 invisible lg:hidden inline-box">૦૦૦</span>
                                        <br class="lg:hidden"/>
                                        જમો 
                                        <a class="recipe" data-id="R1027" href="?id=R1027" sup-id="">
                                            ન્યુટેલા પોપ<sup class="red">૧૦૨૭</sup>
                                        </a>
                                        ન્યારા, અન્ન<sub class="text-[10px]">૦</sub>
                                        <span class="text-12 inline-box">૨૦૫</span>
                                    </p>
                                    <p>
                                        <a class="recipe" data-id="R1028" href="?id=R1028" sup-id="R1028">
                                            કેન્ડી<sup class="red">૧૦૨૮</sup>
                                        </a>
                                        જમોને મારા પ્યાર, અન્ન<sub class="text-[10px]">૦</sub>
                                        <span class="text-12 invisible lg:hidden inline-box">૦૦૦</span>
                                        <br class="lg:hidden"/>
                                        <a class="recipe" data-id="R1029" href="?id=R1029" sup-id="">
                                            મેંગો ડોલી<sup class="red">૧૦૨૯</sup>
                                        </a>
                                        ને 
                                        <a class="recipe" data-id="R1030" href="?id=R1030" sup-id="R1030">
                                            ચોકોબાર<sup class="red">૧૦૩૦</sup>
                                        </a>
                                        , અન્ન<sub class="text-[10px]">૦</sub>
                                        <span class="text-12 invisible">૦૦૦</span>
                                    </p>
                                    <p>
                                        <a class="recipe" data-id="R1031" href="?id=R1031" sup-id="R1031">
                                            રાસબેરી<sup class="red">૧૦૩૧</sup>
                                        </a>
                                        ડોલી 
                                        <a class="ingredient" data-id="I0253" href="?id=I0253" sup-id="">
                                            ફ્રોસ્ટીક<sup class="red">૧૦૩૨</sup>
                                        </a>
                                        , અન્ન<sub class="text-[10px]">૦</sub>
                                        <span class="text-12 invisible lg:hidden inline-box">૦૦૦</span>
                                        <br class="lg:hidden"/>
                                        નહિ નડે તજોને બીક, અન્ન<sub class="text-[10px]">૦</sub>
                                        <span class="text-12 inline-box">૨૦૬</span>
                                    </p>
                                    <p>
                                        <a class="recipe" data-id="R1033" href="?id=R1033" sup-id="">
                                            ચોકો ટ્રફલ<sup class="red">૧૦૩૩</sup>
                                        </a>
                                        <a class="recipe" data-id="R1034" href="?id=R1034" sup-id="">
                                            માવા મલાઈ<sup class="red">૧૦૩૪</sup>
                                        </a>
                                        , અન્ન<sub class="text-[10px]">૦</sub>
                                        <span class="text-12 invisible lg:hidden inline-box">૦૦૦</span>
                                        <br class="lg:hidden"/>
                                        <a class="recipe" data-id="R1035" href="?id=R1035" sup-id="">
                                            માટલા કુલ્ફી<sup class="red">૧૦૩૫</sup>
                                        </a>
                                        <a class="recipe" data-id="R1036" href="?id=R1036" sup-id="">
                                            પિસ્તા મલાઈ<sup class="red">૧૦૩૬</sup>
                                        </a>
                                        , અન્ન<sub class="text-[10px]">૦</sub>
                                        <span class="text-12 invisible">૦૦૦</span>
                                    </p>
                                    <p>
                                        જમો ઠંડી 
                                        <a class="recipe" data-id="R1037" href="?id=R1037" sup-id="">
                                            ફાલુદા કુલ્ફી<sup class="red">૧૦૩૭</sup>
                                        </a>
                                        , અન્ન<sub class="text-[10px]">૦</sub>
                                        <span class="text-12 invisible lg:hidden inline-box">૦૦૦</span>
                                        <br class="lg:hidden"/>
                                        <a class="recipe" data-id="R1038" href="?id=R1038" sup-id="">
                                            આઇસક્રીમ ગોલા<sup class="red">૧૦૩૮</sup>
                                        </a>
                                        <a class="recipe" data-id="R1039" href="?id=R1039" sup-id="">
                                            રાજભોગ કુલ્ફી<sup class="red">૧૦૩૯</sup>
                                        </a>
                                        , અન્ન<sub class="text-[10px]">૦</sub>
                                        <span class="text-12 inline-box">૨૦૭</span>
                                    </p>
                                    <p>
                                        <a class="recipe" data-id="R1040" href="?id=R1040" sup-id="">
                                            આઇસ ગોલા<sup class="red">૧૦૪૦</sup>
                                        </a>
                                        <a class="recipe" data-id="R1041" href="?id=R1041" sup-id="">
                                            ડ્રાયફ્રૂટ ગોલા<sup class="red">૧૦૪૧</sup>
                                        </a>
                                        , અન્ન<sub class="text-[10px]">૦</sub>
                                        <span class="text-12 invisible lg:hidden inline-box">૦૦૦</span>
                                        <br class="lg:hidden"/>
                                        <a class="recipe" data-id="R1042" href="?id=R1042" sup-id="">
                                            પેપ્સી<sup class="red">૧૦૪૨</sup>
                                        </a>
                                        <a class="recipe" data-id="R1043" href="?id=R1043" sup-id="">
                                            માવા મલાઈ ગોલા<sup class="red">૧૦૪૩</sup>
                                        </a>
                                        , અન્ન<sub class="text-[10px]">૦</sub>
                                        <span class="text-12 invisible">૦૦૦</span>
                                    </p>
                                    <h3>સૂકોમેવો</h3>
                                    <p>
                                        સૂકોમેવો જમો મારા માવ, અન્ન<sub class="text-[10px]">૦</sub>
                                        <span class="text-12 invisible lg:hidden inline-box">૦૦૦</span>
                                        <br class="lg:hidden"/>
                                        સંતો-ભક્તોનો છે ભાવ, અન્ન<sub class="text-[10px]">૦</sub>
                                        <span class="text-12 inline-box">૨૦૮</span>
                                    </p>
                                    <p>
                                        <a class="recipe" data-id="R1044" href="?id=R1044" sup-id="">
                                            કાજુ રોસ્ટેડ<sup class="red">૧૦૪૪</sup>
                                        </a>
                                        <a class="ingredient" data-id="I0032" href="?id=I0032" sup-id="">
                                            કાજુ<sup class="red">૧૦૪૫</sup>
                                        </a>
                                        <a class="ingredient" data-id="I0129" href="?id=I0129" sup-id="">
                                            બદામ<sup class="red">૧૦૪૬</sup>
                                        </a>
                                        , અન્ન<sub class="text-[10px]">૦</sub>
                                        <span class="text-12 invisible lg:hidden inline-box">૦૦૦</span>
                                        <br class="lg:hidden"/>
                                        <a class="ingredient" data-id="I0118" href="?id=I0118" sup-id="">
                                            ખારા પિસ્તા<sup class="red">૧૦૪૭</sup>
                                        </a>
                                        <a class="recipe" data-id="R1048" href="?id=R1048" sup-id="">
                                            રોસ્ટેડ બદામ<sup class="red">૧૦૪૮</sup>
                                        </a>
                                        , અન્ન<sub class="text-[10px]">૦</sub>
                                        <span class="text-12 invisible">૦૦૦</span>
                                    </p>
                                    <p>
                                        <a class="ingredient" data-id="I0118" href="?id=I0118" sup-id="">
                                            મોળા પિસ્તા<sup class="red">૧૦૪૯</sup>
                                        </a>
                                        <a class="ingredient" data-id="I0001" href="?id=I0001" sup-id="">
                                            અંજીર<sup class="red">૧૦૫૦</sup>
                                        </a>
                                        <a class="ingredient" data-id="I0207" href="?id=I0207" sup-id="">
                                            આલુ<sup class="red">૧૦૫૧</sup>
                                        </a>
                                        , અન્ન<sub class="text-[10px]">૦</sub>
                                        <span class="text-12 invisible lg:hidden inline-box">૦૦૦</span>
                                        <br class="lg:hidden"/>
                                        જમો 
                                        <a class="ingredient" data-id="I0210" href="?id=I0210" sup-id="">
                                            ખારેક<sup class="red">૧૦૫૨</sup>
                                        </a>
                                        <a class="ingredient" data-id="I0052" href="?id=I0052" sup-id="">
                                            ખજૂર<sup class="red">૧૦૫૩</sup>
                                        </a>
                                        દયાળુ, અન્ન<sub class="text-[10px]">૦</sub>
                                        <span class="text-12 inline-box">૨૦૯</span>
                                    </p>
                                    <p>
                                        જમો 
                                        <a class="ingredient" data-id="I0211" href="?id=I0211" sup-id="">
                                            ટોપરા<sup class="red">૧૦૫૪</sup>
                                        </a>
                                        <a class="ingredient" data-id="I0177" href="?id=I0177" sup-id="">
                                            કાળી દ્રાક્ષ<sup class="red">૧૦૫૫</sup>
                                        </a>
                                        , અન્ન<sub class="text-[10px]">૦</sub>
                                        <span class="text-12 invisible lg:hidden inline-box">૦૦૦</span>
                                        <br class="lg:hidden"/>
                                        <a class="ingredient" data-id="I0002" href="?id=I0002" sup-id="">
                                            અખરોટ<sup class="red">૧૦૫૬</sup>
                                        </a>
                                        ને 
                                        <a class="ingredient" data-id="I0111" href="?id=I0111" sup-id="">
                                            નીલવા દ્રાક્ષ<sup class="red">૧૦૫૭</sup>
                                        </a>
                                        , અન્ન<sub class="text-[10px]">૦</sub>
                                        <span class="text-12 invisible">૦૦૦</span>
                                    </p>
                                    <h3>કોરડ</h3>
                                    <p>
                                        <a class="ingredient" data-id="I0200" href="?id=I0200" sup-id="">
                                            સાકર<sup class="red">૧૦૫૮</sup>
                                        </a>
                                        <a class="ingredient" data-id="I0112" href="?id=I0112" sup-id="">
                                            પતાસા<sup class="red">૧૦૫૯</sup>
                                        </a>
                                        ને 
                                        <a class="ingredient" data-id="I0143" href="?id=I0143" sup-id="">
                                            શીંગ<sup class="red">૧૦૬૦</sup>
                                        </a>
                                        અન્ન<sub class="text-[10px]">૦</sub>
                                        <span class="text-12 invisible lg:hidden inline-box">૦૦૦</span>
                                        <br class="lg:hidden"/>
                                        <a class="ingredient" data-id="I0201" href="?id=I0201" sup-id="">
                                            સાકરિયા<sup class="red">૧૦૬૧</sup>
                                        </a>
                                        ને 
                                        <a class="recipe" data-id="R1062" href="?id=R1062" sup-id="">
                                            ખારીશીંગ<sup class="red">૧૦૬૨</sup>
                                        </a>
                                        , અન્ન<sub class="text-[10px]">૦</sub>
                                        <span class="text-12 inline-box">૨૧૦</span>
                                    </p>
                                    <p>
                                        જમો 
                                        <a class="recipe" data-id="R1063" href="?id=R1063" sup-id="R1063">
                                            રેવડી<sup class="red">૧૦૬૩</sup>
                                        </a>
                                        <a class="recipe" data-id="R1064" href="?id=R1064" sup-id="">
                                            ખારા વટાણા<sup class="red">૧૦૬૪</sup>
                                        </a>
                                        , અન્ન<sub class="text-[10px]">૦</sub>
                                        <span class="text-12 invisible lg:hidden inline-box">૦૦૦</span>
                                        <br class="lg:hidden"/>
                                        <a class="recipe" data-id="R1065" href="?id=R1065" sup-id="">
                                            ખારા ચણા<sup class="red">૧૦૬૫</sup>
                                        </a>
                                        ને 
                                        <a class="recipe" data-id="R1066" href="?id=R1066" sup-id="">
                                            મોળા વટાણા<sup class="red">૧૦૬૬</sup>
                                        </a>
                                        , અન્ન<sub class="text-[10px]">૦</sub>
                                        <span class="text-12 invisible">૦૦૦</span>
                                    </p>
                                    <p>
                                        <a class="recipe" data-id="R1067" href="?id=R1067" sup-id="">
                                            મોળા ચણા<sup class="red">૧૦૬૭</sup>
                                        </a>
                                        <a class="recipe" data-id="R1068" href="?id=R1068" sup-id="">
                                            મસાલા શીંગ<sup class="red">૧૦૬૮</sup>
                                        </a>
                                        , અન્ન<sub class="text-[10px]">૦</sub>
                                        <span class="text-12 invisible lg:hidden inline-box">૦૦૦</span>
                                        <br class="lg:hidden"/>
                                        <a class="recipe" data-id="R1069" href="?id=R1069" sup-id="R1069">
                                            બાફેલી<sup class="red">૧૦૬૯</sup>
                                        </a>
                                        ને 
                                        <a class="recipe" data-id="R1070" href="?id=R1070" sup-id="R1070">
                                            ઓળા શીંગ<sup class="red">૧૦૭૦</sup>
                                        </a>
                                        , અન્ન<sub class="text-[10px]">૦</sub>
                                        <span class="text-12 inline-box">૨૧૧</span>
                                    </p>
                                    <p>
                                        <a class="ingredient" data-id="I0033" href="?id=I0033" sup-id="">
                                            કાજુકળિયા<sup class="red">૧૦૭૧</sup>
                                        </a>
                                        <a class="ingredient" data-id="I0217" href="?id=I0217" sup-id="">
                                            હારડા<sup class="red">૧૦૭૨</sup>
                                        </a>
                                        સારા, અન્ન<sub class="text-[10px]">૦</sub>
                                        <span class="text-12 invisible lg:hidden inline-box">૦૦૦</span>
                                        <br class="lg:hidden"/>
                                        એવું વિધવિધ જમોને પ્યારા, અન્ન<sub class="text-[10px]">૦</sub>
                                        <span class="text-12 invisible">૦૦૦</span>
                                    </p>
                                    <h3>સોડા</h3>
                                    <p>
                                        <a class="recipe" data-id="R1073" href="?id=R1073" sup-id="">
                                            સાદી સોડા<sup class="red">૧૦૭૩</sup>
                                        </a>
                                        <a class="recipe" data-id="R1074" href="?id=R1074" sup-id="">
                                            મસાલા સોડા<sup class="red">૧૦૭૪</sup>
                                        </a>
                                        , અન્ન<sub class="text-[10px]">૦</sub>
                                        <span class="text-12 invisible lg:hidden inline-box">૦૦૦</span>
                                        <br class="lg:hidden"/>
                                        <a class="recipe" data-id="R1075" href="?id=R1075" sup-id="">
                                            લીંબુ સોડા<sup class="red">૧૦૭૫</sup>
                                        </a>
                                        <a class="recipe" data-id="R1076" href="?id=R1076" sup-id="">
                                            મોકટેલ સોડા<sup class="red">૧૦૭૬</sup>
                                        </a>
                                        , અન્ન<sub class="text-[10px]">૦</sub>
                                        <span class="text-12 inline-box">૨૧૨</span>
                                    </p>
                                    <p>
                                        <a class="recipe" data-id="R1077" href="?id=R1077" sup-id="">
                                            જીરા સોડા<sup class="red">૧૦૭૭</sup>
                                        </a>
                                        <a class="recipe" data-id="R1078" href="?id=R1078" sup-id="">
                                            ઓરેંજ સોડા<sup class="red">૧૦૭૮</sup>
                                        </a>
                                        , અન્ન<sub class="text-[10px]">૦</sub>
                                        <span class="text-12 invisible lg:hidden inline-box">૦૦૦</span>
                                        <br class="lg:hidden"/>
                                        <a class="recipe" data-id="R1079" href="?id=R1079" sup-id="">
                                            લીચી લેમન<sup class="red">૧૦૭૯</sup>
                                        </a>
                                        <a class="recipe" data-id="R1080" href="?id=R1080" sup-id="">
                                            ફુદીના સોડા<sup class="red">૧૦૮૦</sup>
                                        </a>
                                        , અન્ન<sub class="text-[10px]">૦</sub>
                                        <span class="text-12 invisible">૦૦૦</span>
                                    </p>
                                    <p>
                                        <a class="recipe" data-id="R1081" href="?id=R1081" sup-id="">
                                            જીંજર સોડા<sup class="red">૧૦૮૧</sup>
                                        </a>
                                        <a class="recipe" data-id="R1082" href="?id=R1082" sup-id="">
                                            મોસંબી સોડા<sup class="red">૧૦૮૨</sup>
                                        </a>
                                        , અન્ન<sub class="text-[10px]">૦</sub>
                                        <span class="text-12 invisible lg:hidden inline-box">૦૦૦</span>
                                        <br class="lg:hidden"/>
                                        પીઓ 
                                        <a class="recipe" data-id="R1083" href="?id=R1083" sup-id="">
                                            ઘાટા-મેંગો સોડા<sup class="red">૧૦૮૩</sup>
                                        </a>
                                        , અન્ન<sub class="text-[10px]">૦</sub>
                                        <span class="text-12 inline-box">૨૧૩</span>
                                    </p>
                                    <p>
                                        <a class="recipe" data-id="R1084" href="?id=R1084" sup-id="">
                                            ઘાટા-પાઇનેપલ સોડા<sup class="red">૧૦૮૪</sup>
                                        </a>
                                        , અન્ન<sub class="text-[10px]">૦</sub>
                                        <span class="text-12 invisible lg:hidden inline-box">૦૦૦</span>
                                        <br class="lg:hidden"/>
                                        પીઓ એ આદિ બહુ સોડા, અન્ન<sub class="text-[10px]">૦</sub>
                                        <span class="text-12 invisible">૦૦૦</span>
                                    </p>
                                    <h3>મુખવાસ</h3>
                                    <p>
                                        જમો મુખવાસ અનેક દયાળ, અન્ન<sub class="text-[10px]">૦</sub>
                                        <span class="text-12 invisible lg:hidden inline-box">૦૦૦</span>
                                        <br class="lg:hidden"/>
                                        <a class="ingredient" data-id="I0214" href="?id=I0214" sup-id="">
                                            સોપારી<sup class="red">૧૦૮૫</sup>
                                        </a>
                                        તથા 
                                        <a class="ingredient" data-id="I0106" href="?id=I0106" sup-id="">
                                            ધાણાદાળ<sup class="red">૧૦૮૬</sup>
                                        </a>
                                        , અન્ન<sub class="text-[10px]">૦</sub>
                                        <span class="text-12 inline-box">૨૧૪</span>
                                    </p>
                                    <p>
                                        ગુલકંદ કાથો ચૂનો સારા, અન્ન<sub class="text-[10px]">૦</sub>
                                        <span class="text-12 invisible lg:hidden inline-box">૦૦૦</span>
                                        <br class="lg:hidden"/>
                                        સલ્લી ટૂટીફ્રૂટી 
                                        <a class="ingredient" data-id="I0252" href="?id=I0252" sup-id="R1087">
                                            પાન<sup class="red">૧૦૮૭ </sup>
                                        </a>
                                        પ્યારા, અન્ન<sub class="text-[10px]">૦</sub>
                                        <span class="text-12 invisible">૦૦૦</span>
                                    </p>
                                    <p>
                                        <a class="ingredient" data-id="I0248" href="?id=I0248" sup-id="R1088">
                                            લીલી<sup class="red">૧૦૮૮</sup>
                                        </a>
                                        <a class="ingredient" data-id="I0185" href="?id=I0185" sup-id="R1089">
                                            સૂકી<sup class="red">૧૦૮૯</sup>
                                        </a>
                                        છે વરિયાળી, અન્ન<sub class="text-[10px]">૦</sub>
                                        <span class="text-12 invisible lg:hidden inline-box">૦૦૦</span>
                                        <br class="lg:hidden"/>
                                        આ 
                                        <a class="recipe" data-id="R1090" href="?id=R1090" sup-id="">
                                            બદામ મસાલાવાળી<sup class="red">૧૦૯૦</sup>
                                        </a>
                                        , અન્ન<sub class="text-[10px]">૦</sub>
                                        <span class="text-12 inline-box">૨૧૫</span>
                                    </p>
                                    <p>
                                        <a class="ingredient" data-id="I0168" href="?id=I0168" sup-id="">
                                            લવિંગ<sup class="red">૧૦૯૧</sup>
                                        </a>
                                        <a class="recipe" data-id="R1092" href="?id=R1092" sup-id="R1092">
                                            ખારેક<sup class="red">૧૦૯૨</sup>
                                        </a>
                                        <a class="ingredient" data-id="I0251" href="?id=I0251" sup-id="">
                                            એલચી દાણા<sup class="red">૧૦૯૩</sup>
                                        </a>
                                        , અન્ન<sub class="text-[10px]">૦</sub>
                                        <span class="text-12 invisible lg:hidden inline-box">૦૦૦</span>
                                        <br class="lg:hidden"/>
                                        <a class="ingredient" data-id="I0142" href="?id=I0142" sup-id="">
                                            મગજતરી<sup class="red">૧૦૯૪</sup>
                                        </a>
                                        ને 
                                        <a class="ingredient" data-id="I0205" href="?id=I0205" sup-id="">
                                            સુવાદાણા<sup class="red">૧૦૯૫</sup>
                                        </a>
                                        , અન્ન<sub class="text-[10px]">૦</sub>
                                        <span class="text-12 invisible">૦૦૦</span>
                                    </p>
                                    <p>
                                        કેરી ગોટલી છે બહુ સારી, અન્ન<sub class="text-[10px]">૦</sub>
                                        <span class="text-12 invisible lg:hidden inline-box">૦૦૦</span>
                                        <br class="lg:hidden"/>
                                        જમો 
                                        <a class="recipe" data-id="R1096" href="?id=R1096" sup-id="R1096">
                                            શેકેલી<sup class="red">૧૦૯૬</sup>
                                        </a>
                                        <a class="recipe" data-id="R1097" href="?id=R1097" sup-id="R1097">
                                            તળેલી<sup class="red">૧૦૯૭</sup>
                                        </a>
                                        પ્યારી, અન્ન<sub class="text-[10px]">૦</sub>
                                        <span class="text-12 inline-box">૨૧૬</span>
                                    </p>
                                    <p>
                                        <a class="ingredient" data-id="I0016" href="?id=I0016" sup-id="">
                                            ઇજમેટ ફૂલ<sup class="red">૧૦૯૮</sup>
                                        </a>
                                        <a class="recipe" data-id="R1099" href="?id=R1099" sup-id="">
                                            ગળ્યાં આંબળાં<sup class="red">૧૦૯૯</sup>
                                        </a>
                                        , અન્ન<sub class="text-[10px]">૦</sub>
                                        <span class="text-12 invisible lg:hidden inline-box">૦૦૦</span>
                                        <br class="lg:hidden"/>
                                        <a class="ingredient" data-id="I0006" href="?id=I0006" sup-id="">
                                            અળસી<sup class="red">૧૧૦૦</sup>
                                        </a>
                                        ને 
                                        <a class="recipe" data-id="R1101" href="?id=R1101" sup-id="">
                                            ખારાં આંબળાં<sup class="red">૧૧૦૧</sup>
                                        </a>
                                        , અન્ન<sub class="text-[10px]">૦</sub>
                                        <span class="text-12 invisible">૦૦૦</span>
                                    </p>
                                    <p>
                                        <a class="ingredient" data-id="I0025" href="?id=I0025" sup-id="">
                                            કમળકાકડી<sup class="red">૧૧૦૨</sup>
                                        </a>
                                        છે 
                                        <a class="ingredient" data-id="I0099" href="?id=I0099" sup-id="">
                                            તલ<sup class="red">૧૧૦૩</sup>
                                        </a>
                                        વાલા, અન્ન<sub class="text-[10px]">૦</sub>
                                        <span class="text-12 invisible lg:hidden inline-box">૦૦૦</span>
                                        <br class="lg:hidden"/>
                                        જમો 
                                        <a class="recipe" data-id="R1104" href="?id=R1104" sup-id="">
                                            કાજુ મસાલાવાળા<sup class="red">૧૧૦૪</sup>
                                        </a>
                                        , અન્ન<sub class="text-[10px]">૦</sub>
                                        <span class="text-12 inline-box">૨૧૭</span>
                                    </p>
                                    <p>
                                        <a class="recipe" data-id="R1105" href="?id=R1105" sup-id="">
                                            જીરાગોળી<sup class="red">૧૧૦૫</sup>
                                        </a>
                                        <a class="recipe" data-id="R1106" href="?id=R1106" sup-id="">
                                            દ્રાક્ષાદિવટી<sup class="red">૧૧૦૬</sup>
                                        </a>
                                        , અન્ન<sub class="text-[10px]">૦</sub>
                                        <span class="text-12 invisible lg:hidden inline-box">૦૦૦</span>
                                        <br class="lg:hidden"/>
                                        <a class="ingredient" data-id="I0093" href="?id=I0093" sup-id="">
                                            ડ્રાય ક્રેનબેરી<sup class="red">૧૧૦૭</sup>
                                        </a>
                                        <a class="recipe" data-id="R1108" href="?id=R1108" sup-id="">
                                            અદરકવટી<sup class="red">૧૧૦૮</sup>
                                        </a>
                                        , અન્ન<sub class="text-[10px]">૦</sub>
                                        <span class="text-12 invisible">૦૦૦</span>
                                    </p>
                                    <p>
                                        જમો 
                                        <a class="recipe" data-id="R1109" href="?id=R1109" sup-id="">
                                            હાજમાગોળી<sup class="red">૧૧૦૯</sup>
                                        </a>
                                        મુજ હાથ, અન્ન<sub class="text-[10px]">૦</sub>
                                        <span class="text-12 invisible lg:hidden inline-box">૦૦૦</span>
                                        <br class="lg:hidden"/>
                                        વળી 
                                        <a class="recipe" data-id="R1110" href="?id=R1110" sup-id="">
                                            મસાલા ગોટલી<sup class="red">૧૧૧૦</sup>
                                        </a>
                                        નાથ, અન્ન<sub class="text-[10px]">૦</sub>
                                        <span class="text-12 inline-box">૨૧૮</span>
                                    </p>
                                    <p>
                                        જમો 
                                        <a class="ingredient" data-id="I0003" href="?id=I0003" sup-id="">
                                            અજમો<sup class="red">૧૧૧૧</sup>
                                        </a>
                                        પાચનકારી, અન્ન<sub class="text-[10px]">૦</sub>
                                        <span class="text-12 invisible lg:hidden inline-box">૦૦૦</span>
                                        <br class="lg:hidden"/>
                                        જમ્યા મુખવાસ અનેક પ્રકારી, અન્ન<sub class="text-[10px]">૦</sub>
                                        <span class="text-12 invisible">૦૦૦</span>
                                    </p>
                                </div>
          <h4>
                                    <p>સંતો-ભક્તો કરે દર્શન, સંતપ્રિય શ્રીહરિજી </p>
                                </h4>
                                <h4>
                                    <p>આવ્યા પૂજા કરવા જન, સંતપ્રિય શ્રીહરિજી </p>
                                </h4>
                                <p>
                                    બહુ ભાવે પૂજ્યા મહારાજ, સંત₀
                                    
                                    પછી પૂજ્યો સંતસમાજ, સંત₀
                                    <span class="space hidden">૨૨૦</span>
                                </p>
                                <p>
                                    સહુએ પ્રાર્થના કરી હે નાથ, સંત₀
                                    
                                    પીરસો સંતોને તમારે હાથ, સંત₀
                                    ૨૨૦
                                </p>
                                <p>
                                    તમે સર્વોપરી ભગવંત, સંત₀
                                    
                                    તમને અતિ વ્હાલા છે સંત₀, સંત₀
                                    <span class="space hidden">૨૨૧</span>
                                </p>
                                <p>
                                    તેને આગ્રહ કરીને જમાડો, સંત₀
                                    
                                    અતિ આનંદ સહુને પમાડો, સંત₀
                                    ૨૨૧
                                </p>
                                <p>
                                    રાજી કરીને સંતસમાજ, સંત₀
                                    
                                    હવે આરામ કરો મહારાજ, સંત₀
                                    <span class="space hidden">૨૨૨</span>
                                </p>
                                <p>
                                    રૂડો ઢોલિયો ઢાળ્યો સુરીતે, સંત₀
                                    
                                    તેને મુજ દિલ જાણી પ્રીતે, સંત₀
                                    ૨૨૨
                                </p>
                                <p>
                                    એમાં પોઢોને મારા માવ, સંત₀
                                    
                                    પ્રેમે ચાંપું તમારા પાવ, સંત₀
                                    <span class="space hidden">૨૨૩</span>
                                </p>
                                <p>
                                    બ્રહ્મચારી ઢોળે પવન, સંત₀
                                    
                                    પ્રેમે પોઢ્યા પ્રાણજીવન, સંત₀
                                    ૨૨૩
                                </p>
                                <p>
                                    ગાયો અન્નકૂટ ‘જ્ઞાનજીવન’, સંત₀
                                    
                                    કોઈ ગાશે સુણશે જન, સંત₀
                                    <span class="space hidden">૨૨૪</span>
                                </p>
                                <p>
                                    તેની ઉપર સંતસમાજ, સંત₀
                                    
                                    બહુ રાજી થશે મહારાજ, સંત₀
                                    ૨૨૪
                                </p>
                                <p>
                                    તેને હરિમાં વધશે પ્રીત, સંત₀
                                    
                                    વળી જગમાં થાશે જીત, સંત₀
                                    <span class="space hidden">૨૨૫</span>
                                </p>
                                <p>
                                    તેની સર્વે વાસના ટળશે, સંત₀
                                    
                                    વાસ અક્ષરધામમાં મળશે, સંત₀
                                    ૨૨૫
                                </p>
                                <h4>
                                    ઇતિ સર્વોપરી શ્રીસ્વામિનારાયણ ચરણકમળ સેવક<br>સ્વામી જ્ઞાનજીવનદાસ વિરચિત અન્નકૂટ થાળ સમાપ્ત:</br>
                                </h4>
          </div>`;
